import ReceiverPicker from './ReceiverPicker';   // [RCV_PICKER_V1] 카테고리 → 그룹 → 수신자
import SenderSelect from './SenderSelect';   // [SMS_SENDER_PICK_V1] 발신번호 드롭다운
import axios from 'axios';
import { commaView } from "../utils/number";
import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import AddressMapOverlay from "./AddressMapOverlay"; // ★ 지도확인 오버레이
import BuildingInfoOverlay from "./BuildingInfoOverlay"; // ★ 건물정보 오버레이
import { updateContractYn, createFullSnapshot, getSnapshotList, getSnapshotDetail } from "../api/propertyApi";
import { authFetch } from "../api/authFetch";
import "./EstateEditor.css";
import PhotoGallery from "./PhotoGallery"; // 상단 임포트 추가
// ★ 추가: 신규 생성할 모달과 API 임포트
import ReceiverManageModal from "./ReceiverManageModal";
import { smsReceiverApi } from "../api/smsApi";
// ◆gemini테스트코드 2026.01.01 ◆ import DataChecker from "./DataChecker"; // ◆gemini테스트코드 2026.01.01 ◆

// 날짜/시간 포맷: YYYY-MM-DD HH:MM:SS
function formatDateTime(v) {
  if (!v) return "";
  // T가 포함된 ISO 문자열인 경우 시차 보정을 위해 Date 객체화 후 재포맷 권장
  const d = new Date(v);
  if (isNaN(d.getTime())) return v;

  const pad = (n) => (n < 10 ? "0" + n : n);

  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());

  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}

// ㎡ ↔ 평 변환
const SQM_PER_PYEONG = 3.305785;
const m2ToPyeong = (v) => {
  const n = parseFloat(v);
  if (!Number.isFinite(n)) return "";
  return (n / SQM_PER_PYEONG).toFixed(2);
};
const pyeongToM2 = (v) => {
  const n = parseFloat(v);
  if (!Number.isFinite(n)) return "";
  return (n * SQM_PER_PYEONG).toFixed(2);
};

//  ===== 물건관리  =====
// ===== GRADE_COLORS: 등급별 색 (PropertyList.js 와 동일하게 유지) =====
const GRADE_COLORS = {
  manage:            "#7cb342",  // 지속관리 — 리스트는 연두배경(#c8f5a8), 테두리용으로 진하게
  prohibit:          "#ff4d4f",  // 계약금지 — 빨강
  attentive:         "#fa8c16",  // 계약유의 — 주황
  "recommend-price": "#1677ff",  // 가성비  — 파랑
  recommend:         "#389e0d",  // 추천    — 초록
  nonrecommend:      "#bfbfbf",  // 비추천  — 연회색
};

// 색을 흰색과 섞어 연하게 만드는 함수 (카드 배경용)
// hex="#ff4d4f", ratio=0.92 → 아주 연한 분홍
const lighten = (hex, ratio) => {
  const h = String(hex).replace("#", "").slice(0, 6);
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const mix = (c) => Math.round(c + (255 - c) * ratio);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
};

const GRADE_CONDITION_OPTIONS = [
  { value: "", label: "선택" },
  { value: "manage", label: "지속관리" },
  { value: "recommend", label: "추천" },
  { value: "recommend-price", label: "가성비" },
  { value: "attentive", label: "계약유의" },
  { value: "nonrecommend", label: "비추천" },
  { value: "prohibit", label: "계약금지" },
];

// ===== 거래유형(다중선택) 라벨 매핑 =====
const RENT_TYPE_MULTI_LABELS = {
  rent_type_4deal: "매매",
  rent_type_1year: "전세",
  rent_type_2month: "월세",
  rent_type_3short: "단기",
  rent_type_5sale: "분양",
  rent_type_6auction: "경매",
};

// ===== 단일 선택 드롭다운 옵션들 =====

// 물건유형
const ESTATE_TYPE_OPTIONS = [
  { value: "", label: "물건유형" },
  { value: "residence", label: "주거용" },
  { value: "profit", label: "수익성" },
  { value: "business", label: "업무용" },
  { value: "commerce", label: "상업용" },
];

// 건물용도
const BLD_TYPE_OPTIONS = [
  { value: "", label: "건물용도" },
  { value: "business-bld", label: "업무용빌딩" },
  { value: "e-apt", label: "오피스텔" },
  { value: "etc", label: "기타" },
  { value: "farm-house", label: "농가주택" },
  { value: "gosiwon", label: "고시원건물" },
  { value: "house-site", label: "택지" },
  { value: "land", label: "토지" },
  { value: "metro-house", label: "도시형주택" },
  { value: "multi-house", label: "다세대주택" },
  { value: "multi-household", label: "다가구주택" },
  { value: "single-room-bld", label: "원룸건물" },
  { value: "pension", label: "펜션" },
  { value: "row-house", label: "연립주택" },
  { value: "sale-shop", label: "분양상가" },
  { value: "s-home-bld", label: "단독주택" },
  { value: "shop", label: "상가건물" },
  { value: "shop-house", label: "상가주택" },
  { value: "single-room", label: "원룸" },
  // ── DB에 이미 존재하던 값들 추가 (2026.08.12) ──
  { value: "villa", label: "빌라" },
  { value: "office", label: "사무실" },
  { value: "apt", label: "아파트" },
  { value: "multi-purpose", label: "다가구" },
  { value: "single-room-owner", label: "원룸(주인세대)" },
];

// 층분할 / 층대체
const FLOOR_TYPE1_OPTIONS = [
  { value: "", label: "층분할여부" },
  { value: "part", label: "층일부" },
  { value: "whole", label: "층전체" },
];

// 룸형태 (DB 컬럼 bld_structure) [BLD_STRUCT_V1]
const BLD_STRUCTURE_OPTIONS = [
  { value: "", label: "룸형태" },
  { value: "open", label: "오픈형" },
  { value: "separate", label: "분리형" },
  { value: "multi", label: "복층형" },
];

const FLOOR_TYPE2_OPTIONS = [
  { value: "", label: "층대체" },
  { value: "top", label: "옥탑" },
  { value: "bottom", label: "바닥층" },
  { value: "parking", label: "주차층" },
];

// 방향
const ESTATE_DIRECTION_OPTIONS = [
  { value: "", label: "방향" },
  { value: "e", label: "동향" },
  { value: "w", label: "서향" },
  { value: "s", label: "남향" },
  { value: "n", label: "북향" },
  { value: "se", label: "남동향" },
  { value: "sw", label: "남서향" },
  { value: "ne", label: "북동향" },
  { value: "nw", label: "북서향" },
];

// 용도지역
const USE_DISTRICT_OPTIONS = [
  { value: "", label: "용도지역" },
  { value: "ud11", label: "제1종전용주거지역" },
  { value: "ud12", label: "제2종전용주거지역" },
  { value: "ud13", label: "제1종일반주거지역" },
  { value: "ud14", label: "제2종일반주거지역" },
  { value: "ud15", label: "제3종일반주거지역" },
  { value: "ud21", label: "준주거지역" },
  { value: "ud22", label: "중심상업지역" },
  { value: "ud23", label: "일반상업지역" },
  { value: "ud24", label: "근린상업지역" },
  { value: "ud25", label: "유통상업지역" },
  { value: "ud26", label: "전용공업지역" },
  { value: "ud27", label: "준공업지역" },
  { value: "ud31", label: "전용공업지역" },
  { value: "ud32", label: "일반공업지역" },
  { value: "ud33", label: "보전녹지지역" },
  { value: "ud34", label: "생산녹지지역" },
  { value: "ud35", label: "자연녹지지역" },
  { value: "ud36", label: "보전관리지역" },
  { value: "ud37", label: "생산관리지역" },
  { value: "ud38", label: "계획관리지역" },
];

// 난방
const HEAT_CONDITION_OPTIONS = [
  { value: "", label: "난방방식" },
  { value: "private-heat", label: "개별난방" },
  { value: "center", label: "중앙난방" },
  { value: "floor", label: "층난방" },
];

// 냉방
const COLD_CONDITION_OPTIONS = [
  { value: "", label: "냉방방식" },
  { value: "private", label: "개별냉방" },
  { value: "center", label: "중앙냉방" },
];

// 임대유형
const SALE_TYPE_RENT_OPTIONS = [
  { value: "", label: "현재 임대 유형" },
  { value: "y", label: "전세" },
  { value: "m", label: "월세" },
  { value: "s", label: "단기" },
];

const SELECT_OPTIONS_MAP = {
  grade_condition: GRADE_CONDITION_OPTIONS,
  estate_type: ESTATE_TYPE_OPTIONS,
  bld_type: BLD_TYPE_OPTIONS,
  bld_structure: BLD_STRUCTURE_OPTIONS,
  floor_type1: FLOOR_TYPE1_OPTIONS,
  floor_type2: FLOOR_TYPE2_OPTIONS,
  estate_direction: ESTATE_DIRECTION_OPTIONS,
  use_district: USE_DISTRICT_OPTIONS,
  heat_condition: HEAT_CONDITION_OPTIONS,
  cold_condition: COLD_CONDITION_OPTIONS,
  sale_type_rent: SALE_TYPE_RENT_OPTIONS,
};

const getSelectOptions = (fieldName) =>
  SELECT_OPTIONS_MAP[fieldName] || [];
 

// 공통 필드 정의 (전체 필드 포함)
const FIELD_DEFS = {
  grade_condition: { label: "물건관리", state: "form", type: "hidden" },
  // 거래유형 (다중선택, 토글버튼)
  rent_type_4deal:   { label: "매매", state: "detail", type: "rent-toggle" },
  rent_type_1year:   { label: "전세", state: "detail", type: "rent-toggle" },
  rent_type_2month:  { label: "월세", state: "detail", type: "rent-toggle" },
  rent_type_3short:  { label: "단기", state: "detail", type: "rent-toggle" },
  rent_type_5sale:   { label: "분양", state: "detail", type: "rent-toggle" },
  rent_type_6auction:{ label: "경매", state: "detail", type: "rent-toggle" },

  /* ───────────── 기본정보 (basic) ───────────── */

  contract_yn: { label: "거래완료", state: "form", type: "rent-toggle" },
  use_yn: { label: "노출중", state: "form", type: "rent-toggle" },
  estate_name: { label: "건물명", state: "basic", type: "text" },
  shop_name: { label: "상호명", state: "basic", type: "text" },
  estate_type: { label: "물건유형", state: "basic", type: "select" },
  bld_type: { label: "건물용도", state: "basic", type: "select" },
  bld_structure: { label: "룸형태", state: "basic", type: "select" },
  bld_type_etc: { label: "상세용도", state: "basic", type: "text" },

  estate_dong: { label: "해당동", state: "basic", type: "text" },
  estate_ho: { label: "해당호수", state: "basic", type: "text" },

  floor: { label: "해당층", state: "basic", type: "number" },
  floor_type1: { label: "층분할여부", state: "basic", type: "select" },
  floor_type2: { label: "층대체", state: "basic", type: "select" },
  floor_etc: { label: "호수대체", state: "basic", type: "text" },

  estate_direction: { label: "방향", state: "basic", type: "select" },

  // sido: { label: "시도", state: "basic", type: "text" },
  // gungu: { label: "시군구", state: "basic", type: "text" },
  // dong: { label: "법정동", state: "basic", type: "text" },

  jibunAddress: { label: "지번주소", state: "basic", type: "text" },
  roadAddress: { label: "도로명주소", state: "basic", type: "text" },
  detailAddress: { label: "상세주소", state: "basic", type: "text" },

  /* ───────────── 거래 및 금액 (detail) ───────────── */

  price_sale: { label: "매매가", state: "detail", type: "number" },
  price_bunyang: { label: "분양가", state: "detail", type: "number" },
  price_deposit: { label: "단기예치금", state: "detail", type: "number" },
  price_mgr_yn: { label: "관리비 별도", state: "detail", type: "rent-toggle" },
  price_per_scale: { label: "평당가", state: "detail", type: "number" },
  price_posible: { label: "협의가", state: "detail", type: "text" },
  price_investment: { label: "실투자금", state: "detail", type: "number" },
  price_premium: { label: "권리금", state: "detail", type: "number" },
  price_sum: { label: "권리+보증금 합계", state: "detail", type: "number" },
  price_per_household: { label: "세대당 관리비", state: "detail", type: "number" },
  mortgage: { label: "근저당", state: "detail", type: "number" },

  fee_jeonse: { label: "전세보증금", state: "detail", type: "number" }, // ★ 새 컬럼 추가
  fee_year: { label: "월세보증금", state: "detail", type: "number" }, // ★ 라벨 수정
  fee_month: { label: "월세", state: "detail", type: "number" },
  f_price_total_mgr: { label: "입금관리비 합계", state: "detail", type: "number" },


  // 관리비 구성 (Y/N)
  price_mgr_item_basic: { label: "기본관리비 포함", state: "detail", type: "rent-toggle" },
  price_mgr_item_water: { label: "수도요금 포함", state: "detail", type: "rent-toggle" },
  price_mgr_item_internet: { label: "인터넷요금 포함", state: "detail", type: "rent-toggle" },
  price_mgr_item_online: { label: "유선요금 포함", state: "detail", type: "rent-toggle" },
  price_mgr_item_heat: { label: "난방요금 포함", state: "detail", type: "rent-toggle" },
  price_mgr_item_elec: { label: "전기요금 포함", state: "detail", type: "rent-toggle" },

  /* ───────────── 면적 (detail) ───────────── */

  exclusive_scale: { label: "전용면적㎡", state: "detail", type: "number" },
  exclusive_scale_square: { label: "전용평수", state: "detail", type: "number" },

  used_scale: { label: "실면적㎡", state: "detail", type: "number" },
  used_scale_square: { label: "실평수", state: "detail", type: "number" },

  common_area_m2: { label: "공용면적㎡", state: "detail", type: "number" },
  common_area_square: { label: "공용평수", state: "detail", type: "number" },

  site_amount: { label: "대지면적㎡", state: "detail", type: "number" },
  site_amount_square: { label: "대지평수", state: "detail", type: "number" },

  totArea: { label: "연면적㎡", state: "detail", type: "number" },
  totArea_square: { label: "연면적평수", state: "detail", type: "number" },

  site_scale: { label: "지분면적㎡", state: "detail", type: "number" },
  site_scale_square: { label: "지분평수", state: "detail", type: "number" },
  use_district: { label: "용도지역 선택", state: "detail", type: "select" },

  /* ───────────── 구성/세대/방/욕실 (detail) ───────────── */

  room_cnt: { label: "룸 수", state: "detail", type: "number" },
  bath_cnt: { label: "욕실 수", state: "detail", type: "number" },

  owner_household: { label: "주인세대 유무", state: "detail", type: "rent-toggle" },
  owner_room: { label: "주인세대 룸 수", state: "detail", type: "number" },
  owner_bath: { label: "주인세대 욕실 수", state: "detail", type: "number" },

  rent_household_cnt: { label: "전체 임대 가구 수", state: "detail", type: "number" },

  bld_scale_under: { label: "건물규모(지하)", state: "detail", type: "number" },
  bld_scale: { label: "건물규모(지상)", state: "detail", type: "number" },

  /* ───────────── 교통 (detail) ───────────── */

  station: { label: "이용 가능역", state: "detail", type: "text" },
  station_distance: { label: "역 이동 시간", state: "detail", type: "number" },
  station_transport: { label: "역 이동 수단", state: "detail", type: "text" },

  /* ───────────── 주차/준공/기타 (detail) ───────────── */

  parking_cnt: { label: "주차대수", state: "detail", type: "number" },
  parking_fee: { label: "주차요금", state: "detail", type: "number" },

  completion_year: { label: "준공일", state: "detail", type: "date" },

  // grade_condition: { label: "상태등급", state: "detail", type: "text" },

  /* ───────────── 임대/입주 서브옵션 (detail) ───────────── */

  sale_type_sub_living: { label: "입주가능", state: "detail", type: "rent-toggle" },
  sale_type_sub_rent: { label: "임대승계", state: "detail", type: "rent-toggle" },
  sale_type_rent: { label: "임대형태(y/m/s)", state: "detail", type: "rent-toggle" },
  sale_type_rent_year: { label: "현재 거주 보증금", state: "detail", type: "number" },
  sale_type_rent_month: { label: "현재 거주 월세", state: "detail", type: "number" },

  /* ───────────── 가전 (detail) ───────────── */
  elec_condition_refrigerator: { label: "냉장고", state: "detail", type: "rent-toggle" },
  elec_condition_washer: { label: "세탁기", state: "detail", type: "rent-toggle" },
  elec_condition_air_conditioner: { label: "에어컨", state: "detail", type: "rent-toggle" },
  elec_condition_cook: { label: "인덕션", state: "detail", type: "rent-toggle" },
  elec_condition_microwave: { label: "전자렌지", state: "detail", type: "rent-toggle" },
  elec_condition_tv: { label: "TV", state: "detail", type: "rent-toggle" },


  /* ───────────── 시설/상태 (detail) ───────────── */

  living_condition_ev: { label: "승강기", state: "detail", type: "rent-toggle" },
  living_condition_terrace: { label: "테라스/베란다", state: "detail", type: "rent-toggle" },
  internal_condition_interior: { label: "인테리어상태", state: "detail", type: "rent-toggle" },
  internal_condition_water: { label: "수도시설", state: "detail", type: "rent-toggle" },
  internal_condition_city_gas: { label: "도시가스", state: "detail", type: "rent-toggle" },
  bath_division: { label: "화장실 남녀구분", state: "detail", type: "rent-toggle" },
  bath_inside: { label: "화장실 내부", state: "detail", type: "rent-toggle" },
  external_condition_exsign: { label: "옥외광고", state: "detail", type: "rent-toggle" },
  heat_condition: { label: "난방방식", state: "detail", type: "select" },
  cold_condition: { label: "냉방시설", state: "detail", type: "select" },
  
  /* ───────────── 메모 (form/meta) ───────────── */

  register_memo: { label: "등록자 메모 (비노출)", state: "form", type: "text" },
  // resident_memo: { label: "거주메모", state: "form", type: "text" },


  /* ───────────── 담당자 및 연락처 (form) ───────────── */

  contact_name1: { label: "담당자1 이름", state: "form", type: "text" },
  contact_phone1: { label: "담당자1 전화", state: "form", type: "text" },
  contact_name2: { label: "담당자2 이름", state: "form", type: "text" },
  contact_phone2: { label: "담당자2 전화", state: "form", type: "text" },
  contact_name3: { label: "담당자3 이름", state: "form", type: "text" },
  contact_phone3: { label: "담당자3 전화", state: "form", type: "text" },
  contact_name4: { label: "담당자4 이름", state: "form", type: "text" },
  contact_phone4: { label: "담당자4 전화", state: "form", type: "text" },
  contact_name5: { label: "담당자5 이름", state: "form", type: "text" },
  contact_phone5: { label: "담당자5 전화", state: "form", type: "text" },

  /* ───────────── 등록/수정 정보 (readonly) ───────────── */

  estate_no: { label: "매물번호", state: "readonly", type: "readonly" },
  estate_id: { label: "매물ID", state: "readonly", type: "readonly" },

  register_date: { label: "등록일시", state: "readonly", type: "readonly" },
  update_date: { label: "수정일시", state: "readonly", type: "readonly" },

  branch_id: { label: "지점ID", state: "readonly", type: "readonly" },
  register_id: { label: "등록자ID", state: "readonly", type: "readonly" },
  update_id: { label: "수정자ID", state: "readonly", type: "readonly" },

  // 필요하면 여기 계속 추가 (owner_household, owner_room, owner_bath 등)
};

// 레이아웃 설정: 이제 탭 구분 없이 전부 "물건정보(info)" 안에서만 사용. 위치 조정은 다 여기서 끝난다:
const FIELD_LAYOUT = [
  // MERGED_LAYOUT_V2 — 섹션 통합본 (2026.08.12)
  // ※ 항목 표시여부는 isFieldVisible() 이 결정. 여기는 소속·순서만 담당.

  // 관리등급 (canEdit=false 면 4357줄 filter 가 통째로 제거)
  {
    id: "info-grade",
    tab: "info",
    title: "물건관리 등급",
    columns: 1,
    fields: ["_grade_condition_group"],
  },

  // ① 건물 + 호실 통합
  {
    id: "info-building-base",
    tab: "info",
    title: "🏢 건물 · 호실",
    columns: 2,
    fields: [
      "_status_toggle_group",
      "estate_name",
      "use_district", "completion_year",
      "estate_type", "bld_type",
      "bld_structure",
      "bld_type_etc", "bld_scale", "bld_scale_under",
      "estate_dong", "estate_ho",
      "floor", "floor_etc",
      "floor_type2", "floor_type1",
      "shop_name", "estate_direction",
      "room_cnt", "bath_cnt",   // ROOM_LABEL_V2: 구성(룸/욕실) 이동
    ],
  },

  // ② 거래유형 + 금액 + 매매시 입주가능 통합
  {
    id: "info-price",
    tab: "info",
    title: "💰 거래 · 금액",
    columns: 2,
    fields: [
      "_rent_type_toggle_group",
      "price_sale",
      "price_bunyang",
      "price_deposit",
      "price_per_scale",
      "price_investment",
      "fee_jeonse",
      "fee_year",
      "fee_month",
      "price_posible",
      "price_premium",
      "price_sum",
      "mortgage",
      "parking_cnt", "parking_fee",
      "price_mgr_yn", "price_per_household",
      "_mgr_items_group",
      "_sale_type_sub_group", "_sale_type_rent_group",
      "sale_type_rent_year", "sale_type_rent_month",
    ],
  },

  // ③ 구성 + 면적 통합
  {
    id: "info-area",
    tab: "info",
    title: "📐 면적 · 구성",
    columns: 2,
    fields: [
      "owner_household",
      "owner_room",
      "owner_bath",
      "rent_household_cnt",
      "exclusive_scale",
      "exclusive_scale_square",
      "used_scale",
      "used_scale_square",
      "common_area_m2",
      "common_area_square",
      "site_amount",
      "site_amount_square",
      "site_scale",
      "site_scale_square",
      "totArea",
    ],
  },

  // ④ 교통 + 냉난방/시설 통합
  {
    id: "info-traffic",
    tab: "info",
    title: "🚇 교통 · 시설",
    columns: 2,
    fields: [
      "station", "station_distance", "station_transport",
      "heat_condition",
      "cold_condition",
      "_facility_elec_group",
      "_facility_group",
    ],
  },

  // 메모 (canEdit=false 면 제거)
  {
    id: "info-memo",
    tab: "info",
    title: "메모",
    columns: 1,
    fields: ["register_memo"],
  },

  // {
  //   id: "info-contact",
  //   tab: "info",
  //   title: "연락처",
  //   columns: 2,
  //   fields: [
  //     "contact_name1",
  //     "contact_phone1",
  //     "contact_name2",
  //     "contact_phone2",
  //     "contact_name3",
  //     "contact_phone3",
  //     "contact_name4",
  //     "contact_phone4",
  //     "contact_name5",
  //     "contact_phone5",
  //   ],
  // },
];


/**
 * 매물 수정/복사/거래완료용 오버레이 에디터
 *
 * props:
 * - open: boolean          // 열림 여부
 * - mode: "edit" | "copy" | "contract"
 * - estate: object | null  // 선택된 매물(estate_no 포함)
 * - onClose(): void        // 닫기 콜백
 * - onSaved(result): void  // 저장 후 콜백(리스트 리로드 등)
 */

// [2] 수신자 그룹화 함수 추출
const getGroupedList = (list) => {
  if (!list || !Array.isArray(list)) return {};
  return list.reduce((acc, curr) => {
    const group = curr.group_name || "미지정";
    if (!acc[group]) acc[group] = [];
    acc[group].push(curr);
    return acc;
  }, {});
};

// [3] 전송 텍스트 생성 헬퍼 함수 (추가)
const generateSmsText = (options, data) => {
  const { basic, detail, estate, estateNo } = data;
  let parts = [];
  // 1. 기본정보 (건물명 우선순위: 건물명 -> 건물용도 -> 상세용도)
  if (options.estateName) {
    const name = (basic?.estate_name || estate?.estate_name || "").trim();
    const bldType = (basic?.bld_type || estate?.bld_type || "").trim();
    const bldEtc = (basic?.bld_type_etc || estate?.bld_type_etc || "").trim();
    
    const displayName = name || bldType || bldEtc;
    if (displayName) parts.push(`■ ${displayName}`);
  }
  if (options.address && (basic?.jibunAddress || estate?.jibunAddress)) {
    parts.push(`■ ${basic?.jibunAddress || estate?.jibunAddress}`);
  }
  if (options.ho) {
    const dong = (basic?.estate_dong || estate?.estate_dong || "").trim();
    const ho = (basic?.estate_ho || estate?.estate_ho || "").trim();
    let unitText = "";
    if (dong) {
      unitText += dong.endsWith("동") ? `${dong} ` : `${dong}동 `;
    }
    if (ho) {
      unitText += ho.endsWith("호") ? ho : `${ho}호`;
    }
    if (unitText) parts.push(`■ ${unitText.trim()}`);
  }
  const floorVal = String(basic?.floor || estate?.floor || "").trim();
  if (options.floor && floorVal) {
    const floorText = floorVal.endsWith("층") ? floorVal : `${floorVal}층`;
    parts.push(`■ ${floorText}`);
  }
  // 2. 금액 (세대당 관리비 포함 로직)
  if (options.price) {
    let priceParts = [];
    
    // 세대당 관리비 (price_per_household) 확인
    const rawMgr = detail.price_per_household ?? estate?.price_per_household;
    const mgrFee = (rawMgr && Number(rawMgr) > 0) ? Number(rawMgr) : 0;
    const mgrText = mgrFee > 0 ? ` (관 ${mgrFee})` : "";

    const d = detail; // 편의상 별칭 사용
    if (d.rent_type_4deal === 'y') priceParts.push(`매매 ${d.price_sale || ""}`);
    if (d.rent_type_1year === 'y') priceParts.push(`전세 ${d.fee_jeonse || ""}${mgrText}`);
    if (d.rent_type_2month === 'y') priceParts.push(`월세 ${d.fee_year || 0}/${d.fee_month || 0}${mgrText}`);
    if (d.rent_type_3short === 'y') priceParts.push(`단기 ${d.price_deposit || 0}/${d.fee_month || 0}${mgrText}`);
    if (d.rent_type_5sale === 'y') priceParts.push(`분양 ${d.price_bunyang || ""}`);
    if (d.rent_type_6auction === 'y') priceParts.push(`경매 ${d.price_sale || ""}`);


    if (priceParts.length > 0) {
      parts.push(`■ ${priceParts.join(' / ')}`);
    }
  }

  // 3. 룸수 / 욕실수 (상업용/업무용 제외)
  const isCommercial = basic.estate_type === 'commerce' || basic.estate_type === 'business';
  if (options.roomBath && !isCommercial) {
    const rooms = detail.room_cnt || estate?.room_cnt || 0;
    const baths = detail.bath_cnt || estate?.bath_cnt || 0;
    if (rooms > 0 || baths > 0) parts.push(`■ ${rooms}룸/${baths}`);
  }

  // 4. 주차정보
  if (options.parking) {
    const pCnt = detail.parking_cnt || estate?.parking_cnt || 0;
    const pFee = detail.parking_fee || estate?.parking_fee || 0;
    parts.push(`■ 주차${pCnt > 0 ? '가능' : '불가'}${pFee > 0 ? `/${pFee}` : ''}`);
  }

  // 5. 준공일
  if (options.completionDate) {
    const cDate = detail.completion_year || estate?.completion_year;
    if (cDate) parts.push(`■ ${String(cDate).substring(0, 10)} 준공`);
  }

  // 6. 시설상태 (y인 라벨만)
  if (options.facilities) {
    const fMap = {
      living_condition_ev: "승강기",
      living_condition_terrace: "테라스",
      internal_condition_interior: "인테리어",
      internal_condition_water: "수도시설",
      internal_condition_city_gas: "도시가스",
      bath_division: "화장실 남녀구분",
      bath_inside: "화장실 내부",
      external_condition_exsign: "옥외광고",
      elec_condition_air_conditioner: "에어컨",
      elec_condition_refrigerator: "냉장고",
      elec_condition_washer: "세탁기",
      elec_condition_tv: "TV",
      elec_condition_cook: "인덕션",
      elec_condition_microwave: "전자렌지",
    };
    const activeFacs = Object.keys(fMap)
      .filter(key => (detail[key] === 'y' || estate?.[key] === 'y'))
      .map(key => fMap[key]);
    if (activeFacs.length > 0) parts.push(`■ 시설: ${activeFacs.join(', ')}`);
  }

  if (options.link) {
    parts.push(`\n상세보기: ${window.location.origin}/m/${estateNo}`);
  }
  return parts.join("\n");
};

// 📍 [외부] 포커스 유지 및 입력 가능 구조
const ContactArraySection = ({ title, list, onChange, isViewMode, formatPhoneNumber }) => {
  const safeList = Array.isArray(list) ? list : [];
  
  // 정상 파일 로직 그대로 (유효 데이터 필터링)
  const validList = safeList.filter(item => {
    // [CARD_BG_V2] 이름만 있어도 유효 (번호 '0' 은 빈 값 취급)
    const num = String(item.number || "").trim();
    const nm  = String(item.name || "").trim();
    return nm !== "" || (num !== "" && num !== "0");
  });

  if (isViewMode && validList.length === 0) return null;

  const addItem = () => onChange([...safeList, { name: "", number: "" }]);
  const removeItem = (index) => onChange(safeList.filter((_, i) => i !== index));
  
  const updateItem = (index, field, val) => {
    const newList = safeList.map((item, i) => {
      if (i === index) {
        // 📍 부모(EstateEditor)로부터 전달받은 함수를 여기서 사용
        const finalVal = (field === 'number' && typeof formatPhoneNumber === 'function') 
          ? formatPhoneNumber(val) 
          : val;
        return { ...item, [field]: finalVal };
      }
      return item;
    });
    onChange(newList);
  };

  const displayList = isViewMode ? validList : safeList;

  return (
    <div style={{ marginBottom: "4px" }}>{/* [CARD_BG_V1] 바깥 연락처 카드와 겹치던 배경·테두리 제거 */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", fontWeight: "bold" }}>{title}</label>
        {!isViewMode && <button type="button" onClick={addItem} style={{ padding: "2px 8px", background: "#3182ce", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}>추가 +</button>}
      </div>
      {isViewMode ? (
        /* [CONTACT_TEL_V1] 보기모드: 이름 + 📞 번호 링크 (모바일에서 누르면 전화 앱) */
        displayList.map((item, idx) => {
          const num = String(item.number || "").trim();
          const __dd = num.replace(/\D/g, ""); const d = __dd.length >= 2 ? __dd : "";   // [CONTACT_VIEW_SYNC_V1] '0' 등 2자리 미만은 번호 없음              // 숫자만 → tel:01012345678
          return (
            <div key={idx} style={{
              display: "flex", gap: 8, alignItems: "center",
              padding: "6px 0", fontSize: 13, borderBottom: "1px solid #e2e8f0",
            }}>
              <span style={{ flex: 1, fontWeight: 600, color: "#2d3748" }}>{item.name || "이름없음"}</span>
              {d ? (
                <a href={`tel:${d}`} onClick={(e) => e.stopPropagation()}
                   style={{ flex: 1.5, color: "#2b6cb0", fontWeight: 600, textDecoration: "none" }}>
                  📞 {num}
                </a>
              ) : (
                <span style={{ flex: 1.5, color: "#a0aec0" }}>번호 없음</span>
              )}
            </div>
          );
        })
      ) : displayList.map((item, idx) => (
        <div key={idx} style={{ display: "flex", gap: "5px", marginBottom: "5px" }}>
          <input 
            placeholder="성명" 
            value={item.name || ""} 
            disabled={isViewMode}
            onChange={e => updateItem(idx, 'name', e.target.value)} 
            style={{ flex: 1, padding: "8px", fontSize: "12px", border: isViewMode ? "none" : "1px solid #cbd5e0", borderRadius: "4px" }}
          />
          <input 
            placeholder="연락처" 
            value={item.number || ""} 
            disabled={isViewMode}
            onChange={e => updateItem(idx, 'number', e.target.value)} 
            style={{ flex: 1.5, padding: "8px", fontSize: "12px", border: isViewMode ? "none" : "1px solid #cbd5e0", borderRadius: "4px" }}
          />
          {!isViewMode && <button type="button" onClick={() => removeItem(idx)} style={{ padding: "0 8px", background: "#e53e3e", color: "#fff", border: "none", borderRadius: "4px" }}>-</button>}
        </div>
      ))}
    </div>
  );
};

export default function EstateEditor({ open, mode, estate, onClose, onSaved, onModeChange, onThumbChange }) {
  console.log("[EstateEditor estate]", estate);
  // mode: "edit" | "copy" | "contract" | "view" (상세보기 추가)

  // ═══════════════════════════════════════════════════════
  // 🔒 등급별 노출 제어 (2026 추가)
  //
  //  canEdit = true  → premium / admin  (전체 노출)
  //  canEdit = false → basic / 비로그인  (민감 영역 숨김)
  //
  //  판단 방법 (두 겹):
  //   ① estate.masked : 백엔드 maskEstate() 가 붙여주는 표시
  //       backend/routes/properties.js 의 SENSITIVE_FIELDS 참고
  //   ② me.grade      : ①이 없을 때를 대비한 보조 판단
  //
  //  ※ 화면 숨김은 "안 보이게" 하는 것일 뿐 보안이 아님.
  //    실제 데이터 차단은 백엔드 maskEstate 가,
  //    실제 기능 차단은 백엔드 라우터의 등급검사가 담당함.
  // ═══════════════════════════════════════════════════════
  const [myGrade, setMyGrade] = useState(null);
  useEffect(() => {
    // 팝업이 열릴 때만 등급 확인 (불필요한 호출 방지)
    if (!open) return;
    fetch("/api/auth/me")
      .then(r => r.ok ? r.json() : null)
      .then(d => setMyGrade((d?.user ?? d)?.grade ?? null))
      .catch(() => setMyGrade(null));
  }, [open]);

  const canEdit = estate?.masked === true
    ? false                                          // ① 백엔드가 가림 처리한 데이터
    : (myGrade === "admin" || myGrade === "premium"); // ② 등급 직접 확인

  const photoRef = useRef(); // PhotoGallery 연결용 Ref

  // 읽기 전용 여부 판단
  const isViewMode = mode === "view";

  // [CONTACT_LEGACY_OFF_V1] 구방식 연락처 참고 목록 (상세보기 전용, 저장 안 함)
  //   소유자 = contact_name/phone 1~3 (공실 등록 '우리 매물장 우선'과 같은 범위), 임차인 = 4~5
  //   해당 쪽 신방식 JSON 이 비었을 때만, 숫자 9자리 이상인 번호만 (자리값 '1'·'0' 제외)
  const __legacyContacts = () => {
    if (!estate) return [];
    const ok = (p) => String(p ?? "").replace(/\D/g, "").length >= 9;
    const nm = (n) => { const t = String(n ?? "").trim(); return t === "0" ? "" : t; };
    const out = [];
    const pick = (role, idxs, cur) => {
      if (Array.isArray(cur) && cur.length) return;
      idxs.forEach((k) => {
        const p = estate["contact_phone" + k];
        if (ok(p)) out.push({ role, name: nm(estate["contact_name" + k]), number: String(p).trim() });
      });
    };
    pick("소유자", [1, 2, 3], form?.owners);
    pick("임차인", [4, 5], form?.tenants);
    return out;
  };

  // [CANCEL_TO_VIEW_V1] 이 창이 '상세보기' 상태였던 적이 있는지 기억
  //   상세보기 → 「정보 수정하기」/「복사」 로 들어온 경우만 취소 시 상세보기로 돌아감
  //   (신규등록 등 처음부터 수정창으로 열린 경우는 돌아갈 곳이 없으니 기존처럼 창 닫기)
  //   모드가 view 로 바뀌면 편집기가 [open, estate, mode] 효과로 원래 값을 다시 채움 → 수정 중 값은 버려짐
  const __fromViewRef = useRef(false);
  useEffect(() => {
    if (!open) { __fromViewRef.current = false; return; }
    if (mode === "view") __fromViewRef.current = true;
  }, [open, mode]);

  const themeColor = isViewMode ? "#718096" : "#2b6cb0"; // 상세보기(회색) : 수정(파란색)
  const headerBg = isViewMode ? "#f8fafc" : "#ebf8ff";   // 헤더 배경색 차이

  // [추가] SMS 관련 상태
  const [smsLogs, setSmsLogs] = useState([]); // 전송 이력 누적용
  const [showSmsPopup, setShowSmsPopup] = useState(false); // 결과 팝업 제어

  // ───────── DRAG_STATE_V2: 창 드래그 이동 + 모바일 판별 ─────────
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize); // 정리
  }, []);

  const [pos, setPos] = useState({ x: 0, y: 0 }); // 원래 자리로부터 옮겨진 거리
  const dragRef = useRef(null);                    // 드래그 중 임시 저장소

  // 헤더를 누른 순간 — 시작 좌표 기록 후 문서 전체에 이동/종료 감시 부착
  const onDragStart = (e) => {
    if (isMobile) return;                          // 모바일은 드래그 안 함
    if (e.target.closest("button")) return;        // 닫기(×) 버튼 클릭은 제외
    const startX = e.clientX, startY = e.clientY;
    const base = { ...pos };
    dragRef.current = true;

    const onMove = (ev) => {
      if (!dragRef.current) return;
      setPos({
        x: base.x + (ev.clientX - startX),
        y: base.y + (ev.clientY - startY),
      });
    };
    const onUp = () => {
      dragRef.current = null;
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  };
  const [smsLoading, setSmsLoading] = useState(false);
  const [smsContent, setSmsContent] = useState(""); 
  const [smsSender, setSmsSender] = useState('');   // [SMS_SENDER_PICK_V1] 매물 SMS 발신번호(이번 발송만)
  const [receivers, setReceivers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]); // 체크된 수신자 ID들
  const [showReceiverModal, setShowReceiverModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false); // ★ 모바일 미리보기 제어
  const [previewData, setPreviewData] = useState(null); // ★ 스냅샷 데이터 임시 저장
  const [smsOptions, setSmsOptions] = useState({
    manual: false,        // 기본문구(수동) 제외
    estateName: true, 
    address: true, 
    ho: true,
    floor: true, 
    tradeType: true, 
    price: true,          // 금액 (관리비 포함 로직 적용 예정)
    roomBath: true,       // [추가] 룸수/욕실수
    parking: true,        // [추가] 주차정보
    completionDate: true, // [추가] 준공일
    facilities: true,     // [추가] 시설상태 (y인 것만)
    link: false,  // [SMS_SHARE_V1] 옛 /m/ 링크 제외 — 백엔드가 /api/s/ 토큰 링크를 붙인다
  });

  const [blogLoading, setBlogLoading] = useState(false);

  const [snapshotLogs, setSnapshotLogs] = useState([]);
  const [selectedSnapshot, setSelectedSnapshot] = useState(null); // 팝업용 데이터
  const [showBlogModal, setShowBlogModal] = useState(false);
  const [blogPreviewData, setBlogPreviewData] = useState(null);
  const [blogLogs, setBlogLogs] = useState([]);
  // ===== THUMB_FE_V1 : 블로그 대표(썸네일) 이미지 =====
  const [showThumbModal, setShowThumbModal] = useState(false);
  const [thumbTitle, setThumbTitle]   = useState("");    // 제목 (줄바꿈 가능)
  const [thumbBgUrl, setThumbBgUrl]   = useState("");    // 고른 매물사진 주소
  const [thumbBgB64, setThumbBgB64]   = useState("");    // 직접 업로드한 사진
  const [thumbResult, setThumbResult] = useState(null);  // { image, fileName, lines }
  const [thumbLoading, setThumbLoading] = useState(false);

  // 썸네일 화면 열기
  // 제목 기본값 우선순위: ① 건물명 → ② (없으면 직접입력) → ③ AI 글제목
  const openThumbModal = () => {
    let t = "";
    if (blogPreviewData?.estate_name && String(blogPreviewData.estate_name).trim()) {
      t = String(blogPreviewData.estate_name).trim();
    } else {
      const m = String(blogPreviewData?.aiContent || "").match(/^#\s*(.+)$/m);
      if (m) t = m[1].trim();
    }
    setThumbTitle(t);
    setThumbBgUrl(blogPreviewData?.photos?.[0] || "");
    setThumbBgB64("");
    setThumbResult(null);
    setShowThumbModal(true);
  };

  // 서버에 썸네일 생성 요청
  const generateThumb = async () => {
    if (!thumbTitle.trim()) { alert("제목을 입력해주세요."); return; }
    setThumbLoading(true);
    try {
      // 매물사진 목록은 sz=w600 이므로 썸네일용으로 크게 바꿔 보낸다
      const bigUrl = thumbBgUrl ? thumbBgUrl.replace(/sz=w\d+/, "sz=w1200") : "";
      const res = await authFetch("/api/blog-thumb/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: thumbTitle,
          imageUrl: bigUrl,
          imageB64: thumbBgB64,
          estateNo: estateNo,
        }),
      });
      const data = await res.json();
      if (data.ok) setThumbResult(data);
      else alert("생성 실패: " + (data.error || "알 수 없는 오류"));
    } catch (e) {
      alert("생성 실패: " + e.message);
    } finally {
      setThumbLoading(false);
    }
  };

  // 만들어진 이미지를 파일로 내려받기
  const downloadThumb = () => {
    if (!thumbResult?.image) return;
    const a = document.createElement("a");
    a.href = thumbResult.image;
    a.download = thumbResult.fileName || "thumbnail.png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // 직접 업로드한 사진을 base64 로 읽어 보관
  const onThumbFilePick = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => {
      setThumbBgB64(String(reader.result));
      setThumbBgUrl("");
    };
    reader.readAsDataURL(f);
  };
  // ===== THUMB_FE_V1 끝 =====
 // 📍 블로그 콘텐츠 생성 이력 상태 추가

  const [diffList, setDiffList] = useState([]); // 변경된 항목 리스트 저장용
  const [keepModDate, setKeepModDate] = useState(false); // [MODDATE_HOLD_V1] 저장 확인창 '수정일 갱신 안 함' (기본 꺼짐)

  const handleViewSnapshot = async (fileName) => {
    try {
      const res = await getSnapshotDetail(estateNo, fileName);
      if (res.ok) {
        setSelectedSnapshot(res.data);
      }
    } catch (err) {
      console.error(err);
      alert("스냅샷을 불러오는데 실패했습니다.");
    }
  };

  // 📍 블로그 이력 서버에서 불러오기
  const fetchBlogLogs = async () => {
    if (!estateNo) return;
    try {
      const res = await authFetch(`/api/properties/${estateNo}/blog-logs`);
      const data = await res.json();
      if (data.ok) setBlogLogs(data.logs || []);
    } catch (err) {
      console.error("블로그 이력 로드 실패:", err);
    }
  };

  const fetchSnapshotLogs = async () => {
    if (!estateNo) {
      console.error("❌ [Snapshot 검증] estateNo가 없습니다.");
      return;
    }

    try {
      console.log(`📡 [Snapshot 검증] API 호출 시작: /api/snapshot/list/${estateNo}`);
      const res = await getSnapshotList(estateNo);
      
      console.log("📥 [Snapshot 검증] 서버 응답 수신:", res);

      if (res && res.ok) {
        console.log("✅ [Snapshot 검증] 데이터 수신 성공, 아이템 수:", res.items?.length);
        setSnapshotLogs(res.items || []);
      } else {
        console.warn("⚠️ [Snapshot 검증] 응답은 왔으나 데이터 형식이 올바르지 않음:", res);
      }
    } catch (err) {
      console.error("🔥 [Snapshot 검증] 호출 중 치명적 에러:", err);
    }
  };

  const [propertyPhotos, setPropertyPhotos] = useState([]); // 전체 사진 저장용
  const [galleryPhotos, setGalleryPhotos] = useState([]); // 상세 사진들을 저장할 상태

  // 1. useCallback으로 함수가 리렌더링 때마다 새로 생성되는 것을 방지
  const handlePhotosLoaded = useCallback((incomingPhotos) => {
    setGalleryPhotos(prev => {
      // 2. [필수] 데이터가 실제로 다를 때만 업데이트 (루프 차단막)
      if (JSON.stringify(prev) === JSON.stringify(incomingPhotos)) {
        return prev;
      }
      return incomingPhotos;
    });
  }, []);

    // 옵션 변경 시 텍스트 즉시 갱신
    const handleOptionChange = (key) => {
      setSmsOptions(prev => {
        const next = { ...prev, [key]: !prev[key] };
        const newText = generateSmsText(next, { basic, detail, estate, estateNo });
        setSmsContent(newText);
        return next;
      });
    };

  // 그룹 전체 선택/해제 핸들러
  const handleGroupCheck = (groupName, isChecked) => {
    const groupIds = groupedReceivers[groupName].map(r => r.id);
    if (isChecked) {
      // 기존 선택된 ID들에 해당 그룹 ID들 합치기 (중복 제거)
      setSelectedIds(prev => [...new Set([...prev, ...groupIds])]);
    } else {
      // 해당 그룹 ID들만 제외하기
      setSelectedIds(prev => prev.filter(id => !groupIds.includes(id)));
    }
  };

  // 개별 체크박스 핸들러
  const handleIndividualCheck = (id, isChecked) => {
    if (isChecked) {
      setSelectedIds(prev => [...prev, id]);
    } else {
      setSelectedIds(prev => prev.filter(item => item !== id));
    }
  };

  // BLOG_RENDER_V1 + BLOG_H1_V1
  // AI가 준 글(줄바꿈 문자가 섞인 긴 문자열)을 진짜 HTML 태그로 바꿔 그린다.
  // ─ CSS(pre-wrap)로 줄을 나누면 복사 시 구조가 사라져 네이버에서 한 줄로 붙는다
  // ─ "# "  → <h1> 글 제목,  "## " → <h2> 소제목,  "---" → <hr>,  나머지 → <p>
  const stripMdMarks = (s) =>
    String(s)
      .replace(/\*\*(.+?)\*\*/g, "$1")   // **강조** → 기호 제거
      .replace(/^[-*]\s+/, "· ")          // - 목록 → · 목록
      .trim();

  // BLOG_PHOTO_V1 — 블로그용 사진 한 장을 그리는 도우미
  const blogPhoto = (url, key, big) => (
    <img key={key} src={url} referrerPolicy="no-referrer"
         style={{ width: "100%", borderRadius: "10px",
                  margin: big ? "0 0 24px" : "8px 0 24px",
                  display: "block" }} />
  );

  // photos: 본문 사이에 끼워 넣을 사진 (1번 대표사진은 제외하고 넘어온다)
  const renderBlogContent = (text, photos) => {
    if (!text) return null;
    const lines = String(text).split("\n");
    const out = [];
    const pool = Array.isArray(photos) ? [...photos] : [];
    let firstH2 = true;   // 첫 소제목 앞에는 사진을 넣지 않는다

    lines.forEach((raw, i) => {
      const line = raw.trim();
      if (!line) return;

      if (/^(-{3,}|\*{3,}|_{3,})$/.test(line)) {
        out.push(
          <hr key={"h" + i}
              style={{ border: 0, borderTop: "1px solid #cbd5e0", margin: "28px 0" }} />
        );
        return;
      }

      const m = line.match(/^(#{1,6})\s*(.+)$/);
      if (m) {
        const level = m[1].length;
        if (level === 1) {
          out.push(
            <h1 key={"t" + i}
                style={{ fontSize: "30px", fontWeight: "bold", color: "#1a202c",
                         margin: "0 0 28px", lineHeight: "1.4",
                         paddingBottom: "16px", borderBottom: "2px solid #e2e8f0" }}>
              {stripMdMarks(m[2])}
            </h1>
          );
        } else {
          // BLOG_PHOTO_V1 — 소제목 앞에 사진 한 장 (첫 소제목은 제외)
          if (!firstH2 && pool.length > 0) {
            out.push(blogPhoto(pool.shift(), "ph" + i, false));
          }
          firstH2 = false;

          out.push(
            <h2 key={"t" + i}
                style={{ fontSize: "21px", fontWeight: "bold", color: "#2d3748",
                         margin: "34px 0 14px", lineHeight: "1.5" }}>
              {stripMdMarks(m[2])}
            </h2>
          );
        }
        return;
      }

      out.push(
        <p key={"p" + i}
           style={{ fontSize: "17px", lineHeight: "1.9", color: "#2d3748",
                    margin: "0 0 16px" }}>
          {stripMdMarks(line)}
        </p>
      );
    });

    // BLOG_PHOTO_V1 — 남은 사진을 2열 격자로 모아 붙인다
    if (pool.length > 0) {
      out.push(
        <div key="restph"
             style={{ display: "grid", gridTemplateColumns: "1fr 1fr",
                      gap: "10px", margin: "24px 0" }}>
          {pool.map((u, k) => (
            <img key={"r" + k} src={u} referrerPolicy="no-referrer"
                 style={{ width: "100%", borderRadius: "8px", display: "block" }} />
          ))}
        </div>
      );
    }

    return out;
  };

  // 블로그 생성 핸들러 함수 (수정본)
const handleGenerateBlogPage = async () => {
  if (!estateNo) return;

  const userKeywords = window.prompt("블로그 포스팅의 주요 주제를 입력해주세요. (예: 직주근접, 가성비, 조용한동네, 인테리어)");
  if (userKeywords === null) return;

  setBlogLoading(true);

  try {
    // BLOG_NOSNAP_V1
    // 스냅샷이 있으면 그것을 쓰고, 없으면 현재 화면 값으로 대체한다.
    let target = null;
    try {
      const listRes = await getSnapshotList(estateNo);
      if (listRes.ok && listRes.items && listRes.items.length > 0) {
        const latestFileName = listRes.items[0].fileName;   // DESC 정렬이므로 [0]이 최신
        const detailRes = await getSnapshotDetail(estateNo, latestFileName);
        target = detailRes.data;
      }
    } catch (snapErr) {
      console.warn("스냅샷 조회 실패 - 현재 화면 값으로 대체:", snapErr);
    }

    if (!target) {
      // 스냅샷 없음 — 화면 상태값으로 스냅샷 모양을 즉석 조립
      target = {
        meta: {},
        basic: { ...basic },
        detail: { ...detail },
        photos: (galleryPhotos || []).map(p =>
          typeof p === "string" ? p : (p.url || p.path || p.thumb_url)
        ).filter(Boolean),
        timestamp: new Date().toISOString(),
        editor_mode: "live",
      };
      console.log("[블로그] 스냅샷이 없어 현재 화면 값으로 생성합니다.");
    }

    // BLOG_PHOTO_FALLBACK_V1
    // 스냅샷은 있는데 사진이 비어 있는 경우(= 사진을 스냅샷 저장 뒤에 올린 매물)
    // 현재 화면의 사진 목록(galleryPhotos)으로 채운다.
    // 글 내용은 스냅샷 그대로 두고 사진만 보충하는 것이라 기존 동작에 영향 없음.
    if (target && (!Array.isArray(target.photos) || target.photos.length === 0)) {
      const livePhotos = (galleryPhotos || []).map(p =>
        typeof p === "string" ? p : (p.url || p.path || p.thumb_url)
      ).filter(Boolean);
      if (livePhotos.length > 0) {
        target = { ...target, photos: livePhotos };
        console.log("[블로그] 스냅샷에 사진이 없어 현재 사진 " + livePhotos.length + "장으로 보충합니다.");
      }
    }

    const detailSrc = target.detail || {};

    // 3. Gemini AI 분석 요청
    const aiResponse = await axios.post("/api/blog/analyze-gemini", {
        snapshot: target,
        keywords: userKeywords
    });

    if (!aiResponse.data.ok) throw new Error("AI 분석 실패");

    // --- 📍 [추가] 가격 및 관리비 범위 가이드 로직 ---
    const fYear = parseInt(detailSrc.fee_year || 0);
    const fMonth = parseInt(detailSrc.fee_month || 0);
    
    const customInfoLines = [];
    
    // 기본 정보 추가
    // BLOG_H1_V1 — 값이 있을 때만 추가 (station 없으면 "인접"만 찍히던 문제)
    const hasVal = (v) => v !== null && v !== undefined && String(v).trim() !== "";
    const cYear = detailSrc.completion_year
      ? String(detailSrc.completion_year).substring(0, 4) : "";
    if (/^\d{4}$/.test(cYear)) customInfoLines.push(`${cYear}년식 컨디션`);
    if (hasVal(detailSrc.price_per_household))
      customInfoLines.push(`관리비 약 ${detailSrc.price_per_household}만원`);
    if (hasVal(detailSrc.station))
      customInfoLines.push(`${detailSrc.station} 인접`);

    // 가격 범위 로직 추가
    if (fYear > 0 || fMonth > 0) {
      customInfoLines.push(`보통 보증금은 ${fYear.toLocaleString()} ~ ${(fYear + 1000).toLocaleString()}정도이며,`);
      customInfoLines.push(`월세는 ${fMonth.toLocaleString()} ~ ${(fMonth + 10).toLocaleString()}정도입니다.`);
    }
    // ----------------------------------------------

    // 4. 블로그 미리보기 데이터 세팅
    const generationTime = new Date().toLocaleString('ko-KR'); // 📍 생성 시각 기록
    
    const newBlogPreview = {
      estate_name: target.basic.estate_name,
      roadAddress: target.basic.roadAddress,
      aiContent: aiResponse.data.content, // Gemini 생성 문구
      summary: aiResponse.data.summary || null,  // BLOG_SUMMARY_V1 요약 카드 데이터
      infoLines: customInfoLines,        // 📍 위에서 만든 커스텀 라인 적용
      photos: (target.photos || []).map(url => url.replace(/sz=w\d+/, 'sz=w600')),
      lat: target.basic.lat,
      lng: target.basic.lng,
      generatedAt: generationTime
    };

    setBlogPreviewData(newBlogPreview);

    // 5. 📍 서버에 블로그 생성 이력 저장
    try {
      await authFetch(`/api/properties/${estateNo}/blog-logs`, {
        method: "POST",
        headers: { "Content-Type": "application/json" }, // ★ 수정: 헤더 없으면 서버가 body를 못 읽어 keywords가 NULL로 저장됨
        body: JSON.stringify({ keywords: userKeywords })
      });
      fetchBlogLogs(); // 저장 후 목록 새로고침
    } catch (err) {
      console.error("이력 저장 실패");
    }

    setShowBlogModal(true);
  } catch (error) {
    const serverMsg = error.response?.data?.error || error.message;
    alert("AI 분석 실패: " + serverMsg);
  } finally {
    setBlogLoading(false);
  }
};

const updateContactList = useCallback((type, newList) => {
  setForm(prev => ({
    ...prev,
    [type]: newList
  }));
}, []);

  // [1단계] 전송 버튼 클릭 시 현재 화면 데이터 박제 (미리보기용)
const handleOpenPreview = () => {
    // 1. 기본 텍스트 처리
    const lines = smsContent.split('\n');
    const priceLine = lines.find(l => 
        l.includes('■') && 
        (l.includes('매매') || l.includes('전세') || l.includes('월세') || l.includes('단기'))
    );
    const extractedPrice = priceLine ? priceLine.replace(/■/g, '').trim() : "";

    // 📸 2. 사진 수집 로직 (가장 안전한 필터링 방식)
    // PhotoGallery에서 올라온 galleryPhotos를 우선 사용
    const sourcePhotos = (galleryPhotos && galleryPhotos.length > 0) 
      ? galleryPhotos 
      : (propertyPhotos && propertyPhotos.length > 0) ? propertyPhotos : [];
    console.log("📸 스냅샷 수집 대상 원본:", sourcePhotos);

    const photoUrls = sourcePhotos.map(p => {
      // p가 객체면 url 필드 추출, 문자열이면 그대로 사용
      let rawUrl = (typeof p === 'string') ? p : (p.url || p.path || p.thumb_url);
      
      if (!rawUrl) return null;

      // 구글 드라이브 주소 변환 (sz 파라미터가 있으면 고화질로, 없으면 원본 유지)
      if (rawUrl.includes('drive.google.com') || rawUrl.includes('googleusercontent.com')) {
        // 📍 쿼리 파라미터 유연한 처리: 기존 sz 제거 후 w600 강제 주입
        let cleanUrl = rawUrl.split('&sz=')[0];
        return cleanUrl.includes('?') ? `${cleanUrl}&sz=w600` : `${cleanUrl}?sz=w600`;
      }
      return rawUrl;
    }).filter(Boolean); // null 값 제거

    // 🕵️ 디버깅용 콘솔 (F12에서 확인 필수!)
    console.log("최종 수집된 사진 배열:", photoUrls);

    // 📍 시설 상태 데이터 수집 (한글 라벨로 변환)
    const fMap = {
      living_condition_ev: "승강기",
      living_condition_terrace: "테라스",
      internal_condition_interior: "인테리어",
      internal_condition_water: "수도시설",
      internal_condition_city_gas: "도시가스",
      bath_division: "화장실 남녀구분",
      bath_inside: "화장실 내부",
      external_condition_exsign: "옥외광고",
      elec_condition_air_conditioner: "에어컨",
      elec_condition_refrigerator: "냉장고",
      elec_condition_washer: "세탁기",
      elec_condition_tv: "TV",
      elec_condition_cook: "인덕션",
      elec_condition_microwave: "전자렌지",
    };

    // detail 객체에서 'y'인 것들만 한글 이름으로 필터링
    const selectedFacilities = Object.keys(fMap)
      .filter(key => detail[key] === 'y' || estate?.[key] === 'y')
      .map(key => fMap[key]);

    // 3. 스냅샷 데이터 생성
    const snapshotData = {
      estate_name: smsOptions.estateName ? (basic.estate_name || estate?.estate_name) : null,
      price_info: smsOptions.price ? extractedPrice : null,
      roadAddress: smsOptions.address ? (basic.roadAddress || estate?.roadAddress) : null,
      jibunAddress: smsOptions.address ? (basic.jibunAddress || estate?.jibunAddress) : null,
      estate_ho: smsOptions.ho ? (basic.estate_ho || estate?.estate_ho) : null,
      floor: smsOptions.floor ? (basic.floor || estate?.floor) : null,
      exclusive_scale: smsOptions.roomBath ? detail.exclusive_scale : null,
      room_cnt: smsOptions.roomBath ? detail.room_cnt : null,
      bath_cnt: smsOptions.roomBath ? detail.bath_cnt : null,
      parking_cnt: smsOptions.parking ? (detail.parking_cnt || estate?.parking_cnt) : null,
      completion_year: smsOptions.completionDate ? detail.completion_year : null,
      
      photos: photoUrls, // ★ 이 배열이 비어있으면 사진이 안 나옵니다.
      
      facilities: selectedFacilities, // ✅ 한글 배열로 저장 (예: ["승강기", "에어컨"])
      memo: smsContent.replace(new RegExp(`${window.location.origin}/m/\\d+`, 'g'), '').trim(),
      lat: smsOptions.address ? (basic.lat || null) : null,
      lng: smsOptions.address ? (basic.lng || null) : null,
    };

    setPreviewData(snapshotData);
    setShowPreviewModal(true);

    console.log("박제될 사진들:", photoUrls);
  };

  // [2단계] [수정] 미리보기 확인 시 스냅샷 저장 후 바로 SMS 발송까지 수행
  const handleSaveSnapshotAndSend = async () => {
    setSmsLoading(true);
    try {
      // 1. 서버에 모바일 상세화면용 스냅샷 저장 (기존 로직)
      const res = await authFetch("/api/properties/snapshots", {
        method: "POST",
        body: JSON.stringify({
          propertyId: estateNo,   
          snapshotData: previewData 
        })
      });
      const resData = await res.json();
      if (!resData.ok) throw new Error("화면 저장 실패");

      // 2. 📍 실제 SMS 발송 함수 호출 (이미 만들어둔 handleSmsSend 실행)
      console.log("🚀 스냅샷 저장 성공, 이제 실제 SMS 발송을 시작합니다.");
      await handleSmsSend(); 
      
      // 3. 모든 프로세스 완료 후 모달들 닫기
      setShowPreviewModal(false);
      setShowSmsPopup(false); 
      
    } catch (err) {
      console.error("최종 프로세스 에러:", err);
      alert("처리 중 오류가 발생했습니다: " + err.message);
    } finally {
      setSmsLoading(false);
    }
  };

// 복잡한 useMemo를 제거하고, 명부가 없을 때를 대비해 빈 객체를 기본값으로 선언합니다.
  const groupedReceivers = (receivers && receivers.length > 0) 
    ? receivers.reduce((acc, curr) => {
        const group = curr.group_name || "미지정";
        if (!acc[group]) acc[group] = [];
        acc[group].push(curr);
        return acc;
      }, {})
    : {};

  // EstateEditor 컴포넌트 내부 상단에 추가
const isFieldVisible = (fieldName) => {
    const type = basic.estate_type; // residence, profit, business, commerce
    const d = detail;

    // [0] 거래유형(rent_type_...) 체크 상태 (매핑용)
    const rent = {
      deal: d.rent_type_4deal === 'y' || d.rent_type_6auction === 'y', // 매매 or 경매
      jeon: d.rent_type_1year === 'y',                                // 전세
      wol: d.rent_type_2month === 'y',                                // 월세
      short: d.rent_type_3short === 'y',                              // 단기
      sale: d.rent_type_5sale === 'y'                                 // 분양
    };

    // [1] 필수 공통 항목 및 그룹 (무조건 노출)
    if ([
      "_facility_group", "_grade_condition_group", "_status_toggle_group", 
      "_rent_type_toggle_group", "register_memo", "estate_name", "estate_type", 
      "bld_type", "bld_type_etc", "bld_structure", "use_district", "completion_year"
    ].includes(fieldName)) return true;   // [BLD_STRUCT_VIS_V1]

    if (fieldName === "_facility_elec_group") return type === 'residence';

    // [2] 거래유형에 따른 금액 필드 공통 제어 (모든 물건유형 공통 적용)
    // 매매/경매 관련 필드
    if (['price_sale', 'price_investment', 'mortgage', 'price_per_scale'].includes(fieldName)) {
      return rent.deal;
    }

    // 분양가
    if (fieldName === 'price_bunyang') return rent.sale;
    // 전세보증금
    if (fieldName === 'fee_jeonse') return rent.jeon;
    // 월세보증금
    if (fieldName === 'fee_year') return rent.wol;
    // 월세 (월세 or 단기일 때 노출)
    if (fieldName === 'fee_month') return rent.wol || rent.short;
    // 단기예치금
    if (fieldName === 'price_deposit') return rent.short;

    // ★ 협의가 필드 수정: 매매(deal) 혹은 월세(wol)일 때 노출
    if (fieldName === 'price_posible') {
      return rent.wol; 
    }

    // [3] 수익성(profit) 물건 특수 로직
    if (type === 'profit') {
      // 건물 전체 관리이므로 호수/동 등 세부 정보 제외
      const hiddenInProfit = [
        "estate_dong", "estate_ho", "floor", "floor_etc", 
        "floor_type1", "floor_type2", "shop_name", "estate_direction" 
      ];
      if (hiddenInProfit.includes(fieldName)) return false;

      // 주인세대 유무에 따른 노출
      if (fieldName === 'owner_room' || fieldName === 'owner_bath') {
        return d.owner_household === 'y';
      }

      // 수익성 전용 필드
      const profitFields = [
        "totArea", "site_amount", "site_amount_square", "owner_household", 
        "rent_household_cnt", "sale_type_rent_year", "sale_type_rent_month", 
        "living_condition_terrace", "living_condition_ev", "site_scale", "site_scale_square"
      ];
      if (profitFields.includes(fieldName)) return true;
    }

    // [4] 기타 공통 항목 (층, 주차, 교통 등)
    const commonFields = [
      "estate_dong", "floor", "estate_ho", "floor_etc", "floor_type1", "floor_type2",
      "bld_scale", "bld_scale_under", "parking_cnt", "parking_fee",
      "station", "station_distance", "station_transport",
      "price_mgr_yn", "price_per_household", "_mgr_items_group", 
      "heat_condition", "living_condition_ev", "estate_direction"
    ];
    if (commonFields.includes(fieldName)) return true;

    // [5] 주거용(residence) 전용 항목
    if (type === 'residence') {
      if (fieldName === '_sale_type_sub_group') return rent.deal;
      if (fieldName === '_sale_type_rent_group' || fieldName === 'sale_type_rent_year' || fieldName === 'sale_type_rent_month') {
        return rent.deal && d.sale_type_sub_rent === 'y';
      }
      if (["room_cnt", "bath_cnt"].includes(fieldName)) return true;
      if (fieldName.includes("scale") || fieldName.includes("area") || fieldName === "totArea") return true;
    }

    // [6] 상업용 / 업무용 (commerce / business) 전용 항목
    if (type === 'commerce' || type === 'business') {
      // 상가 관련 특수 필드 (권리금 등)
      if (["shop_name", "price_premium", "price_sum", "cold_condition", 
           "internal_condition_city_gas", "living_condition_terrace", "internal_condition_water",
           "bath_division", "bath_inside", "external_condition_exsign"].includes(fieldName)) return true;
      
      // 면적 관련
      if (fieldName.includes("scale") || fieldName.includes("area") || fieldName === "totArea") return true;
    }

    return false;
  };

// 입력 요소 포커스를 위한 Ref 객체들
  const fieldRefs = {
    estate_type: useRef(null),
    completion_year: useRef(null),
    rent_type_group: useRef(null),
  };

  const [errors, setErrors] = useState({}); // 누락된 필드 하이라이트 상태

  const [applyMode, setApplyMode] = useState("ifEmpty");

  const [estateNo, setEstateNo] = useState(
    estate && estate.estate_no ? estate.estate_no : null
  );


  useEffect(() => {
    if (estate && estate.estate_no) {
      setEstateNo(estate.estate_no);
    }
  }, [estate]);
  const registerId = estate && estate.register_id ? estate.register_id : null;
  const updateId = estate && estate.update_id ? estate.update_id : null;
  const registerDate = estate && estate.register_date ? estate.register_date : null;
  const updateDate = estate && estate.update_date ? estate.update_date : null;

  const [form, setForm] = useState({
    use_yn: "y",
    contract_yn: "y",
    grade_condition: "",
    register_memo: "",
    resident_memo: "",
    contact_name1: "",
    contact_phone1: "",
    contact_name2: "",
    contact_phone2: "",
    contact_name3: "",
    contact_phone3: "",
    contact_name4: "",
    contact_phone4: "",
    contact_name5: "",
    contact_phone5: "",
  });

  // 기본정보 폼
  const [basic, setBasic] = useState({
    estate_name: "",
    estate_dong: "",
    estate_ho: "",
    estate_type: "residence",
    bld_type: "",
    bld_type_etc: "",
    estate_direction: "",
    shop_name: "",
    floor: "",
    floor_type1: "",
    floor_type2: "",
    floor_etc: "",
    lat: null,
    lng: null,
    roadAddress: "",
    jibunAddress: "",
    detailAddress: "",
  });

  // 상세정보 폼(금액/면적/방·욕실/주차/준공년도 등)
  const [detail, setDetail] = useState({
    // 거래유형
    rent_type_4deal: "",
    rent_type_1year: "",
    rent_type_2month: "",
    rent_type_3short: "",
    rent_type_5sale: "",
    rent_type_6auction: "",    

    // 금액
    price_sale: "",
    price_bunyang: "",
    price_deposit: "",
    price_mgr_yn: "y",
    price_per_scale: "",
    price_investment: "",
    price_premium: "",
    price_sum: "",
    price_per_household: "",
    mortgage: "",
    fee_jeonse: "", // ★ 추가
    fee_year: "",
    fee_month: "",
    price_posible: "",
    f_price_total_mgr: "",
    // 관리비 구성
    price_mgr_item_basic: "",
    price_mgr_item_water: "",
    price_mgr_item_internet: "",
    price_mgr_item_online: "",
    price_mgr_item_heat: "",
    price_mgr_item_elec: "",

    // 면적
    exclusive_scale: "",
    exclusive_scale_square: "",
    used_scale: "",
    used_scale_square: "",
    common_area_m2: "",
    common_area_square: "",
    site_amount: "",
    site_amount_square: "",
    site_scale: "",
    site_scale_square: "",
    use_district: "",

    // 방/욕실/층/주차/기타
    room_cnt: "",
    bath_cnt: "",
    bld_scale_under: "",
    bld_scale: "",
    parking_cnt: "",
    parking_fee: "",
    completion_year: "",
    // 주인세대
    owner_household: "n",
    owner_room: "",
    owner_bath: "",
    rent_household_cnt: "",
    // 시설/상태
    living_condition_ev: "",
    living_condition_terrace: "",
    internal_condition_interior: "",
    internal_condition_water: "",
    internal_condition_city_gas: "",
    bath_division: "",
    bath_inside: "",
    external_condition_exsign: "",
    heat_condition: "",
    cold_condition: "",
    // 임대/입주 서브옵션
    sale_type_sub_living: "",
    sale_type_sub_rent: "",
    sale_type_rent: "",
    sale_type_rent_year: "",
    sale_type_rent_month: "",
    // 교통
    station: "",
    station_distance: "",
    station_transport: "",
  });

  // 전화번호 자동 포맷 (예: 010-1234-5678, 02-1234-5678)
  const formatPhoneNumber = (raw) => {
    if (!raw) return "";
    const digits = raw.replace(/\D/g, "");

    // 서울 02
    if (digits.startsWith("02")) {
      if (digits.length <= 2) return digits;
      if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
      if (digits.length <= 9)
        return `${digits.slice(0, 2)}-${digits.slice(2, digits.length - 4)}-${digits.slice(-4)}`;
      return `${digits.slice(0, 2)}-${digits.slice(2, digits.length - 4)}-${digits.slice(-4)}`;
    }

    // 그 외 (010, 031 등)
    if (digits.length <= 3) return digits;
    if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, digits.length - 4)}-${digits.slice(-4)}`;
  };

  const handleContactPhoneChange = (fieldName, value) => {
    if (isViewMode) return;
    
    // 숫자가 아닌 문자 제거 (단, 문자열 상태 유지)
    const rawDigits = value.replace(/\D/g, "");
    
    // 포맷팅 함수 호출 (기존 formatPhoneNumber 사용)
    const formatted = formatPhoneNumber(rawDigits);
    
    setForm((prev) => ({ 
      ...prev, 
      [fieldName]: formatted // ★ 숫자로 변환하지 않고 문자열 그대로 저장
    }));
  };

  // 공통 값 가져오기
  const getFieldValue = (fieldName) => {
    const def = FIELD_DEFS[fieldName];
    if (!def) return "";
    if (def.state === "basic") return basic[fieldName] ?? "";
    if (def.state === "detail") return detail[fieldName] ?? "";
    if (def.state === "form") return form[fieldName] ?? "";
    return "";
  };

  // 공통 값 설정하기
  const setFieldValue = (fieldName, value) => {
    if (isViewMode) return; // ★ 이 한 줄이 있으면 어떤 입력도 반영되지 않습니다.
    const def = FIELD_DEFS[fieldName];
    if (!def) return;
    if (def.state === "basic") {
      setBasic((prev) => ({ ...prev, [fieldName]: value }));
    } else if (def.state === "detail") {
      setDetail((prev) => ({ ...prev, [fieldName]: value }));
    } else if (def.state === "form") {
      setForm((prev) => ({ ...prev, [fieldName]: value }));
    }
  };

  // [PROFIT_RT_CLEAN_V1] 수익성 화면에 없는 거래유형(전세·월세·단기)을 자동으로 'n'
  //  - 수익성 편집 화면은 매매·분양·경매 버튼만 보여주지만(_rent_type_toggle_group 렌더 부분),
  //    불러온 옛 값(전세 y 등)이 detail 에 남아 저장 때 그대로 다시 전송됐다 (12126번 사례)
  //  - 용도를 수익성으로 바꾼 경우에도 같은 정리가 일어난다
  //  - 정리된 값은 「저장 전 변경사항 확인」 목록에 '전세 y→n' 으로 보인다 (의도된 표시)
  //  - 매물 불러오기 effect(아래 [open, estate, mode]) 가 detail 을 채운 뒤 다시 돌며 정리한다
  useEffect(() => {
    if (isViewMode || basic.estate_type !== "profit") return;
    setDetail((prev) => {
      if (prev.rent_type_1year !== "y" && prev.rent_type_2month !== "y" && prev.rent_type_3short !== "y") return prev;
      return { ...prev, rent_type_1year: "n", rent_type_2month: "n", rent_type_3short: "n" };
    });
  }, [isViewMode, basic.estate_type, detail.rent_type_1year, detail.rent_type_2month, detail.rent_type_3short]);

  // [COPY_TYPE_PICK_V1] 복사 모드로 열리면 먼저 용도를 고르게 한다
  //  - 「이 매물 복사하기」 버튼 → onModeChange("copy") → mode 가 copy 로 바뀌면 선택창 표시
  //  - 고른 용도는 setFieldValue("estate_type") 로 basic 에 들어가고,
  //    항목 표시 규칙(basic.estate_type 기준)이 그 용도에 맞는 칸만 보여준다
  //  - 선택창 화면은 하단 「상세보기(view) 모드일 때는…」 주석 바로 앞에 있음
  const [copyTypePick, setCopyTypePick] = useState(false);
  useEffect(() => {
    setCopyTypePick(!!open && mode === "copy");
  }, [open, mode]);

  // 전용/실/공용/대지 면적 ↔ 평수 상호변환 대상 필드
  const AREA_SYNC_FIELDS = new Set([
    "exclusive_scale",
    "exclusive_scale_square",
    "used_scale",
    "used_scale_square",
    "common_area_m2",
    "common_area_square",
    "site_amount",
    "site_amount_square",
    "site_scale",
    "site_scale_square",
  ]);

  // 공통 입력 렌더링
  // 공통 입력 렌더링
  const renderFieldInput = (fieldName) => {
    // ══════ [PRICECARD_VIEW_V1] 거래·금액 카드 보기모드 표시 (2026-10-08) ══════
    // 왜 함수 맨 앞인가: price_mgr_yn(rent-toggle)·_sale_type_* 그룹은
    //   아래 MERGE_CELLS_V1 / BLDCARD_VIEW 블록에 도달하기 전에 따로 그려지기 때문.
    // 여기서 return 하지 않은 칸은 기존 경로를 그대로 탄다. 수정모드는 영향 없음.
    if (isViewMode) {
      const __pcHas = (v) => v !== null && v !== undefined && String(v).trim() !== "" && String(v).trim() !== "0";
      const __pcNum = (v) => Number(String(v ?? "").replace(/,/g, "")) || 0;
      const __pcFmt = (v) => __pcNum(v).toLocaleString();          // 1000 → "1,000"
      const __pcBox = (txt) => (                                     // MERGE_CELLS_V1 mergedBox 와 같은 모양
        <div style={{
          padding: "6px 0", fontSize: "14px", color: "#2d3748",
          fontWeight: "600", borderBottom: "1px solid #edf2f7",
          minHeight: "32px", display: "flex", alignItems: "center",
        }}>{txt}</div>
      );
      const __pcType = String(basic.estate_type || "");
      const __pcRtLbl = { y: "전세", m: "월세", s: "단기" };         // SALE_TYPE_RENT_OPTIONS 와 동일

      // ① 매매가 — 수익성: "160,000 (평당 4,520)" / "(평당가 미상)"
      if (fieldName === "price_sale" && __pcType === "profit") {
        const sale = detail.price_sale, pps = detail.price_per_scale;
        if (!__pcHas(sale)) return null;
        return __pcBox(`${__pcFmt(sale)} (${__pcHas(pps) ? "평당 " + __pcFmt(pps) : "평당가 미상"})`);
      }
      if (fieldName === "price_per_scale" && __pcType === "profit") return null;   // ①에 합침

      // ── [VIEW_LAYOUT_V2] 냉난방 — 난방 칸에 "개별난방/개별냉방" (한쪽만 있으면 그것만, '/' 없음) ──
      //   냉방은 냉방 칸이 원래 보이는 유형일 때만 붙임 (isFieldVisible 규칙 그대로 → 주거용엔 안 붙음)
      //   난방 'private' (93건) 은 냉방 코드가 잘못 들어간 옛 데이터 → 화면에서 개별난방으로 표시 (DB 그대로)
      if (fieldName === "heat_condition") {
        const hMap = { "private-heat": "개별난방", private: "개별난방", center: "중앙난방", floor: "층난방" };
        const cMap = { private: "개별냉방", center: "중앙냉방" };
        const hv = String(detail.heat_condition ?? "").trim();
        const cv = String(detail.cold_condition ?? "").trim();
        const h = hMap[hv] || hv;
        const c = isFieldVisible("cold_condition") ? (cMap[cv] || cv) : "";
        const txt = [h, c].filter(Boolean).join("/");
        return txt ? __pcBox(txt) : null;
      }
      if (fieldName === "cold_condition") return null;      // 난방 칸에 합쳐 출력

      // ══════ [AREACARD_VIEW_V1] 면적·구성 카드 + 임대현황 가구수 (2026-10-08) ══════
      // ⓐ 수익성 임대현황 — "임대현황 21,900/370 (14가구)"
      //    가구수(rent_household_cnt)는 면적·구성 카드 칸이지만 여기로 합쳐 출력 (아래 ⓒ에서 숨김)
      //    아래 ② 보다 먼저 실행되어 수익성은 여기서 끝남
      if (fieldName === "sale_type_rent_year" && __pcType === "profit") {
        const dep = detail.sale_type_rent_year, mon = detail.sale_type_rent_month;
        const hh = detail.rent_household_cnt;
        if (!__pcHas(dep) && !__pcHas(mon) && !__pcHas(hh)) return null;
        let t = "임대현황";
        if (__pcHas(dep) || __pcHas(mon))
          t += ` ${__pcFmt(dep)}${__pcHas(mon) ? "/" + __pcFmt(mon) : ""}`;
        if (__pcHas(hh)) t += ` (${hh}가구)`;
        return __pcBox(t);
      }

      // ⓑ 주인세대 — 선택된 것만. 있음이면 같은 칸에 "3룸/1"
      //    칸 폭은 카드 배치 코드의 isFullWidthGroup 에서 보기모드 2칸(한 줄 전체)로 → 옆자리 비움
      if (fieldName === "owner_household") {
        // [VIEW_LAYOUT_V1] 원래 토글(있음/없음 막대)과 같은 크기·색상 — 선택된 쪽 하나만 표시
        //   칸은 한 줄 전체(isFullWidthGroup) → 왼쪽 반 = 토글, 오른쪽 반 = "3룸/1" (없음이면 비움)
        //   gap 8 = 카드 격자 gap 과 동일해서 아래 칸들과 세로줄이 맞음
        const yes = detail.owner_household === "y";
        const rm = detail.owner_room, bt = detail.owner_bath;
        const rb = [__pcHas(rm) ? `${rm}룸` : "", __pcHas(bt) ? String(bt) : ""].filter(Boolean).join("/");
        return (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, alignItems: "center" }}>
            <div style={{ display: "flex", border: `1px solid ${yes ? "#285e61" : "#553c9a"}`, borderRadius: 4, overflow: "hidden" }}>
              <div style={{
                flex: 1, textAlign: "center", padding: "6px 0", fontSize: 12,
                // [VIEW_LAYOUT_V2] 있음=청록 · 없음=보라 (상세보기의 파랑·주황·빨강·남색·초록과 겹치지 않는 색)
                backgroundColor: yes ? "#903bd6" : "#767577", color: "#fff",
              }}>{yes ? "주인세대 있음" : "주인세대 없음"}</div>
            </div>
            <div style={{ fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>{yes ? rb : ""}</div>
          </div>
        );
      }
      if (fieldName === "owner_room" || fieldName === "owner_bath") return null;   // ⓑ에 합침

      // ⓒ 전체 임대 가구 수 — 수익성은 ⓐ 임대현황에 합침
      if (fieldName === "rent_household_cnt" && __pcType === "profit") return null;

      // ⓓ 면적 — ㎡ 칸에 "20.47평(67.65㎡)" 로 합치고 평 칸은 숨김
      //    평 값이 없으면 ㎡ ÷ 3.3058 로 화면에서만 계산 (DB 는 그대로)
      //    연면적(totArea)은 평 칸(totArea_square)이 카드·자동변환 목록에 없어 평이 비는 경우가 많음 → 계산으로 보완
      {
        const __arPairs = {
          exclusive_scale: "exclusive_scale_square", used_scale: "used_scale_square",
          common_area_m2: "common_area_square",      site_amount: "site_amount_square",
          site_scale: "site_scale_square",           totArea: "totArea_square",
        };
        const __arPrefix = {
          exclusive_scale: "전용", used_scale: "실면적", common_area_m2: "공용",
          site_amount: "대지", site_scale: "지분", totArea: "연면적",
        };
        const __arPrefixOn = true;   // true 로 바꾸면 "대지 35.4평(117.03㎡)" 처럼 앞에 이름
        if (Object.values(__arPairs).includes(fieldName)) return null;   // 평 칸 숨김
        if (__arPairs[fieldName]) {
          const m2 = __pcNum(detail[fieldName]);
          const sq = __pcNum(detail[__arPairs[fieldName]]);
          if (!m2 && !sq) return null;
          const py = sq || Math.round((m2 / 3.3058) * 100) / 100;
          const f2 = (x) => x.toLocaleString(undefined, { maximumFractionDigits: 2 });
          const body = m2 ? `${f2(py)}평(${f2(m2)}㎡)` : `${f2(py)}평`;
          return __pcBox(__arPrefixOn ? `${__arPrefix[fieldName]} ${body}` : body);
        }
      }
      // ══════ [AREACARD_VIEW_V1] 끝 ══════

      // ② 현재 거주 보증금/월세
      if (fieldName === "sale_type_rent_year") {
        const dep = detail.sale_type_rent_year, mon = detail.sale_type_rent_month;
        if (!__pcHas(dep) && !__pcHas(mon)) return null;
        if (__pcType === "profit") {                                  // 수익성: "임대현황 21,900/370"
          return __pcBox(`임대현황 ${__pcFmt(dep)}${__pcHas(mon) ? "/" + __pcFmt(mon) : ""}`);
        }
        if (detail.sale_type_rent === "y") return __pcBox(__pcFmt(dep));   // 전세: 보증금만
        return __pcBox(`${__pcFmt(dep)}${__pcHas(mon) ? " / " + __pcFmt(mon) : ""}`);
      }
      if (fieldName === "sale_type_rent_month") return null;                  // ②에 합침

      // ③ 임대승계 칩 — "임대승계 (월세)" (입주가능은 아래 원래 코드가 그림)
      if (fieldName === "_sale_type_sub_group"
          && detail.sale_type_sub_rent === "y" && detail.sale_type_sub_living !== "y") {
        const rt = __pcRtLbl[detail.sale_type_rent] || "";
        return (
          <div style={{ display: "flex", width: "100%", border: "1px solid #ff7300ff", borderRadius: 4, overflow: "hidden" }}>
            <div style={{
              flex: 1, textAlign: "center", padding: "6px 0", fontSize: 12, fontWeight: 600,
              backgroundColor: "#ff7300ff", color: "#fff",
            }}>{rt ? `임대승계 (${rt})` : "임대승계"}</div>
          </div>
        );
      }
      if (fieldName === "_sale_type_rent_group") return null;                 // ③에 합침

      // ④ 주차 — "주차 1대(5만원)"
      if (fieldName === "parking_cnt") {
        const cnt = detail.parking_cnt, fee = detail.parking_fee;
        if (!__pcHas(cnt) && !__pcHas(fee)) return null;
        const feeTxt = __pcHas(fee) ? `(${__pcFmt(fee)}만원)` : "";
        return __pcBox(__pcHas(cnt) ? `주차 ${cnt}대${feeTxt}` : `주차비${feeTxt}`);
      }
      if (fieldName === "parking_fee") return null;                           // ④에 합침

      // ⑤ 관리비 — 세대당 관리비 있으면 "관)9", 없고 '관리비 별도'면 "관리비 별도"
      if (fieldName === "price_per_household") {
        const v = detail.price_per_household;
        if (__pcHas(v)) return __pcBox(`관)${__pcFmt(v)}`);
        return detail.price_mgr_yn === "y" ? __pcBox("관리비 별도") : null;
      }
      if (fieldName === "price_mgr_yn") return null;                          // ⑤에 합침

      // [PRICECARD_VIEW_V2] ⑥ 이름을 앞에 붙여 출력 — "실투자금 85,000" / "권리 3,000" / "합계 8,000"
      //   값 없거나 0 이면 칸 숨김 (HIDE_EMPTY_IN_VIEW 와 같은 규칙)
      {
        const __pcPrefix = { price_investment: "실투자금", price_premium: "권리", price_sum: "합계" };
        if (__pcPrefix[fieldName]) {
          const v = detail[fieldName];
          return __pcHas(v) ? __pcBox(`${__pcPrefix[fieldName]} ${__pcFmt(v)}`) : null;
        }
      }
    }
    // ══════ [PRICECARD_VIEW_V1] 끝 ══════

    // ★ [수정] 내부 타이틀(글자) 삭제
    if (fieldName === "_status_toggle_group") {
      return (
        <div style={{ 
          display: "flex", 
          gap: "20px",        // 스위치 사이 간격 확대
          alignItems: "center", 
          padding: "10px 0",  // 위아래 여백 추가
          width: "100%" 
        }}>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
            {renderFieldInput("contract_yn")}
          </div>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
            {renderFieldInput("use_yn")}
          </div>
        </div>
      );
    }

    const isError = !!errors[fieldName];

    const errorStyle = isError ? { border: "2px solid #ff4d4f", backgroundColor: "#fff2f0" } : {};

    // RENDER_CHIPS_V1 — 보기모드 전용: 체크된 항목만 기존 버튼 모양으로 표시
    // c = { bg: 켜진색, size: 글자크기 }  각 묶음의 기존 속성을 그대로 넘겨받음
    // 켜진 항목들이 가로를 균등 분할(flex:1)하여 기존 버튼과 같은 형태 유지
    const renderChips = (items, readValue, c) => {
      const on = items.filter(it => readValue(it.key) === "y");
      if (on.length === 0) return null;   // 켜진 게 없으면 항목째로 숨김
      return (
        <div style={{
          display: "flex", width: "100%",
          border: `1px solid ${c.bg}`, borderRadius: 4, overflow: "hidden",
        }}>
          {on.map((it, idx) => (
            <div key={it.key} style={{
              flex: 1, textAlign: "center",
              padding: "6px 0",
              fontSize: c.size || 12, fontWeight: 600,
              backgroundColor: c.bg, color: "#fff",
              borderRight: idx < on.length - 1 ? "1px solid rgba(255,255,255,0.4)" : "none",
            }}>{it.label}</div>
          ))}
        </div>
      );
    };

    // 거래유형 토글 출력
    if (fieldName === "_rent_type_toggle_group") {
      // 1. const 대신 let을 사용하여 재할당이 가능하도록 수정
      let items = [
        { key: "rent_type_4deal", label: "매매" },
        { key: "rent_type_1year", label: "전세" },
        { key: "rent_type_2month", label: "월세" },
        { key: "rent_type_3short", label: "단기" },
        { key: "rent_type_5sale", label: "분양" },
        { key: "rent_type_6auction", label: "경매" },
      ];

      // 2. 수익성일 때 리스트 필터링 (이제 let이므로 에러가 나지 않음)
      if (basic.estate_type === "profit") {
        items = items.filter(it => 
          ["rent_type_4deal", "rent_type_5sale", "rent_type_6auction"].includes(it.key)
        );
      }

      const isError = !!errors["_rent_type_toggle_group"];

      // CHIPS_RENT_TYPE: 보기모드는 체크된 것만 칠로
      if (isViewMode) {
        return renderChips(items, (k) => getFieldValue(k), { bg: "#d00", size: 13 });
      }

      return (
        <div
          ref={fieldRefs.rent_type_group} // ★ 스크롤 이동용 Ref
          title="거래유형 (매매/전세/월세 등 다중 선택 가능)" // ★ 주석 추가
          style={{
            display: "flex",
            width: "100%",
            border: isError ? "2px solid #ff4d4f" : "1px solid #d00", // ★ 에러 시 빨간 테두리
            backgroundColor: isError ? "#fff2f0" : "transparent",
            borderRadius: 6,
            overflow: "hidden",
          }}
        >
          {items.map((it, idx) => {
            const val = getFieldValue(it.key);
            const checked = val === "y";

            return (
              <div
                key={it.key}
                onClick={() => {
                  if (isViewMode) return; // ★ 상세보기 시 클릭 방지
                  setFieldValue(it.key, checked ? "n" : "y");
                  // ★ 클릭 시 에러 상태 해제
                  setErrors(prev => {
                    const next = { ...prev };
                    delete next["_rent_type_toggle_group"];
                    return next;
                  });
                }}
                style={{
                  flex: 1,
                  padding: "10px 0",
                  cursor: "pointer",
                  textAlign: "center",
                  fontSize: 13,

                  backgroundColor: checked ? "#d00" : "#fff",
                  color: checked ? "#fff" : "#d00",

                  borderRight:
                    idx < items.length - 1
                      ? "1px solid #d00"
                      : "none",
                  userSelect: "none",
                }}
              >
                {it.label}
              </div>
            );
          })}
        </div>
      );
    }

  // 임대/입주 옵션(입주가능/임대승계) – 주인세대 유무처럼 단일선택 바
  if (fieldName === "_sale_type_sub_group") {
    const living = detail.sale_type_sub_living ?? "";
    const rent = detail.sale_type_sub_rent ?? "";

    // 현재 선택 상태: "living" / "rent" / ""
    const current =
      living === "y" ? "living" : rent === "y" ? "rent" : "";

    // CHIPS_SALE_SUB: 보기모드는 선택된 것만 (기존 주황 유지)
    if (isViewMode) {
      if (!current) return null;   // 미선택이면 항목째로 숨김
      const label = current === "living" ? "입주가능" : "임대승계";
      return (
        <div style={{
          display: "flex", width: "100%",
          border: "1px solid #ff7300ff", borderRadius: 4, overflow: "hidden",
        }}>
          <div style={{
            flex: 1, textAlign: "center", padding: "6px 0",
            fontSize: 12, fontWeight: 600,
            backgroundColor: "#ff7300ff", color: "#fff",
          }}>{label}</div>
        </div>
      );
    }

    const setMode = (mode) => {
      if (mode === "living") {
        if (current === "living") {
          // 다시 클릭하면 둘 다 해제
          setFieldValue("sale_type_sub_living", "n");
          setFieldValue("sale_type_sub_rent", "n");
        } else {
          setFieldValue("sale_type_sub_living", "y");
          setFieldValue("sale_type_sub_rent", "n");
        }
      } else if (mode === "rent") {
        if (current === "rent") {
          setFieldValue("sale_type_sub_living", "n");
          setFieldValue("sale_type_sub_rent", "n");
        } else {
          setFieldValue("sale_type_sub_living", "n");
          setFieldValue("sale_type_sub_rent", "y");
        }
      }
    };

    return (
      <div
        style={{
          display: "flex",
          border: "1px solid #502604ff",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        <button
          type="button"
          disabled={isViewMode} // ★ 추가
          onClick={() => !isViewMode && setMode("living")} // ★ 조건부 실행
          style={{
            flex: 1,
            padding: "6px 0",
            fontSize: 12,
            cursor: "pointer",
            backgroundColor: current === "living" ? "#ff7300ff" : "#fff",
            color: current === "living" ? "#fff" : "#502604ff",
            border: "none",
            borderRight: "1px solid #502604ff",
          }}
        >
          입주가능
        </button>
        <button
          type="button"
          onClick={() => setMode("rent")}
          style={{
            flex: 1,
            padding: "6px 0",
            fontSize: 12,
            cursor: "pointer",
            backgroundColor: current === "rent" ? "#ff7300ff" : "#fff",
            color: current === "rent" ? "#fff" : "#502604ff",
            border: "none",
          }}
        >
          임대승계
        </button>
      </div>
    );
  }

  // 물건관리 등급 – 단일선택 버튼 바 (한 행 전용)
  if (fieldName === "_grade_condition_group") {
    const current = form.grade_condition ?? "";
    const items = GRADE_CONDITION_OPTIONS.filter(o => o.value);

    return (
      <div
        style={{
          display: "flex",
          width: "100%", // ★ 추가: 부모 너비를 꽉 채우도록 설정
          border: "1px solid #333",
          borderRadius: 4,
          overflow: "hidden",
          marginTop: 4, // 라벨과의 간격
        }}
      >
        {items.map((opt, idx) => {
          const checked = current === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              disabled={isViewMode} // ★ 추가
              onClick={() =>
                !isViewMode &&
                setFieldValue(
                  "grade_condition",
                  checked ? "" : opt.value
                )
              }
              style={{
                flex: 1,
                padding: "8px 0",
                fontSize: 12,
                cursor: "pointer",
                backgroundColor: checked ? "#a04db9ff" : "#fff",
                color: checked ? "#f1ebebff" : "#222",
                border: "none",
                borderRight:
                  idx < items.length - 1 ? "1px solid #860560ff" : "none",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  }



  // 물건관리 등급 (grade_condition) – 단일선택 토글
  if (fieldName === "grade_condition") {
    const current = form.grade_condition ?? "";

    return (
      <div
        style={{
          display: "flex",
          border: "1px solid #444",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        {GRADE_CONDITION_OPTIONS.filter(o => o.value).map((opt, idx, arr) => {
          const checked = current === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() =>
                setFieldValue(
                  "grade_condition",
                  checked ? "" : opt.value
                )
              }
              style={{
                flex: 1,
                padding: "6px 0",
                fontSize: 12,
                cursor: "pointer",
                backgroundColor: checked ? "#7f67d6ff" : "#fff",
                color: checked ? "#fff" : "#222",
                border: "none",
                borderRight:
                  idx < arr.length - 1 ? "1px solid #7315aaff" : "none",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  }


  // 임대형태(y/m/s) 단일선택 버튼 바
  if (fieldName === "_sale_type_rent_group") {
    const current = detail.sale_type_rent ?? "";
    const items = [
      { value: "y", label: "전세" },
      { value: "m", label: "월세" },
      { value: "s", label: "단기" },
    ];
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {/* <div style={{ fontSize: 12, width: 70 }}>임대형태</div> */}
        <div
          style={{
            display: "flex",
            flex: 1,
            border: "1px solid #d00",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          {items.map((it, idx) => {
            const checked = current === it.value;
            return (
              <button
                key={it.value}
                type="button"
                onClick={() =>
                  setFieldValue(
                    "sale_type_rent",
                    checked ? "" : it.value
                  )
                }
                style={{
                  flex: 1,
                  padding: "6px 0",
                  cursor: "pointer",
                  fontSize: 13,
                  backgroundColor: checked ? "#d00" : "#fff",
                  color: checked ? "#fff" : "#d00",
                  border: "none",
                  borderRight:
                    idx < items.length - 1 ? "1px solid #d00" : "none",
                }}
              >
                {it.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // 관리비 구성 묶음 버튼 – 거래유형처럼 한 덩어리로
  if (fieldName === "_mgr_items_group") {
    const items = [
      { key: "price_mgr_item_basic", label: "기본" },
      { key: "price_mgr_item_water", label: "수도" },
      { key: "price_mgr_item_internet", label: "인터넷" },
      { key: "price_mgr_item_online", label: "유선" },
      { key: "price_mgr_item_heat", label: "난방" },
      { key: "price_mgr_item_elec", label: "전기" },
    ];

    // CHIPS_MGR_ITEMS: 보기모드는 체크된 것만 (기존 남색 유지)
    if (isViewMode) {
      return renderChips(items, (k) => detail[k], { bg: "#0c2a57ff", size: 12 });
    }

    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}> {/* ★ width 추가 */}
        {/* <div style={{ fontSize: 12, width: 70 }}>관리비 구성</div> */}
        <div
          style={{
            display: "flex",
            flex: 1,
            width: "100%", // ★ width 추가
            border: "1px solid #999",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          {items.map((it, idx) => {
            const v = detail[it.key] ?? "";
            const checked = v === "y";
            return (
              <button
                key={it.key}
                type="button"
                onClick={() =>
                  setFieldValue(it.key, checked ? "n" : "y")
                }
                style={{
                  flex: 1,               // 전부 같은 비율
                  padding: "6px 0",
                  fontSize: 12,
                  cursor: "pointer",
                  backgroundColor: checked ? "#0c2a57ff" : "#fff",
                  color: checked ? "#fff" : "#0c2a57ff",
                  border: "none",
                  borderRight:
                    idx < items.length - 1 ? "1px solid #999" : "none",
                }}
              >
                {it.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  // 가전 묶음
  if (fieldName === "_facility_elec_group") {
    const items = [
      { key: "elec_condition_refrigerator", label: "냉장고" },
      { key: "elec_condition_washer", label: "세탁기" },
      { key: "elec_condition_air_conditioner", label: "에어컨" },
      { key: "elec_condition_cook", label: "인덕션" },
      { key: "elec_condition_microwave", label: "전자렌지" },
      { key: "elec_condition_tv", label: "TV" },
    ];

    // CHIPS_ELEC: 보기모드는 체크된 것만 (기존 파랑 #0057a8 유지)
    if (isViewMode) {
      return renderChips(items, (k) => detail[k], { bg: "#0057a8", size: 12 });
    }

    return (
      <div
        style={{
          display: "flex",
          border: "1px solid #999",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        {items.map((it, idx) => {
          const checked = detail[it.key] === "y";
          return (
            <button
              key={it.key}
              type="button"
              onClick={() => setFieldValue(it.key, checked ? "n" : "y")}
              style={{
                flex: 1,
                padding: "6px 0",
                fontSize: 12,
                backgroundColor: checked ? "#0057a8" : "#fff",
                color: checked ? "#fff" : "#0057a8",
                border: "none",
                borderRight: idx < items.length - 1 ? "1px solid #999" : "none",
              }}
            >
              {it.label}
            </button>
          );
        })}
      </div>
    );
  }


  // 시설 / 상태 묶음 버튼 렌더링
    if (fieldName === "_facility_group") {
      // 1. const를 let으로 변경하여 재할당을 허용합니다.
      let items = [
        { key: "living_condition_ev", label: "승강기" },
        { key: "living_condition_terrace", label: "테라스/베란다" },
        { key: "internal_condition_interior", label: "인테리어" },
        { key: "internal_condition_water", label: "수도시설" },
        { key: "internal_condition_city_gas", label: "도시가스" },
        { key: "bath_division", label: "화장실 남녀구분" },
        { key: "bath_inside", label: "화장실 내부" },
        { key: "external_condition_exsign", label: "옥외광고" },
      ];

      // 2. 이제 let이므로 필터링된 결과가 정상적으로 대입됩니다.
      if (basic.estate_type === 'residence') {
        items = items.filter(it => ["living_condition_ev", "internal_condition_interior", "living_condition_terrace"].includes(it.key));
      } else if (basic.estate_type === 'profit') {
        items = items.filter(it => ["living_condition_ev", "living_condition_terrace"].includes(it.key));
      }

    // CHIPS_FACILITY: 보기모드는 체크된 것만 (기존 초록 유지)
    if (isViewMode) {
      return renderChips(items, (k) => getFieldValue(k), { bg: "#248f04ff", size: 12 });
    }

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          border: "1px solid #999",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        {items.map((it, idx) => {
          const v = detail[it.key] ?? "";
          const checked = v === "y";
          return (
            <button
              key={it.key}
              type="button"
              onClick={() =>
                setFieldValue(it.key, checked ? "n" : "y")
              }
              style={{
                flex: items.length > 4 ? "0 0 25%" : "1", // 개수가 적을 땐 꽉 채우고 많을 땐 격자로
                padding: "6px 0",
                fontSize: 12,
                cursor: "pointer",
                backgroundColor: checked ? "#248f04ff" : "#fff",
                color: checked ? "#fff" : "#248f04ff",
                border: "none",
                borderRight:
                  (idx % 4 !== 3) && idx < items.length - 1
                    ? "1px solid #999"
                    : "none",
                borderBottom: items.length > 4 && idx < items.length - 4 ? "1px solid #999" : "none",
              }}
            >
              {it.label}
            </button>
          );
        })}
      </div>
    );
  }

    const def = FIELD_DEFS[fieldName];
    if (!def) return null;

    const value = getFieldValue(fieldName);

    // ★ [추가] 상세보기(View Mode)일 때 input 대신 순수 텍스트로 출력
    if (isViewMode && def.type !== "rent-toggle" && def.type !== "use-toggle") {

      // ══════ MERGE_CELLS_V1: 관련 항목을 한 셀로 합쳐 출력 ══════
      // 값이 있는지 검사하는 도우미 (0 과 "0" 도 없는 값으로 취급)
      const has = (v) => v !== null && v !== undefined && String(v).trim() !== ""
                         && String(v).trim() !== "0";
      // 합친 값을 그리는 공통 상자 (아래 개별 항목 출력과 같은 모양)
      const mergedBox = (txt) => (
        <div style={{
          padding: "6px 0", fontSize: "14px", color: "#2d3748",
          fontWeight: "600", borderBottom: "1px solid #edf2f7",
          minHeight: "32px", display: "flex", alignItems: "center",
        }}>{txt}</div>
      );

      // ══════ [BLDCARD_VIEW_V1] 건물·호실 카드 보기모드 표시 규칙 (2026-10-07) ══════
      // · 화면 표시만 바꾼다 — 저장값(basic/detail 상태)은 건드리지 않음
      // · 라벨(칸 위 작은 제목) 숨김은 아래 카드 배치 코드의 __bcHide 가 담당
      // · 아래 ⑤ MERGE_ROOM_BATH 보다 먼저 실행되므로 room_cnt 는 여기서 처리됨
      const __bcType = String(getFieldValue("estate_type") || "");
      const __bcRes  = __bcType === "residence";             // 주거용 여부
      // 코드 → 한글 라벨 (옵션표에 없으면 원래 값 그대로, 빈값이면 "")
      const __bcLbl = (opts, v) => {
        const o = opts.find(x => x.value !== "" && String(x.value) === String(v));
        return o ? o.label : (has(v) ? String(v) : "");
      };
      // 건물용도 + 상세용도 → "원룸건물 (다가구주택)"
      //   상세용도가 비었거나 건물용도와 같은 글자면 괄호 생략
      const __bcBld = () => {
        const bt  = __bcLbl(BLD_TYPE_OPTIONS, getFieldValue("bld_type"));
        const etc = String(getFieldValue("bld_type_etc") || "").trim();
        // [BLDCARD_VIEW_V2] 건물용도가 비면 "건물용도 미상" (상세용도만 있으면 괄호로)
        if (!bt) return has(etc) ? `건물용도 미상 (${etc})` : "건물용도 미상";
        return (has(etc) && etc !== bt) ? `${bt} (${etc})` : bt;
      };

      // ⓐ 건물명 — 비어 있으면 건물용도로 대신 표시
      if (fieldName === "estate_name") {
        const nm  = String(getFieldValue("estate_name") || "").trim();
        const txt = has(nm) ? nm : __bcLbl(BLD_TYPE_OPTIONS, getFieldValue("bld_type"));
        return txt ? mergedBox(txt) : null;
      }

      // ⓑ 용도지역 — 수익성(profit)일 때만. 그 외는 칸 자체 숨김
      //    (수익성이면 아래 기본 select 출력 경로로 내려가 한글 라벨 표시)
      // [BLDCARD_VIEW_V4] 용도지역은 자기 칸 없이 물건유형 칸 안에 합쳐 출력
      if (fieldName === "use_district") return null;
      // 물건유형 — 수익성이면 "수익성(제2종일반주거지역)"
      //   use_district 는 코드(ud14)로 저장 → USE_DISTRICT_OPTIONS 로 한글 변환
      //   (옛 데이터처럼 한글이 그대로 들어 있으면 __bcLbl 이 그 글자를 그대로 돌려줌)
      if (fieldName === "estate_type") {
        const et = __bcLbl(ESTATE_TYPE_OPTIONS, __bcType);
        if (!et) return null;
        const ud = __bcType === "profit"
          ? __bcLbl(USE_DISTRICT_OPTIONS, getFieldValue("use_district")) : "";
        return mergedBox(ud ? `${et}(${ud})` : et);
      }

      // ⓒ 준공일 — "2006-01-25 준공" / 비었거나 0000-00-00 이면 "준공일 미상"
      if (fieldName === "completion_year") {
        const d  = String(getFieldValue("completion_year") || "").slice(0, 10);
        const ok = /^\d{4}-\d{2}-\d{2}$/.test(d) && !d.startsWith("0000");
        return mergedBox(ok ? `${d} 준공` : "준공일 미상");
      }

      // ⓓ 건물용도 — "원룸건물 (다가구주택)"
      //    격자는 숨긴 칸을 건너뛰고 당겨 채우므로, 주거용에서 룸형태 칸을 숨기면
      //    이 칸이 곧 '룸형태가 있던 자리'에 보인다
      if (fieldName === "bld_type") {
        const t = __bcBld();
        return t ? mergedBox(t) : null;
      }
      if (fieldName === "bld_type_etc")     return null;   // ⓓ 건물용도 옆에 합쳐 출력
      if (fieldName === "bld_structure")    return null;   // ⓔ 룸수 옆에 합쳐 출력
      if (fieldName === "estate_direction") return null;   // ⓔ 룸수 옆에 합쳐 출력

      // ⓔ 룸수 — "1.5룸/1 (오픈형,남향)"
      //    룸형태·방향은 주거용일 때만 붙이고, 있는 값만 쉼표로 연결
      if (fieldName === "room_cnt") {
        const rm = getFieldValue("room_cnt");
        const bt = getFieldValue("bath_cnt");
        const parts = [];
        if (has(rm)) parts.push(`${rm}룸`);
        if (has(bt)) parts.push(String(bt));
        const extra = [];
        if (__bcRes) {
          const st = __bcLbl(BLD_STRUCTURE_OPTIONS, getFieldValue("bld_structure"));
          const dr = __bcLbl(ESTATE_DIRECTION_OPTIONS, getFieldValue("estate_direction"));
          if (st) extra.push(st);
          if (dr) extra.push(dr);
        }
        if (!parts.length && !extra.length) return null;
        const base = parts.join("/");
        const tail = extra.length ? (base ? ` (${extra.join(",")})` : extra.join(",")) : "";
        return mergedBox(base + tail);
      }
      // ── [BLDCARD_VIEW_V2] ⓕ 층·호수 — "101동 5층-501호" ──
      //    아래 ② 해당층-호수(MERGE_CELLS_V1)보다 먼저 실행되어 그것을 대신함
      //    호수가 없으면 기존과 같은 순서로 대체: 호수 → 호수대체 → 층대체
      const __bcHo  = getFieldValue("estate_ho");
      const __bcEtc = getFieldValue("floor_etc");
      const __bcFt2 = getFieldValue("floor_type2");
      if (fieldName === "floor") {
        const fl = getFieldValue("floor");
        const ho = has(__bcHo) ? __bcHo : (has(__bcEtc) ? __bcEtc : (__bcFt2 || ""));
        // estate_dong 은 '동' 글자 없이 저장됨(101, B) → 화면에서만 붙임. 이미 '동'이면 그대로
        const dg = String(getFieldValue("estate_dong") || "").trim();
        const dongTxt = has(dg) ? (/동$/.test(dg) ? dg : `${dg}동`) : "";
        if (!has(fl) && !has(ho) && !dongTxt) return null;
        const left  = has(fl) ? `${fl}층` : "";
        const right = has(ho) ? (String(ho).includes("호") ? ho : `${ho}호`) : "";
        const fh = [left, right].filter(Boolean).join("-");
        return mergedBox([dongTxt, fh].filter(Boolean).join(" "));
      }
      if (fieldName === "estate_dong") return null;       // ⓕ 층·호수 칸에 합쳐 출력
      // 호수대체 — 호수가 없어 ⓕ에서 대신 쓰였을 때만 숨김 (호수가 따로 있으면 별도 정보라 표시)
      if (fieldName === "floor_etc" && !has(__bcHo)) return null;
      // 층대체 — 호수·호수대체 둘 다 없어 ⓕ에서 대신 쓰였을 때만 숨김
      if (fieldName === "floor_type2" && !has(__bcHo) && !has(__bcEtc)) return null;
      // ══════ [BLDCARD_VIEW_V1] 끝 ══════

      // ① 건물규모 — "지상 12층 / 지하 2층" (지하 없으면 지상만)
      if (fieldName === "bld_scale") {
        const up = getFieldValue("bld_scale");
        const dn = getFieldValue("bld_scale_under");
        if (!has(up) && !has(dn)) return null;
        const parts = [];
        if (has(up)) parts.push(`지상 ${up}층`);
        if (has(dn)) parts.push(`지하 ${dn}층`);
        return mergedBox(parts.join(" / "));
      }
      if (fieldName === "bld_scale_under") return null;  // 위에서 합쳐 출력됨

      // ② 해당층-호수 — "3층-302호" (호수 없으면 대체값 사용)
      if (fieldName === "floor") {
        const fl = getFieldValue("floor");
        // 호수가 없으면 기존 대체 순서(호수 → 층대체 → 층구분) 적용
        const ho = getFieldValue("estate_ho")
                   || basic.floor_etc || basic.floor_type2 || "";
        if (!has(fl) && !has(ho)) return null;
        const left  = has(fl) ? `${fl}층` : "";
        const right = has(ho) ? (String(ho).includes("호") ? ho : `${ho}호`) : "";
        return mergedBox([left, right].filter(Boolean).join("-"));
      }
      if (fieldName === "estate_ho") return null;        // 위에서 합쳐 출력됨

      // ③ 보증금/월세 — "2,000/140"
      if (fieldName === "fee_year") {
        const dep = getFieldValue("fee_year");
        const mon = getFieldValue("fee_month");
        if (!has(dep) && !has(mon)) return null;
        const fmt = (v) => Number(String(v).replace(/,/g, "")).toLocaleString();
        const parts = [];
        if (has(dep)) parts.push(fmt(dep));
        if (has(mon)) parts.push(fmt(mon));
        return mergedBox(parts.join("/"));
      }
      if (fieldName === "fee_month") return null;        // 위에서 합쳐 출력됨

      // ④ 교통 — "독산역 도보 5분" (DB 값 그대로, 수단만 한글 변환)
      if (fieldName === "station") {
        const st = getFieldValue("station");
        const di = getFieldValue("station_distance");
        const tr = getFieldValue("station_transport");
        const koMap = { walk: "도보", bus: "버스", car: "차량" };
        const trKo = tr ? (koMap[String(tr).toLowerCase()] || tr) : "";
        if (!has(st) && !has(di) && !has(trKo)) return null;
        const parts = [];
        if (has(st))   parts.push(st);
        if (has(trKo)) parts.push(trKo);
        if (has(di))   parts.push(`${di}분`);
        return mergedBox(parts.join(" "));
      }
      if (fieldName === "station_distance") return null;   // 위에서 합쳐 출력됨
      if (fieldName === "station_transport") return null;  // 위에서 합쳐 출력됨

      // ⑤ MERGE_ROOM_BATH: 룸/욕실 — "3룸/1"
      if (fieldName === "room_cnt") {
        const rm = getFieldValue("room_cnt");
        const bt = getFieldValue("bath_cnt");
        if (!has(rm) && !has(bt)) return null;
        const parts = [];
        if (has(rm)) parts.push(`${rm}룸`);
        if (has(bt)) parts.push(String(bt));
        return mergedBox(parts.join("/"));
      }
      if (fieldName === "bath_cnt") return null;         // 위에서 합쳐 출력됨
      // ══════ MERGE_CELLS_V1 끝 ══════

      let displayValue = value;
      
      // select 타입은 value 대신 label 찾기
      if (def.type === "select") {
        const options = getSelectOptions(fieldName);
        const selectedOpt = options.find(o => String(o.value) === String(value));
        displayValue = selectedOpt ? selectedOpt.label : value;
      }

      // TRANSPORT_KO: 교통수단이 영어로 저장된 데이터를 화면에서만 한글로
      // (DB는 그대로. 변환표에 없는 값은 원본 그대로 표시)
      if (fieldName === "station_transport") {
        const koMap = { walk: "도보", bus: "버스", car: "차량" };
        displayValue = koMap[String(value).toLowerCase()] || value;
      }

      // [COMMA_V1] 금액·면적 등 number 타입은 천단위 콤마로 표시 (소수점 유지)
      if (def.type === "number") {
        displayValue = commaView(value);
      }
      
      // 값이 없거나 "0"인 경우 처리
      const isZero = value === 0 || value === "0" || !value || String(value).trim() === "";

      // HIDE_EMPTY_IN_VIEW: 상세보기에서 값이 비면 항목 자체를 그리지 않음
      // (편집모드는 위 if 조건에서 걸러지므로 영향 없음)
      if (isZero) return null;

      return (
        <div style={{
          padding: "6px 0",
          fontSize: "14px",
          color: "#2d3748",
          fontWeight: "600",
          borderBottom: "1px solid #edf2f7", // 가벼운 하단 구분선
          minHeight: "32px",
          display: "flex",
          alignItems: "center",
          wordBreak: "break-all"
        }}>
          {isZero ? "정보없음" : displayValue}
        </div>
      );
    }
    const isAreaSync =
      def.state === "detail" && AREA_SYNC_FIELDS.has(fieldName);

    // 💡 값이 없거나 0, "0"인 경우 검사
    const isValueEmptyOrZero = 
      value === null || value === undefined || value === "" || value === 0 || value === "0";

    // ★ [해당호 출력 특수 로직] 상세보기 시 호수가 없으면 대체값(호수대체 -> 층대체) 적용
    let finalValue = value;
    if (fieldName === "estate_ho" && isViewMode && isValueEmptyOrZero) {
      finalValue = basic.floor_etc || basic.floor_type2 || "";
    }
    const isFinalEmpty = 
      finalValue === null || finalValue === undefined || finalValue === "" || finalValue === 0 || finalValue === "0";

    const commonProps = {
      name: fieldName,
      title: def.label, 
      // 최종 결정된 값 주입
      value: isFinalEmpty ? "" : finalValue,
      placeholder: isFinalEmpty ? def.label : "",
      disabled: isViewMode, // ★ 상세보기 모드일 때 비활성화
      onChange: isAreaSync
        ? handleDetailChange
        : (e) => setFieldValue(fieldName, e.target.value),
      className:
        isOverrideField(def.state, fieldName, applyMode)
          ? "override-highlight"
          : "",
      style: {
        width: "100%",
        boxSizing: "border-box",
        padding: "6px 8px",
        fontSize: 13,
        borderRadius: 4,
        // ★ 상세보기 모드일 때는 테두리를 연하게 하고 배경색을 회색으로 변경
        border: isViewMode ? "1px solid #e2e8f0" : `1px solid ${isError ? "#ff4d4f" : "#cbd5e0"}`,
        backgroundColor: isViewMode ? "#f1f5f9" : "#fff",
        color: isViewMode ? "#4a5568" : "#000",
        cursor: isViewMode ? "default" : "text",
      },
    };

    // owner_household(주인세대 유무)는 거래유형처럼 바 형태로 (있음/없음) 2분할
    if (fieldName === "owner_household") {
      const current = value ?? "";
      return (
        <div
          style={{
            display: "flex",
            border: "1px solid #666",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <button
            type="button"
            onClick={() => setFieldValue("owner_household", "y")}
            style={{
              flex: 1,
              padding: "6px 0",
              fontSize: 12,
              cursor: "pointer",
              backgroundColor: current === "y" ? "#333" : "#fff",
              color: current === "y" ? "#fff" : "#333",
              border: "none",
              borderRight: "1px solid #666",
            }}
          >
            주인세대 있음
          </button>
          <button
            type="button"
            onClick={() => setFieldValue("owner_household", "n")}
            style={{
              flex: 1,
              padding: "6px 0",
              fontSize: 12,
              cursor: "pointer",
              backgroundColor: current === "n" ? "#333" : "#fff",
              color: current === "n" ? "#fff" : "#333",
              border: "none",
            }}
          >
            주인세대 없음
          </button>
        </div>
      );
    }

    // Y/N 체크박스 타입 공통 처리
    if (def.type === "checkbox") {
      const checked = value === "y";

      // 상세정보 필드는 별도 헬퍼 사용
      if (def.state === "detail") {
        return (
          <label
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 13,
            }}
          >
            <input
              type="checkbox"
              name={fieldName}
              checked={checked}
              onChange={handleDetailCheckbox(fieldName)}
            />
            <span>예</span>
          </label>
        );
      }

      // 다중선택 체크박스 (거래유형)
      if (def.type === "multi-check") {
        const checked = value === "y";
        return (
          <label
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 13,
            }}
          >
            <input
              type="checkbox"
              name={fieldName}
              checked={checked}
              onChange={(e) =>
                setFieldValue(fieldName, e.target.checked ? "y" : "n")
              }
            />
            <span>{RENT_TYPE_MULTI_LABELS[fieldName]}</span>
          </label>
        );
      }


      // basic/form 등은 공통 setter 사용
      return (
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            fontSize: 13,
          }}
        >
          <input
            type="checkbox"
            name={fieldName}
            checked={checked}
            onChange={(e) =>
              setFieldValue(fieldName, e.target.checked ? "y" : "n")
            }
          />
          <span>예</span>
        </label>
      );
    }

    // 계약상태 및 노출상태 토글 처리 (이미지 기반 스위치 디자인 적용)
    if (def.type === "rent-toggle" || def.type === "use-toggle") {
      const isY = value === "y";
      const isUseYn = fieldName === "use_yn";
      const isContract = fieldName === "contract_yn";
      const isMgmtYn = fieldName === "price_mgr_yn";
      
      // 관리비(price_mgr_yn)는 기존 버튼 스타일 유지, contract/use만 스위치 적용
      if (isContract || isUseYn) {
        let labelText = "";
        if (isContract) labelText = isY ? "계약가능" : "계약불가";
        else if (isUseYn) labelText = isY ? "노출중" : "노출중지";

        return (
          <div 
            style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", userSelect: "none" }} 
            onClick={() => setFieldValue(fieldName, isY ? "n" : "y")}
          >
            {/* 스위치 컨테이너 */}
            <div style={{
              width: "64px",
              height: "30px",
              backgroundColor: isY ? "#2b6cb0" : "#9e9e9e", // ON: 주황색, OFF: 회색
              borderRadius: "20px",
              position: "relative",
              display: "flex",
              alignItems: "center",
              transition: "all 0.3s ease"
            }}>
              {/* 배경 내부 텍스트 (ON/OFF) */}
              <span style={{
                fontSize: "11px",
                fontWeight: "bold",
                color: "#fff",
                width: "100%",
                textAlign: isY ? "left" : "right",
                paddingLeft: isY ? "8px" : "0",
                paddingRight: isY ? "0" : "8px"
              }}>
                {isY ? "ON" : "OFF"}
              </span>

              {/* 스위치 핸들(흰색 원) */}
              <div style={{
                width: "24px",
                height: "24px",
                backgroundColor: "#fff",
                borderRadius: "50%",
                position: "absolute",
                left: isY ? "37px" : "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
                fontSize: "9px",
                fontWeight: "bold",
                color: isY ? "#2b6cb0" : "#9e9e9e"
              }}>

              </div>
            </div>
            
            {/* 우측 설명 라벨 (y/n 값 병기) */}
            <span style={{ fontSize: "13px", fontWeight: "600", color: "#333" }}>
              {labelText}
            </span>
          </div>
        );
      }

      // 기존 관리비 버튼 로직 (그대로 유지)
      let activeColor = isY ? "#2b6cb0" : "#888";
      let label = isY ? "관리비 별도" : "관리비 포함";

      return (
        <button
          type="button"
          onClick={() => setFieldValue(fieldName, isY ? "n" : "y")}
          style={{
            padding: "6px 12px",
            fontSize: 12,
            borderRadius: 4,
            cursor: "pointer",
            fontWeight: "600",
            width: "100%",
            border: `1px solid ${activeColor}`,
            backgroundColor: isY ? activeColor : "#fff",
            color: isY ? "#fff" : activeColor,
            transition: "all 0.2s"
          }}
        >
          {label}
        </button>
      );
    }

    // 등록자메모(register_memo)는 textarea로 출력
    if (fieldName === "register_memo") {
      return (
        <textarea
          name={fieldName}
          disabled={isViewMode} // ★ 추가
          value={value ?? ""}
          placeholder={def.label}
          onChange={(e) => setFieldValue(fieldName, e.target.value)}
          style={{
            width: "100%",
            minHeight: "100px", // 초기 높이 설정
            padding: "8px",
            fontSize: "13px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            resize: "vertical", // 사용자가 높이 조절 가능
            boxSizing: "border-box",
            lineHeight: "1.5"
          }}
        />
      );
    }


    // 단일 선택 드롭다운
    if (def.type === "select") {
      let options = getSelectOptions(fieldName);
      const current = value ?? "";

      // 용도지역(use_district) 및 방향(estate_direction) 특수 처리
      const isTargetField = fieldName === "use_district" || fieldName === "estate_direction";
      
      if (isTargetField) {
        const isEmpty = current === "" || current === 0 || current === "0";
        const placeholderLabel = fieldName === "use_district" ? "용도지역 선택" : "방향 선택";
        
        // 첫 번째 옵션 텍스트를 선택 문구로 변경
        options = options.map((opt, idx) => 
          idx === 0 ? { ...opt, label: placeholderLabel } : opt
        );

        return (
          <select
            name={fieldName}
            disabled={isViewMode} // ★ 핵심 수정: select 비활성화
            value={isEmpty ? "" : current}
            onChange={(e) => setFieldValue(fieldName, e.target.value)}
            style={{ 
              ...commonProps.style, 
              width: "100%",
              // 값이 없을 때 강조색 (연한 노란색 계열)
              backgroundColor: isViewMode ? "#f1f5f9" : (isEmpty ? "#fffbe6" : "#fff"), // ★ 잠김 시 회색
              borderColor: isEmpty ? "#ffe58f" : "#ddd",
              cursor: isViewMode ? "not-allowed" : "default" // ★ 커서 변경
            }}
          >
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        );
      }
      
      const hasValue =
        current && options.some((opt) => opt.value === current);
      const finalOptions = hasValue
        ? options
        : current
        ? [...options, { value: current, label: current }]
        : options;

      return (
        <select
          ref={fieldRefs[fieldName]}
          name={fieldName}
          disabled={isViewMode} // ★ 추가
          value={current}
          onChange={(e) => {
            setFieldValue(fieldName, e.target.value);
            if (e.target.value) {
              setErrors(prev => {
                const newErrs = { ...prev };
                delete newErrs[fieldName];
                return newErrs;
              });
              // 값이 채워지면 다음 필수 필드(준공일)로 포커스 이동 시도
              if (fieldName === "estate_type") fieldRefs.completion_year.current?.focus();
            }
          }}
          style={{ ...commonProps.style, ...errorStyle }}
        >
          {finalOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }

    if (def.type === "number") {
      return (
        <input
          type="text"
          inputMode="decimal"
          pattern="^-?[\d,]*\.?\d*$"
          name={fieldName}
          {...commonProps}
          value={commaView(value)}
          onChange={(e) => {
            const v = String(e.target.value).replace(/,/g, "");
            if (v === "") {
              if (isAreaSync) { e.target.value = ""; handleDetailChange(e); }
              else { setFieldValue(fieldName, ""); }
              return;
            }
            if (!/^-?\d*\.?\d*$/.test(v)) return;
            if (isAreaSync) { e.target.value = v; handleDetailChange(e); }
            else { setFieldValue(fieldName, v); }
          }}
        />
      );
    }
    if (def.type === "date") {
      return (
        <input 
          ref={fieldRefs[fieldName]}
          type="date" 
          {...commonProps} 
          style={{ ...commonProps.style, ...errorStyle }}
          onChange={(e) => {
            commonProps.onChange(e);
            if (e.target.value) {
              setErrors(prev => {
                const newErrs = { ...prev };
                delete newErrs[fieldName];
                return newErrs;
              });
            }
          }}
        />
      );
    }
    return <input type="text" {...commonProps} />;
  };

  // 상세정보 탭에서 전체필드의 나머지 컬럼들을 편집하기 위한 추가 상태
  const [detailExtra, setDetailExtra] = useState({});

  const [saving, setSaving] = useState(false);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false); // ★ 저장 확인 팝업 상태
  const [tab, setTab] = useState("info"); // "info" | "full"
  const [buildingOpen, setBuildingOpen] = useState(false);

  // ★ 지도 오버레이 열림 상태
  const [mapOpen, setMapOpen] = useState(false);

  // 건물정보(공공데이터) 상태
  const [buildingInfo, setBuildingInfo] = useState(null);
  const [buildingInfoLoading, setBuildingInfoLoading] = useState(false);
  const [buildingInfoError, setBuildingInfoError] = useState("");
  const [buildingSelectedHo, setBuildingSelectedHo] = useState("");
  const [pnuCandidates, setPnuCandidates] = useState([]);
  const [buildingCachedAt, setBuildingCachedAt] = useState(null); // ✅ 캐시 날짜

  const handleFetchBuildingInfo = async () => {
    try {
      setBuildingInfo(null);
      setBuildingInfoError("");
      setBuildingInfoLoading(true);
      setBuildingCachedAt(null); // ✅ 초기화

      const params = new URLSearchParams();
      // ✅ pnu 최우선 사용 (캐시 HIT 가능성 높음)
      if (estate?.pnu || basic?.pnu) {
        params.append("pnu", estate?.pnu || basic?.pnu);
      } else {
        if (basic.roadAddress) params.append("roadAddress", basic.roadAddress);
        if (basic.jibunAddress) params.append("jibunAddress", basic.jibunAddress);
      }

      // 좌표가 있으면 같이 보냄
      const lat = detail.lat || basic.lat || estate?.lat;
      const lng = detail.lng || basic.lng || estate?.lng;
      if (lat && lng) {
        params.append("lat", lat);
        params.append("lng", lng);
      }

      const res = await fetch(`/api/building-info?${params.toString()}`);
      const data = await res.json();

      // building / stations 를 반드시 분리하여 저장
      setBuildingInfo({
        data: data.data ?? null,
        building: data.data?.recapTitle ? { ...data.data.recapTitle, dongList: data.data.dongList, vworldShareList: data.data.vworldShareList } : null,
        stations: Array.isArray(data.stations) ? data.stations : [],
        providers: data.providers ?? {},
        ok: data.ok,
        error: data.error,
        raw: data,
      });

      // ✅ 캐시 날짜 저장
      if (data.cached && data.cached_at) {
        setBuildingCachedAt(data.cached_at);
      }

      if (!data.ok) {
        if (data.reason === "MULTIPLE_PNU") {
          setPnuCandidates(data.candidates);
          setBuildingInfoError("지번이 여러 개입니다. 하나를 선택하세요.");
          return;
        }
        setBuildingInfoError(data.error || "조회 실패");
        return;
      }
    } catch (e) {
      setBuildingInfoError(e.message || "조회 실패");
      setBuildingInfo(null);
    } finally {
      setBuildingInfoLoading(false);
    }
  };

  // ✅ 최신정보 강제 조회 (캐시 무시하고 API 직접 호출)
  const handleRefreshBuildingInfo = async () => {
    try {
      setBuildingInfo(null);
      setBuildingInfoError("");
      setBuildingInfoLoading(true);
      setBuildingCachedAt(null);

      const params = new URLSearchParams();
      if (estate?.pnu || basic?.pnu) {
        params.append("pnu", estate?.pnu || basic?.pnu);
      } else {
        if (basic.roadAddress) params.append("roadAddress", basic.roadAddress);
        if (basic.jibunAddress) params.append("jibunAddress", basic.jibunAddress);
      }

      const res = await fetch(`/api/building-info/refresh?${params.toString()}`);
      const data = await res.json();

      setBuildingInfo({
        data: data.data ?? null,
        building: data.data?.recapTitle ? { ...data.data.recapTitle, dongList: data.data.dongList, vworldShareList: data.data.vworldShareList } : null,
        stations: Array.isArray(data.stations) ? data.stations : [],
        providers: data.providers ?? {},
        ok: data.ok,
        error: data.error,
        raw: data,
      });

      if (!data.ok) {
        setBuildingInfoError(data.error || "최신 조회 실패");
      }
    } catch (e) {
      setBuildingInfoError(e.message || "최신 조회 실패");
      setBuildingInfo(null);
    } finally {
      setBuildingInfoLoading(false);
    }
  };

  const handleSelectHoFromBuilding = useCallback(
    (hoNo) => {
      setBasic((prev) => ({
        ...prev,
        estate_ho: hoNo || "",
      }));
    },
    [setBasic]
  );

/**
 * override 모드에서 덮어쓸 필드 화이트리스트
 * key는 EstateEditor 내부 필드명 기준
 */
const OVERRIDE_FIELDS = {
  basic: new Set([
    "estate_name",
    "estate_dong",
    "estate_ho",
    "floor",
    "lat",
    "lng",
  ]),



  detail: new Set([
    // 면적
    "exclusive_scale",
    "common_area_m2",
    "site_amount",
    "site_scale",
    "totArea",

    // 건물 규모
    "bld_scale",
    "bld_scale_under",

    // 주차 / 세대
    "parking_cnt",
    "rent_household_cnt",

   // 대지권 (지분)
   "land_share_value",
   "land_share_total",

    // 교통
    "station",
    "station_distance",
    "station_transport",

    // 준공
    "completion_year",

    // 시설(자동판단)
    "living_condition_ev",
  ]),
};

// override 대상인지 판별
 const isOverrideField = (section, field, mode) => {
   return mode === "override" &&
          OVERRIDE_FIELDS?.[section]?.has(field);
 };


  /**
    * BuildingInfoOverlay → EstateEditor 주입 전용 핸들러
    * @param {ApplyBuildingData} source
    * @param {ApplyMode} mode
    */
  const applyBuildingInfoToDetail = (source, mode = "ifEmpty") => {
    if (!source) return;

    // 📍 [디버깅 추가] 교체 시 넘어오는 데이터 전체 확인 (F12 콘솔에서 확인 가능)
    console.log("📍 건물정보 교체 원본 데이터:", source);
    const applyValue = (section, field, current, newVal) => {
      // 1. 현재 값과 새 값의 비어있음 여부 체크
      const isCurrentEmpty =
        current === "" || current === null || current === undefined ||
        (typeof current === "string" && current.trim() === "");

      const isNewEmpty = 
        newVal === "" || newVal === null || newVal === undefined ||
        (typeof newVal === "string" && newVal.trim() === "");

      console.log("[APPLY VALUE]", { section, field, current, newVal, mode });

      // 2. 교체 실행(override) 모드인 경우
      if (mode === "override") {
        const allowed = OVERRIDE_FIELDS[section]?.has(field);
        // ★ 핵심: 허용된 필드이면서, 새로운 데이터가 비어있지 않을 때만 교체
        return (allowed && !isNewEmpty) ? newVal : current;
      }

      // 3. 미입력분 채우기(ifEmpty) 모드인 경우
      if (isCurrentEmpty && !isNewEmpty) {
        return newVal;
      }
      if (current === "" || current === null || current === undefined) {
        return newVal;
      }
      // ★ isEmpty를 isCurrentEmpty로 수정
      return isCurrentEmpty ? newVal : current;
    };

    // 1) 기본정보 (basic) 주입 — building
    setBasic((prev) => ({
      ...prev,
      // [BLD_NAME_KEEP_V1] 건물명은 교체(override) 모드에서도 "매물장이 비어 있을 때만" 대장 이름 사용.
      //   대장 건물명은 비었거나 "○○빌라 A동"처럼 매물장 표기와 달라 덮어쓰면 목록 이름이 바뀜.
      //   서버 동기화(backend/routes/buildingSync.js)의 estate_name 규칙과 동일하게 맞춤.
      estate_name: String(prev.estate_name ?? "").trim()
        ? prev.estate_name
        : (String(source.building?.name ?? "").trim() || prev.estate_name),
      estate_dong: applyValue("basic", "estate_dong", prev.estate_dong, source.building?.dong),
      estate_ho: applyValue("basic", "estate_ho", prev.estate_ho, source.building?.ho),
      floor: applyValue("basic", "floor", prev.floor, source.building?.floor),
      // [BLD_PURPOSE_V1] 건물용도(bld_type)·상세용도(bld_type_etc) 자동 입력
      //   주용도 출처: 해당 호 주용도 → 없으면 건물 주용도 (BuildingInfoOverlay buildApplyData 의 purpose)
      //   ① 주용도가 BLD_TYPE_OPTIONS 목록에 있으면 → 그 코드 선택 (다가구주택 → multi-household)
      //        호가 없을 때만 건물 상세용도를 bld_type_etc 에
      //   ② 목록에 없으면 → bld_type 그대로, bld_type_etc 에 "주용도(상세용도)" 글자
      //        (선택칸에 목록 밖 글자를 넣으면 수정화면 드롭다운이 빈칸이 되므로)
      //   적용(ifEmpty)=빈칸만 / 교체(override)=덮어씀. OVERRIDE_FIELDS 는 거치지 않음
      //   bld_type_etc 는 varchar(50) → 50자에서 자름
      ...(() => {
        const p = source.purpose || {};
        const hoP   = String(p.ho   || "").trim();
        const mainP = String(p.main || "").trim();
        const etcP  = String(p.etc  || "").trim();
        const purpose = hoP || mainP;
        if (!purpose) return {};
        const detailTxt = hoP ? "" : etcP;           // 건물 상세용도는 호가 없을 때만 사용
        const norm = (t) => String(t).replace(/\s+/g, "");
        const opt = BLD_TYPE_OPTIONS.find((o) => o.value && norm(o.label) === norm(purpose));
        const ow = mode === "override";
        const curType = String(prev.bld_type ?? "").trim();
        const curEtc  = String(prev.bld_type_etc ?? "").trim();
        const out = {};
        if (opt) {
          if (ow || !curType) out.bld_type = opt.value;
          if (detailTxt && norm(detailTxt) !== norm(purpose) && (ow || !curEtc))
            out.bld_type_etc = detailTxt.slice(0, 50);
        } else {
          const txt = (detailTxt && norm(detailTxt) !== norm(purpose))
            ? `${purpose}(${detailTxt})` : purpose;
          if (ow || !curEtc) out.bld_type_etc = txt.slice(0, 50);
        }
        return out;
      })(),
    }));

    // 2) 상세정보 (detail) 주입 — area / stats / location
    setDetail((prev) => {
      console.log("[APPLY START]", {
        mode,
        buildingStats: source?.buildingStats,
        parkingTotal: source?.buildingStats?.parkingTotal,
        householdCount: source?.buildingStats?.householdCount,
        completionDate: source?.building?.completionDate,
      });
      const next = { ...prev };

      // 면적
      next.exclusive_scale = applyValue(
        "detail",
        "exclusive_scale",
        prev.exclusive_scale,
        source.area?.private
      );
      if (next.exclusive_scale && !prev.exclusive_scale_square) {
        next.exclusive_scale_square = m2ToPyeong(next.exclusive_scale);
      }

      next.common_area_m2 = applyValue(
        "detail",
        "common_area_m2",
        prev.common_area_m2,
        source.area?.public
      );
      if (next.common_area_m2 && !prev.common_area_square) {
        next.common_area_square = m2ToPyeong(next.common_area_m2);
      }

      next.site_amount = applyValue(
        "detail",
        "site_amount",
        prev.site_amount,
        source.area?.land
      );
      if (next.site_amount && !prev.site_amount_square) {
        next.site_amount_square = m2ToPyeong(next.site_amount);
      }

      next.site_scale = applyValue(
        "detail",
        "site_scale",
        prev.site_scale,
        source.landShare?.value
      );
      if (next.site_scale && !prev.site_scale_square) {
        next.site_scale_square = m2ToPyeong(next.site_scale);
      }

      next.totArea = applyValue(
        "detail",
        "totArea",
        prev.totArea,
        source.area?.total
      );

      // [USE_DISTRICT_AUTO_V1] 용도지역 자동 입력 — 건물정보 적용/교체 공통
      //   규칙: 현재 값이 USE_DISTRICT_OPTIONS 의 유효 코드(ud11 등)면 그대로 둠 (교체 모드여도 유지)
      //         빈칸·"0"·한글 이름 등 무효 값이면
      //           → ① 대장 용도지역(source.zoning.names) 중 코드표에 있는 첫 번째
      //           → ② 없으면 현재 한글 이름을 코드로 변환 (예: 제2종일반주거지역 → ud14)
      //   출처: BuildingInfoOverlay.jsx buildApplyData() 의 zoning
      //   서버 동일 규칙: gongsilRegister.js toUseDistrictCode() · buildingSync.js
      {
        const validCodes = new Set(USE_DISTRICT_OPTIONS.map((o) => o.value).filter(Boolean));
        const cur = String(prev.use_district ?? "").trim();
        if (!validCodes.has(cur)) {
          // 이름 → 코드표 (옵션 목록의 label 그대로 사용 · 중복 '전용공업지역'은 먼저 나오는 ud26)
          const nameToCode = {};
          USE_DISTRICT_OPTIONS.forEach((o) => {
            if (o.value && !(o.label in nameToCode)) nameToCode[o.label] = o.value;
          });
          // "제2종 일반주거지역", "제2종일반주거" 같은 변형도 받음 (서버 toUseDistrictCode 와 동일)
          const toCode = (n) => {
            const t = String(n || "").replace(/\s+/g, "");
            if (!t) return null;
            return nameToCode[t] || (!/지역$/.test(t) && nameToCode[t + "지역"]) || null;
          };
          let code = null;
          for (const n of source.zoning?.names || []) {
            code = toCode(n);
            if (code) break;
          }
          if (!code) code = toCode(cur);
          if (code) next.use_district = code;
        }
      }

      // 건물 규모
      next.bld_scale = applyValue(
        "detail",
        "bld_scale",
        prev.bld_scale,
        source.buildingStats?.groundFloors
      );

      next.bld_scale_under = applyValue(
        "detail",
        "bld_scale_under",
        prev.bld_scale_under,
        source.buildingStats?.undergroundFloors
      );

      // 주차 / 세대 / 승강기
      next.parking_cnt = applyValue(
        "detail",
        "parking_cnt",
        prev.parking_cnt,
        source.buildingStats?.parkingTotal
      );

      next.rent_household_cnt = applyValue(
        "detail",
        "rent_household_cnt",
        prev.rent_household_cnt,
        source.buildingStats?.householdCount
      );

      const evValue =
        Number(source.buildingStats?.elevatorCount) > 0 ? "y" : "n";

        if (source.buildingStats?.elevatorCount !== undefined) {
          if (mode === "override" || !prev.living_condition_ev) {
            next.living_condition_ev =
              Number(source.buildingStats.elevatorCount) > 0 ? "y" : "n";
          }
        }

      // 대지권 (지분)
      if (source.landShare) {
        next.land_share_value = applyValue(
          "detail",
          "land_share_value",
          prev.land_share_value,
          source.landShare.value
        );

        next.land_share_total = applyValue(
          "detail",
          "land_share_total",
          prev.land_share_total,
          source.landShare.total
        );
      }

      // 준공일 (override / ifEmpty 분기 통합)
      {
        const incoming = normalizeDate(source.building?.completionDate);
        next.completion_year = applyValue(
          "detail",
          "completion_year",
          prev.completion_year,
          incoming
        );
      }
      // 교통
      if (source.location?.station) {
        next.station = applyValue(
          "detail",
          "station",
          prev.station,
          source.location.station.name
        );
        next.station_distance = applyValue(
          "detail",
          "station_distance",
          prev.station_distance,
          source.location.station.walkMin
        );
        if (!prev.station_transport) {
          next.station_transport =
            Number(source.location.station.walkMin) <= 17 ? "도보" : "";
        }
      }

      // 📍 [수정] 좌표 업데이트 안전장치 강화
      setBasic((prevBasic) => {
        // 1. 새로 들어온 값이 유효한 숫자인지, 0은 아닌지 엄격하게 검사
        const incomingLat = source.location?.lat;
        const incomingLng = source.location?.lng;
        
        // 숫자로 변환했을 때 유효하고(Not NaN), 0이 아닐 때만 새 값 후보로 인정
        const isValidNewLat = incomingLat && Number(incomingLat) !== 0;
        const isValidNewLng = incomingLng && Number(incomingLng) !== 0;

        // 2. 모드(override/ifEmpty)와 유효성을 결합하여 최종 결정
        let finalLat = prevBasic.lat;
        let finalLng = prevBasic.lng;

        if (mode === "override") {
          // 교체 모드일 때: 새 값이 유효할 때만 교체, 아니면 기존 값 유지
          finalLat = isValidNewLat ? Number(incomingLat) : prevBasic.lat;
          finalLng = isValidNewLng ? Number(incomingLng) : prevBasic.lng;
        } else {
          // 채우기 모드일 때: 기존 값이 없을 때만 새 유효값으로 채움
          const isCurrentEmpty = !prevBasic.lat || prevBasic.lat === 0;
          if (isCurrentEmpty && isValidNewLat) finalLat = Number(incomingLat);
          if (isCurrentEmpty && isValidNewLng) finalLng = Number(incomingLng);
        }

        console.log(`[COORD_SYNC] Mode: ${mode} | Final: ${finalLat}, ${finalLng}`);

        return {
          ...prevBasic,
          lat: finalLat,
          lng: finalLng,
        };
      });

      return next;
    });
  };

  // 에디터 열릴 때마다 현재 estate 값으로 초기화
  useEffect(() => {
    if (!open || !estate) return;

    const isCopy = mode === "copy";

    // JSON 파싱 헬퍼 함수
    const parseJSON = (data) => {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (typeof data === 'string') {
        try { return JSON.parse(data); } catch (e) { return []; }
      }
      return [];
    };

    // ★ 신규 등록 모드이거나 전달받은 estate 정보가 없으면 번호를 null로 강제 초기화
      const dbOwners = parseJSON(estate.owners);
      const dbTenants = parseJSON(estate.tenants);
      const isNewRecord = !estate || !estate.estate_no;

    if (isNewRecord) {
      setEstateNo(null);
    } else {
      setEstateNo(estate.estate_no);
    }
    // ◆gemini테스트코드 2026.01.01 ◆ console.log("서버에서 받은 데이터:", estate);

  console.log("[EstateEditor estate RAW]", estate);
  console.log("[EstateEditor price fields]", {
    bld_type_etc: estate.bld_type_etc,
    estate_direction: estate.estate_direction,
    price_bunyang: estate.price_bunyang,
    price_deposit: estate.price_deposit,
    price_mgr_yn: estate.price_mgr_yn,
    price_posible: estate.price_posible,
    price_investment: estate.price_investment,
  });

    setForm({
      ...estate, // 기존 모든 DB 필드 기본 복사
      use_yn: estate.use_yn || "y",
      // ★ 수정: 복사 모드이거나 신규 등록일 때는 무조건 "y"로 설정
      contract_yn: (mode === "copy" || !estate.estate_no) ? "y" : (estate.contract_yn || "y"),
      grade_condition: estate.grade_condition || "",
      register_memo: estate.register_memo || "",
      resident_memo: estate.resident_memo || "",
      // 📍 [초기화] 복사 시 리스트용 썸네일 정보 완전 삭제
      thumb_url: isCopy ? "" : (estate.thumb_url || ""),
      thumb_file_id: isCopy ? null : (estate.thumb_file_id || null),
      url: isCopy ? "" : (estate.url || ""),
      // 📍 핵심: 배열 데이터 우선 순위 적용
      owners: dbOwners, // [CONTACT_LEGACY_OFF_V1] 구방식 칸은 수정칸에 안 채움 (일부러 비운 연락처가 되살아나던 문제) — 상세보기에 참고 표시만
      tenants: isCopy ? [] : dbTenants,
      // 기존 구형 필드 유지 (호환용)
      contact_name1: estate.contact_name1 || "",
      contact_phone1: estate.contact_phone1 || "",
      contact_name2: estate.contact_name2 || "",
      contact_phone2: estate.contact_phone2 || "",
      contact_name3: estate.contact_name3 || "",
      contact_phone3: estate.contact_phone3 || "",
      contact_name4: estate.contact_name4 || "",
      contact_phone4: estate.contact_phone4 || "",
      contact_name5: estate.contact_name5 || "",
      contact_phone5: estate.contact_phone5 || "",
    });
    
    setTab("info"); // 새로 열릴 때는 항상 간단정보 탭부터

 setBasic((prev) => ({
   ...prev,
      estate_name: estate.estate_name || "",
      shop_name: estate.shop_name || "",
      estate_type: estate.estate_type || "",
      estate_dong: isCopy ? "" : (estate.estate_dong || ""),
      estate_ho: isCopy ? "" : (estate.estate_ho || ""),
      bld_type: estate.bld_type || "",
      bld_structure: estate.bld_structure || "",   // [BLD_STRUCT_LOAD_V1]
      estate_direction: estate.estate_direction || estate.direction || "",
      bld_type_etc: estate.bld_type_etc || "",
      floor: isCopy ? "" : estate.floor ?? "",
      floor_type1: isCopy ? "" : estate.floor_type1 || "",
      floor_type2: isCopy ? "" : estate.floor_type2 || "",
      floor_etc: isCopy ? "" : estate.floor_etc || "",
      roadAddress: estate.roadAddress || "",
      jibunAddress: estate.jibunAddress || "",
      detailAddress: estate.detailAddress || "",
      lat: estate.lat || null,
      lng: estate.lng || null
    }));

    // 면적 초기값 계산 (어느 쪽이든 값 있으면 나머지 자동 계산)
    const exM2 = estate.exclusive_scale ?? estate.exclusive_area_m2 ?? "";
    const exPy =
      estate.exclusive_scale_square ??
      (exM2 !== "" ? m2ToPyeong(exM2) : "");

    const usedM2 = estate.used_scale ?? "";
    const usedPy =
      estate.used_scale_square ??
      (usedM2 !== "" ? m2ToPyeong(usedM2) : "");

    const commonM2 = estate.common_area_m2 ?? estate.common_area ?? "";
    const commonPy =
      estate.common_area_square ??
      (commonM2 !== "" ? m2ToPyeong(commonM2) : "");

    const siteM2 = estate.site_amount ?? "";
    const sitePy =
      estate.site_amount_square ??
      (siteM2 !== "" ? m2ToPyeong(siteM2) : "");

     const site_scaleM2 = estate.site_scale ?? "";
    const site_scalePy =
      estate.site_scale_square ??
      (site_scaleM2 !== "" ? m2ToPyeong(site_scaleM2) : "");     

    // 연면적(㎡) snake_case / camelCase 흡수
    const totArea =
      estate.totArea ??
      estate.tot_area ??
      "";


    // 상세정보 초기값
 setDetail((prev) => ({
   ...prev,

      elec_condition_refrigerator: estate.elec_condition_refrigerator ?? "",
      elec_condition_washer: estate.elec_condition_washer ?? "",
      elec_condition_air_conditioner: estate.elec_condition_air_conditioner ?? "",
      elec_condition_cook: estate.elec_condition_cook ?? "",
      elec_condition_microwave: estate.elec_condition_microwave ?? "",
      elec_condition_tv: estate.elec_condition_tv ?? "",

      totArea: totArea,
      totArea_square: estate?.totArea_square ?? "", // [TOTAREA_SQ_LOAD_V1] 안 불러와 확인창에 「→ 빈값」으로 보이던 것
      //거래유형
      rent_type_4deal: isCopy ? "n" :estate.rent_type_4deal ?? "",
      rent_type_1year: isCopy ? "n" :estate.rent_type_1year ?? "",
      rent_type_2month: isCopy ? "n" :estate.rent_type_2month ?? "",
      rent_type_3short: isCopy ? "n" :estate.rent_type_3short ?? "",
      rent_type_5sale: isCopy ? "n" :estate.rent_type_5sale ?? "",
      rent_type_6auction: isCopy ? "n" :estate.rent_type_6auction ?? "",

      // 금액
      price_sale: isCopy ? "" :estate.price_sale ?? "",
      price_bunyang: isCopy ? "" :estate.price_bunyang ?? "",     // 분양가
      price_deposit: isCopy ? "" :estate.price_deposit ?? "",     // 보증금
      price_posible: isCopy ? "" :estate.price_posible ?? "",     // 협의가
      price_investment: isCopy ? "" :estate.price_investment ?? "", // 실투자금
      price_mgr_yn: mode === "copy" ? "y" : (estate.price_mgr_yn ?? "y"),      // 관리비 별도
      price_per_scale: estate.price_per_scale ?? "",
      price_premium: isCopy ? "" :estate.price_premium ?? "",
      price_sum: isCopy ? "" :estate.price_sum ?? "",
      price_per_household: estate.price_per_household ?? "",
      mortgage: isCopy ? "" :estate.mortgage ?? "",
      fee_jeonse: isCopy ? "" :estate.fee_jeonse ?? "", // ★ 추가
      fee_year: isCopy ? "" :estate.fee_year ?? "",
      fee_month: isCopy ? "" :estate.fee_month ?? "",
      f_price_total_mgr: estate.f_price_total_mgr ?? "",
      price_mgr_item_basic: estate.price_mgr_item_basic ?? "",
      price_mgr_item_water: estate.price_mgr_item_water ?? "",
      price_mgr_item_internet: estate.price_mgr_item_internet ?? "",
      price_mgr_item_online: estate.price_mgr_item_online ?? "",
      price_mgr_item_heat: estate.price_mgr_item_heat ?? "",
      price_mgr_item_elec: estate.price_mgr_item_elec ?? "",
      // 면적
      exclusive_scale: isCopy ? "" :exM2,
      exclusive_scale_square: isCopy ? "" :exPy,
      used_scale: usedM2,
      used_scale_square: usedPy,
      common_area_m2: commonM2,
      common_area_square: commonPy,
      site_amount: siteM2,
      site_amount_square: sitePy,
      site_scale: site_scaleM2,
      site_scale_square: site_scalePy,
      use_district: estate.use_district ?? "",
      // 방/욕실/층/주차/기타
      room_cnt: isCopy ? "" : estate.room_cnt ?? "",
      bath_cnt: isCopy ? "" : estate.bath_cnt ?? "",
      bld_scale_under: estate.bld_scale_under ?? "",
      bld_scale: estate.bld_scale ?? "",
      parking_cnt: estate.parking_cnt ?? "",
      parking_fee: estate.parking_fee ?? "",
      completion_year: normalizeDate(estate.completion_year),


      // 주인세대
      owner_household: estate.owner_household === "y" ? "y" : "n",
      owner_room: estate.owner_room ?? "",
      owner_bath: estate.owner_bath ?? "",
      rent_household_cnt: estate.rent_household_cnt ?? "",

      // 시설/상태
      living_condition_ev: estate.living_condition_ev ?? "",
      living_condition_terrace: estate.living_condition_terrace ?? "",
      internal_condition_interior: estate.internal_condition_interior ?? "",
      internal_condition_water: estate.internal_condition_water ?? "",
      internal_condition_city_gas: estate.internal_condition_city_gas ?? "",
      bath_division: estate.bath_division ?? "",
      bath_inside: estate.bath_inside ?? "",
      external_condition_exsign: estate.external_condition_exsign ?? "",
      heat_condition: estate.heat_condition ?? "",
      cold_condition: estate.cold_condition ?? "",

      // 임대/입주 서브옵션
      sale_type_sub_living: estate.sale_type_sub_living ?? "",
      sale_type_sub_rent: estate.sale_type_sub_rent ?? "",
      sale_type_rent: estate.sale_type_rent ?? "",
      sale_type_rent_year: estate.sale_type_rent_year ?? "",
      sale_type_rent_month: estate.sale_type_rent_month ?? "",

      // 교통
      station: estate.station ?? "",
      station_distance: estate.station_distance ?? "",
      station_transport: estate.station_transport ?? "",
    }));
   // 전체필드 기반 추가 필드는 매물 변경 시마다 초기화
   setDetailExtra({});

    // 📍 복사 시 사진 정보 초기화
    if (isCopy) {
      setPropertyPhotos([]);
      setGalleryPhotos([]);
    }

  }, [open, estate, mode]);

  // ★ [추가] 호수 입력에 따른 해당층 자동 추론 로직 (BuildingInfo 주입 실패 시 보완)
useEffect(() => {
  // 1. 상세보기 모드이거나 호수가 없으면 중단
  if (isViewMode || !basic.estate_ho) return;

  const ho = String(basic.estate_ho).trim().toUpperCase();
  let inferredFloor = "";

  // 2. 숫자가 시작되는 위치 찾기
  const firstDigitIndex = ho.search(/[0-9]/);
  if (firstDigitIndex === -1) return; // 숫자가 없으면 중단

  // 3. 숫자 부분만 추출
  // [FLOOR_INFER_V1] '호' 등 뒤 글자를 빼고 연속된 숫자만 (503호 → 503)
  const digitPart = (ho.substring(firstDigitIndex).match(/^[0-9]+/) || [""])[0];
  const isBasement = ho.includes('B') || ho.includes('지하');

  if (isBasement) {
    // 📍 지하층 규칙: 숫자가 3자리면 앞 1자리에 - 붙임, 2자리면 무조건 -1
    if (digitPart.length >= 3) {
      inferredFloor = `-${digitPart.substring(0, digitPart.length - 2)}`;
    } else {
      inferredFloor = "-1";
    }
  } else {
    // 📍 지상층 규칙: 숫자가 4자리면 앞 2자리, 3자리면 앞 1자리
    if (digitPart.length === 4) {
      inferredFloor = digitPart.substring(0, 2);
    } else if (digitPart.length === 3) {
      inferredFloor = digitPart.substring(0, 1);
    } else if (digitPart.length <= 2) {
      inferredFloor = "1"; // 10호, 1호 등은 1층으로 추정
    }
  }

  // 4. [핵심 수정] 기존 값이 있더라도 호수를 변경하면 즉시 반영
  // 단, 추론된 값이 유효할 때만 업데이트합니다.
  if (inferredFloor) {
    setBasic(prev => ({
      ...prev,
      floor: inferredFloor
    }));
  }
}, [basic.estate_ho, isViewMode]); // 의존성에서 basic.floor를 제거하여 실시간 변경 허용

  useEffect(() => {
    if (
      !buildingInfo ||
      !buildingInfo.ok ||
      !buildingInfo.building ||
      !Array.isArray(buildingInfo.building.hoList)
    ) {
      return;
    }

    const hoList = buildingInfo.building.hoList;
    if (!hoList.length) return;

    const currentHo = (basic.estate_ho || "").trim();

    // 1) 수정 모드: 기존 호수(B01 등)가 리스트에 있으면 그걸 우선 선택
    if (currentHo) {
      const match = hoList.find(
        (h) => String(h.hoNo || "").trim() === currentHo
      );
      if (match) {
        setBuildingSelectedHo(currentHo);
        return;
      }
    }

    // 2) 없으면 첫 번째 호수로 기본값
    setBuildingSelectedHo(String(hoList[0].hoNo || "").trim());
  }, [buildingInfo, basic.estate_ho]);

// [추가] SMS 이력 불러오기 및 팝업 오픈 시 메시지 생성
  useEffect(() => {
    if (open && estateNo && isViewMode && canEdit) {
      fetchSmsLogs();
      smsReceiverApi.getList().then(res => {
        if (res.ok) setReceivers(res.items || []);
      });
    }

if (showSmsPopup) {
      // 현재 선택된 옵션들에 기반하여 텍스트 생성
      const initialText = generateSmsText(smsOptions, { basic, detail, estate, estateNo });
      setSmsContent(initialText);
    }
  }, [open, estateNo, isViewMode, showSmsPopup, basic, detail, estate, canEdit]);

  // useEffect에 fetchSnapshotLogs 추가
  useEffect(() => {
    if (open && estateNo) {
      console.log("🚀 [Lifecycle] 데이터 로드 시작:", estateNo);
      
      // [CANEDIT_GUARD_V1] SMS·스냅샷·블로그 이력은 premium/admin 전용이다.
      // 비로그인·basic 은 해당 UI 가 숨겨지므로 호출하지 않는다.
      if (canEdit) {
        fetchSmsLogs();
        fetchSnapshotLogs();
        fetchBlogLogs();

        // 상세보기 모드 전용 로직
        if (isViewMode) {
          smsReceiverApi.getList().then(res => {
            if (res.ok) setReceivers(res.items || []);
          });
        }
      }
    }
    // ★ canEdit 은 등급을 비동기로 받아 처음엔 false 다.
    //   의존성에 넣지 않으면 관리자인데도 기능이 안 나타난다.
  }, [open, estateNo, canEdit]);

  useEffect(() => {
    const fetchAllPhotos = async () => {
      if (!estateNo) return;
      
      // 📍 핵심: 새 매물을 불러오기 전, 기존 사진 상태를 즉시 비워야 합니다.
      setPropertyPhotos([]); 
      setGalleryPhotos([]);

      try {
        const res = await authFetch(`/api/properties/public/${estateNo}`);
        const data = await res.json();
        
        if (data.ok && data.data.photos) {
          setPropertyPhotos(data.data.photos);
        }
      } catch (err) {
        console.error("사진 로드 실패:", err);
      }
    };

    if (open && estateNo) {
      fetchAllPhotos();
    }
  }, [open, estateNo]); // estateNo가 바뀔 때마다 실행됨

  // EstateEditor.jsx 내부 상단 useEffect들 모여있는 곳에 추가
  useEffect(() => {
    if (showPreviewModal && previewData?.lat && previewData?.lng) {
      const { kakao } = window;
      if (!kakao) return;

      kakao.maps.load(() => {
        // 0.1초 정도 뒤에 실행해야 DOM이 확실히 생성됨
        setTimeout(() => {
          const container = document.getElementById('preview-map');
          if (!container) return;

          const pos = new kakao.maps.LatLng(parseFloat(previewData.lat), parseFloat(previewData.lng));
          const map = new kakao.maps.Map(container, {
            center: pos,
            level: 4
          });
          new kakao.maps.Marker({ position: pos }).setMap(map);
        }, 100);
      });
    }
  }, [showPreviewModal, previewData]);


  // [추가] 블로그 모달 전용 이미지 지도(StaticMap) 생성 로직
  useEffect(() => {
    if (showBlogModal && blogPreviewData?.lat && blogPreviewData?.lng) {
      const { kakao } = window;
      if (!kakao) return;

      kakao.maps.load(() => {
        // DOM이 렌더링될 시간을 벌기 위해 setTimeout 사용
        setTimeout(() => {
          const container = document.getElementById('blog-static-map-container');
          if (!container) return;

          // 기존에 생성된 내용이 있다면 삭제 (중복 방지)
          container.innerHTML = "";

          const markerPosition = new kakao.maps.LatLng(
            parseFloat(blogPreviewData.lat), 
            parseFloat(blogPreviewData.lng)
          );

          const staticMapOption = {
            center: markerPosition,
            level: 3,
            marker: { position: markerPosition }
          };

          // 📍 카카오 공식 SDK 방식: 이미지 지도를 생성하여 container에 삽입
          const staticMap = new kakao.maps.StaticMap(container, staticMapOption);
          
          // 블로그 복사 시 지도가 너무 작게 나오지 않도록 스타일 강제 조정
          const staticImg = container.querySelector('img');
          if (staticImg) {
            staticImg.style.width = '100%';
            staticImg.style.height = 'auto';
            staticImg.style.display = 'block';
          }
        }, 200);
      });
    }
  }, [showBlogModal, blogPreviewData]);

  const fetchReceivers = async () => {
    if (!canEdit) return;
    try {
      const res = await smsReceiverApi.getList();
      if (res.ok) {
        setReceivers(res.items); // 📍 여기서 receivers가 업데이트되면 uniqueGroups도 자동 갱신됩니다.
      }
    } catch (err) { console.error("수신자 로드 실패", err); }
  };

  const fetchSmsLogs = async () => {
    try {
      const res = await authFetch(`/api/sms/logs/${estateNo}`);
      const data = await res.json();
      if (data.ok) setSmsLogs(data.logs);
    } catch (err) { console.error("SMS 이력 로드 실패", err); }
  };

const handleSmsSend = async () => {
  if (selectedIds.length === 0) return alert("전송 대상을 선택해주세요.");
  const targets = receivers.filter(r => selectedIds.includes(r.id));
  if (!window.confirm(`${targets.length}명에게 전송하시겠습니까?`)) return;

  setSmsLoading(true);
  try {
    // [1] curl 테스트할 때 썼던 상세 정보 수집
    const lines = smsContent.split('\n');
    const priceLine = lines.find(l => l.includes('■') && (l.includes('매매') || l.includes('전세') || l.includes('월세') || l.includes('단기')));
    const extractedPrice = priceLine ? priceLine.replace(/■/g, '').trim() : "가격협의";

    // [2] curl 테스트와 동일한 사진 수집 (sz=w600 고화질 처리)
    const photoUrls = (galleryPhotos.length > 0 ? galleryPhotos : (estate?.photos || []))
      .map(p => {
        let url = (typeof p === 'string') ? p : (p.url || p.path || p.thumb_url);
        return url ? url.replace(/sz=w\d+/, 'sz=w600') : null;
      }).filter(Boolean);

    // [3] ★ 터미널에서 성공했던 그 전송 방식 (POST)
    const promises = targets.map(target => 
      authFetch("/api/sms/send", {
        method: "POST",
        body: JSON.stringify({
          // 📍 1. 백엔드 변수명 1:1 매칭 (curl 데이터와 동일하게)
          propertyId: Number(estateNo),   // curl의 propertyId
          receiver: target.phone.replace(/\D/g, ""), // curl의 receiver
          receiverName: target.name || "담당자",     // curl의 receiverName
          content: smsContent,                       // curl의 content
          sender: smsSender || undefined,               // [SMS_SENDER_PICK_V1] 비면 서버가 기본번호
          
          // 📍 2. 스냅샷 데이터 필드명 매칭
          estate_name: basic.estate_name || estate?.estate_name || "매물정보",
          price_info: extractedPrice,
          roadAddress: basic.roadAddress || estate?.roadAddress || "",
          jibunAddress: basic.jibunAddress || estate?.jibunAddress || "",
          estate_ho: basic.estate_ho || "",
          floor: basic.floor || "",
          exclusive_scale: detail.exclusive_scale || "",
          photos: photoUrls,
          facilities: previewData?.facilities || [],
          lat: basic.lat || estate?.lat || 37.5665,
          lng: basic.lng || estate?.lng || 126.9780
        })
      })
    );

    // [4] 모든 전송 대기
    const results = await Promise.all(promises);
    
    // [5] 성공 여부 확인 및 리스트 즉시 갱신
    if (results.every(res => res.ok)) {
      alert("전송 및 기록 저장이 완료되었습니다.");
      setSelectedIds([]);
      
      // 📍 여기서 다시 조회를 날려야 터미널 데이터처럼 화면에 딱 뜹니다!
      await fetchSmsLogs(); 
    } else {
      alert("일부 전송 기록 저장에 실패했습니다.");
    }

  } catch (err) {
    console.error("전송 장애 발생:", err);
    alert("전송 중 오류가 발생했습니다.");
  } finally {
    setSmsLoading(false);
  }
};

// [수정] SMS 기록 삭제 핸들러
  const handleSmsDelete = async () => {
    if (!window.confirm("해당 매물의 모든 전송 기록을 초기화하시겠습니까?")) return;
    
    try {
      const res = await authFetch(`/api/sms/logs/${estateNo}`, { 
        method: "DELETE" 
      });
      
      const result = await res.json(); // 서버의 응답 메시지 확인

      if (result.ok) {
        setSmsLogs([]); // 서버 삭제 성공 시에만 프론트 상태 비우기
        alert("전송 기록이 완전히 삭제되었습니다.");
      } else {
        throw new Error(result.error || "서버 삭제 실패");
      }
    } catch (err) { 
      console.error("삭제 실패 상세:", err);
      alert(`삭제에 실패했습니다: ${err.message}`); 
    }
  };

  // 지도에서 가장 가까운 역/소요시간을 선택했을 때 detail에 반영
  const handleMapStationSelect = (info) => {
    if (!info) return;

    setDetail((prev) => ({
      ...prev,
      // 지도에서 온 값이 있으면 덮어쓰고, 없으면 기존 값 유지
      station: info.station ?? prev.station ?? "",
      station_distance:
        info.station_distance ?? info.distanceMinutes ?? prev.station_distance ?? "",
      station_transport: info.station_transport ?? info.transport ?? prev.station_transport ?? "",
    }));
  };

  const title = useMemo(() => {
    if (!estateNo) return "매물 신규 등록";
    if (mode === "copy") return "매물 복사 등록";
    if (mode === "contract") return "거래완료 처리";
    return "매물 정보 수정";
  }, [mode, estateNo]);

  const addr = useMemo(() => {
    if (!estate) return "";
    return (
      estate.roadAddress ||
      estate.jibunAddress ||
      estate.address ||
      ""
    );
  }, [estate]);

  // 전체 필드 보기용 key/value 목록
  const fullEntries = useMemo(() => {
    if (!estate) return [];
    const hiddenKeys = new Set([
      "created_at",
      "updated_at",
      "_raw",
    ]);
    return Object.entries(estate)
      .filter(([key]) => !hiddenKeys.has(key))
      .sort(([a], [b]) => a.localeCompare(b));
  }, [estate]);

  // 📍 중복 없는 그룹 목록 생성
  const uniqueGroups = useMemo(() => {
    if (!receivers || receivers.length === 0) return [];
    return [...new Set(receivers.map(r => r.group_name))].filter(Boolean);
  }, [receivers]);

 // 간단정보/상세정보 탭에서 이미 사용하는 필드 제외 + 지정 필드 제외
 const extraFieldNames = useMemo(() => {
   if (!estate) return [];

   // 이미 탭에서 쓰는 컬럼들 (간단정보 + 상세정보)
    const usedKeys = new Set([
      // meta(form)
      "use_yn","contract_yn","grade_condition",
      "contact_name1","contact_phone1",
      "contact_name2","contact_phone2",
      "contact_name3","contact_phone3",
      "contact_name4","contact_phone4",
      "contact_name5","contact_phone5",
      "register_memo",//"resident_memo",
      // "resident_name","resident_phone",

      // basic
      "estate_name","shop_name","estate_dong","estate_ho",
      "estate_type","bld_type","bld_structure","bld_type_etc",
      "floor_type1","floor_type2","floor_etc",
      "estate_direction",

      // detail - 거래/금액
      "price_sale","price_bunyang","price_deposit",
      "price_mgr_yn","price_per_scale",
      "price_investment","price_premium","price_sum",
      "price_per_household","mortgage",
      "fee_year","fee_month","price_posible","f_price_total_mgr",

      // detail - 면적/대지/지분
      "exclusive_scale","exclusive_scale_square",
      "used_scale","used_scale_square",
      "common_area_m2","common_area_square",
      "site_amount","site_amount_square",
      "site_scale","site_scale_square",
      "use_district","totArea","totArea_square",

      // detail - 구성/층/주차/준공
      "room_cnt","bath_cnt",
      "bld_scale_under","bld_scale",
      "parking_cnt","parking_fee","completion_year",
      "owner_household","owner_room","owner_bath",
      "rent_household_cnt",

      // detail - 교통
      "station","station_distance","station_transport",

      // detail - 임대/입주 옵션
      "sale_type_sub_living","sale_type_sub_rent",
      "sale_type_rent","sale_type_rent_year","sale_type_rent_month",

      // detail - 시설/상태
      "living_condition_ev","living_condition_terrace",
      "internal_condition_interior","internal_condition_water",
      "internal_condition_city_gas",
      "bath_division","bath_inside",
      "external_condition_exsign",
      "heat_condition","cold_condition",
    ]);

   // 요구사항에서 제외하라고 한 컬럼 + 시스템용
  const excludeKeys = new Set([
    "thumb_file_id",
    "thumb_url",
    "url",
    "use_yn",   // 이미 meta 탭에서 사용
    "created_at",
    "updated_at",
    "_raw",
    // 시스템 정보 (읽기전용) - 헤더에서만 표시
    "estate_no",
    "estate_id",
    "branch_id",
    "register_id",
    "update_id",
    "register_date",
    "update_date",
  ]);

   return Object.keys(estate)
     .filter((key) => !usedKeys.has(key) && !excludeKeys.has(key))
     .sort((a, b) => a.localeCompare(b));
 }, [estate]);

  const handleRadioChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 날짜 데이터 표준화: 백엔드에서 온 문자열을 가공 없이 10자리만 자릅니다.
  const normalizeDate = (v) => {
    if (!v) return "";
    // 문자열이면 그대로, 객체면 강제 변환 없이 날짜 부분만 추출 (성공했던 코드)
    const dateStr = (v instanceof Date) ? v.toLocaleDateString('sv-SE') : String(v);
    return String(v).slice(0, 10);
  };

  const handleBasicChange = (e) => {
    const { name, value } = e.target;
    setBasic((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDetailCheckbox = (name) => (e) => {
    setDetail((prev) => ({
      ...prev,
      [name]: e.target.checked ? "y" : "n",
    }));
  };

  // 상세정보 변경  면적 상호 변환
  const handleDetailChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => {
      const next = { ...prev, [name]: value };

      if (name === "exclusive_scale") {
        next.exclusive_scale_square = value === "" ? "" : m2ToPyeong(value);
      } else if (name === "exclusive_scale_square") {
        next.exclusive_scale = value === "" ? "" : pyeongToM2(value);
      } else if (name === "used_scale") {
        next.used_scale_square = value === "" ? "" : m2ToPyeong(value);
      } else if (name === "used_scale_square") {
        next.used_scale = value === "" ? "" : pyeongToM2(value);
      } else if (name === "common_area_m2") {
        next.common_area_square = value === "" ? "" : m2ToPyeong(value);
      } else if (name === "common_area_square") {
        next.common_area_m2 = value === "" ? "" : pyeongToM2(value);
      } else if (name === "site_amount") {
        next.site_amount_square = value === "" ? "" : m2ToPyeong(value);
      } else if (name === "site_amount_square") {
        next.site_amount = value === "" ? "" : pyeongToM2(value);
      } else if (name === "site_scale") {
        next.site_scale_square = value === "" ? "" : m2ToPyeong(value);
      } else if (name === "site_scale_square") {
        next.site_scale = value === "" ? "" : pyeongToM2(value);
      }

      return next;
    });
  };

  // 최종 저장: meta  basic  detail 모두 한 번에 저장
  // ══════ [PRICE_AUTO_V1] 금액 자동 계산 (2026-10-08) ══════
  //   수정모드에서만. 재료 값이 바뀔 때마다 다시 계산해 detail 에 넣음 → 저장 시 그대로 DB 로.
  //   재료가 부족해 계산할 수 없으면 기존 값을 지우지 않고 그대로 둠 (옛 매물 보호)
  //   수익성: 평당가 = 매매가 ÷ 대지평수(대지평수 → 대지㎡/3.3058 → 지분평수 순)  [만원, 반올림]
  //           실투자금 = 매매가 − 현재거주보증금 − 근저당
  //   상업용·업무용: 권리+보증금 합계 = 월세보증금(fee_year) + 권리금
  //   DB 금액 칸은 varchar → 콤마 제거 후 숫자 변환, 결과는 문자열로 저장
  useEffect(() => {
    if (isViewMode) return;
    const t = String(basic.estate_type || "");
    const n = (v) => { const x = Number(String(v ?? "").replace(/,/g, "")); return Number.isFinite(x) ? x : 0; };
    const upd = {};
    if (t === "profit") {
      const sale = n(detail.price_sale);
      let py = n(detail.site_amount_square);
      if (!py && n(detail.site_amount)) py = n(detail.site_amount) / 3.3058;
      if (!py) py = n(detail.site_scale_square);
      if (sale && py) {
        const pps = String(Math.round(sale / py));
        if (String(detail.price_per_scale ?? "") !== pps) upd.price_per_scale = pps;
      }
      if (sale) {
        const inv = String(sale - n(detail.sale_type_rent_year) - n(detail.mortgage));
        if (String(detail.price_investment ?? "") !== inv) upd.price_investment = inv;
      }
    } else if (t === "commerce" || t === "business") {
      const dep = n(detail.fee_year), pre = n(detail.price_premium);
      if (dep || pre) {
        const sum = String(dep + pre);
        if (String(detail.price_sum ?? "") !== sum) upd.price_sum = sum;
      }
    }
    if (Object.keys(upd).length) setDetail((prev) => ({ ...prev, ...upd }));
  }, [isViewMode, basic.estate_type, detail.price_sale, detail.site_amount_square,
      detail.site_amount, detail.site_scale_square, detail.sale_type_rent_year,
      detail.mortgage, detail.fee_year, detail.price_premium,
      detail.price_per_scale, detail.price_investment, detail.price_sum]);
  // ══════ [PRICE_AUTO_V1] 끝 ══════

  const handleSave = async () => {
    const newErrors = {};

    // 🔴 [필수값 검증]
    if (!basic.estate_type) {
      newErrors.estate_type = true;
    }
    if (!detail.completion_year) {
      newErrors.completion_year = true;
    }

    // 📍 변경된 항목들을 담을 배열
    const changedItems = [];

    // 📍 비교에서 제외할 시스템 필드 목록
    const excludeKeys = [
      "estate_no", "estate_id", "register_date", "update_date", 
      "branch_id", "register_id", "update_id", "insert_date", "created_at"
    ];

    // 비교 대상 필드 정의 (라벨: 필드명)
    const compareMap = { ...FIELD_DEFS };

    // 🔍 전수 비교 로직
    Object.keys(compareMap).forEach(key => {
      // 제외 필드면 스킵
      if (excludeKeys.includes(key)) return;

      const def = compareMap[key];
      let original = estate[key];
      let current = getFieldValue(key);

      const sOrig = String(original ?? "").trim();
      const sCurr = String(current ?? "").trim();

      if (sOrig !== sCurr) {
        let displayFrom = sOrig;
        let displayTo = sCurr;
        
        if (def.type === "select") {
          const opts = getSelectOptions(key);
          displayFrom = opts.find(o => String(o.value) === sOrig)?.label || sOrig;
          displayTo = opts.find(o => String(o.value) === sCurr)?.label || sCurr;
        }

        changedItems.push({ 
          label: def.label, 
          from: displayFrom || "(빈값)", 
          to: displayTo || "(빈값)" 
        });
      }
    });

    // 📍 연락처(owners, tenants) 상세 비교 로직
    ['owners', 'tenants'].forEach(key => {
      const label = key === 'owners' ? "소유자 연락처" : "임차인 연락처";
      
      // 배열을 "이름(번호), 이름(번호)" 형태의 문자열로 변환하여 비교
      const formatList = (list) => {
        if (!Array.isArray(list)) return "(없음)";
        const filtered = list.filter(item => item.number && item.number !== "0");
        return filtered.length > 0 
          ? filtered.map(item => `${item.name || "이름없음"}(${item.number})`).join(", ")
          : "(없음)";
      };

      const fromStr = formatList(estate[key]);
      const toStr = formatList(form[key]);

      if (fromStr !== toStr) {
        changedItems.push({
          label: label,
          from: fromStr,
          to: toStr
        });
      }
    });

    // 변경사항이 하나도 없으면 바로 저장 시도하거나 안내
    if (changedItems.length === 0 && mode !== "copy") {
      if (!window.confirm("수정된 내용이 없습니다. 그래도 저장하시겠습니까?")) return;
    }

    // 📍 배열인지 확인하고 정제하는 헬퍼
    const ensureArray = (data) => {
      if (Array.isArray(data)) return data;
      if (typeof data === 'string' && data.trim() !== "") {
        try { return JSON.parse(data); } catch(e) { return []; }
      }
      return [];
    };


    
    // 거래유형 중 최소 하나라도 'y'인지 체크
    // [PROFIT_RT_CLEAN_V1] 수익성은 화면에 보이는 매매·분양·경매만 센다 (숨은 전세 y 로 통과하던 구멍)
    const hasRentType = (basic.estate_type === "profit"
      ? [detail.rent_type_4deal, detail.rent_type_5sale, detail.rent_type_6auction]
      : [
          detail.rent_type_4deal, detail.rent_type_1year, detail.rent_type_2month,
          detail.rent_type_3short, detail.rent_type_5sale, detail.rent_type_6auction
        ]
    ).some(v => v === "y");

    if (!hasRentType) {
      newErrors["_rent_type_toggle_group"] = true;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      
      // 우선순위별 경고 및 포커스 처리
      if (newErrors.estate_type) {
        alert("물건유형(estate_type)은 필수 입력입니다.");
        fieldRefs.estate_type.current?.focus();
      } else if (newErrors["_rent_type_toggle_group"]) {
        alert("거래유형을 최소 하나 이상 선택해주세요.");
        // 버튼 형태이므로 focus() 대신 scrollIntoView() 사용
        fieldRefs.rent_type_group.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (newErrors.completion_year) {
        alert("준공일(completion_year)은 필수 입력입니다.");
        fieldRefs.completion_year.current?.focus();
      }
      return;
    }

    // 변경된 항목 리스트를 상태에 저장 (상태 변수 하나 추가 필요)
    setDiffList(changedItems);
    setKeepModDate(false); // [MODDATE_HOLD_V1] 확인창 열 때마다 기본 꺼짐으로
    setShowSaveConfirm(true); 
  };

// 기존 저장 로직: 이름만 바꿉니다. (중괄호 건드리지 마세요)
  const executeFinalSave = async () => { 
    setShowSaveConfirm(false); // 실행 시 팝업 닫기
    const newErrors = {};

    // 신규 등록(estate_no 없음)도 허용: 저장 과정에서 매물번호 생성

    // 📍 연락처 데이터 정제 및 문자열화 방지 로직 (배열 그대로 유지)
    // [CONTACT_DEFNAME_V1] 번호는 있는데 이름이 빈 연락처에 자동 이름
    //   빈 이름 1개 → base ("소유자"/"임차인") / 2개 이상 → base1, base2 … (이미 쓰인 이름은 건너뜀)
    //   이름만 있거나 이름·번호 둘 다 빈 행은 그대로 (둘 다 빈 행은 아래 filter 가 이미 제거)
    //   서버 데이터 변환 스크립트 contact_rename.js 와 같은 규칙
    const __autoName = (list, base) => {
      // [CONTACT_DEFNAME_V2] 이름·번호 모두 '0'/빈칸 = 무의미 → 제외
      const __z = (v) => { const t = String(v ?? "").trim(); return t === "" || t === "0"; };
      const arr = (Array.isArray(list) ? list : []).filter((x) => !(__z(x?.name) && __z(x?.number)));
      const used = new Set(arr.map((x) => String(x?.name ?? "").trim()).filter((v) => v && v !== "0"));
      const isBlank = (x) => __z(x?.name) && !__z(x?.number);   // 이름 '0' 도 빈 이름
      const blanks = arr.filter(isBlank).length;
      let n = 1;
      return arr.map((x) => {
        if (!isBlank(x)) return x;
        let cand;
        if (blanks === 1 && ![...used].some((u) => u.startsWith(base))) cand = base;   // 같은 계열 있으면 번호 이어감
        else { do { cand = base + n++; } while (used.has(cand)); }
        used.add(cand);
        return { ...x, name: cand };
      });
    };

    const getCleanedContactArray = (list) => {
      if (!Array.isArray(list)) return [];
      return list
        .filter(item => item && String(item.number || "").trim() !== "")
        .map(item => ({
          name: String(item.name || "").trim() || "이름없음",
          number: String(item.number || "").trim()
        }));
    };

    // 1) 메모/거래완료(meta) 페이로드 구성 
    // ★ [수정] 백엔드 copy API가 수정한 값을 즉시 반영하도록 basic 필드들을 통합 전송
    const metaPayload = {
      use_yn: form.use_yn,
      grade_condition: form.grade_condition,
      register_memo: form.register_memo,
      resident_memo: form.resident_memo,
      // [CONTACT_NAME_KEEP_V1] 이름만 있어도 저장 (예전엔 번호 없으면 버려져 연락처가 사라졌음)
      owners: __autoName(Array.isArray(form.owners) ? form.owners.filter((it) => String(it?.name ?? "").trim() || String(it?.number ?? "").trim()) : [], "소유자"), // [CONTACT_DEFNAME_V1]
      tenants: __autoName(Array.isArray(form.tenants) ? form.tenants.filter((it) => String(it?.name ?? "").trim() || String(it?.number ?? "").trim()) : [], "임차인"),
      // 📍 백엔드 properties.js의 fieldsToOverride 대응용 필드 추가
      estate_name: basic.estate_name,
      shop_name: basic.shop_name,
      estate_dong: basic.estate_dong,
      estate_ho: basic.estate_ho,
      estate_type: basic.estate_type,
      bld_type: basic.bld_type,
      bld_type_etc: basic.bld_type_etc,
      floor: basic.floor,
      floor_type1: basic.floor_type1,
      floor_type2: basic.floor_type2,
      floor_etc: basic.floor_etc,
      lat: basic.lat ?? null,
      lng: basic.lng ?? null,
      estate_direction: basic.estate_direction,
    };

    // 2) 기본정보 페이로드
    const basicPayload = {
      estate_name: basic.estate_name,
      shop_name: basic.shop_name,
      estate_dong: basic.estate_dong,
      estate_ho: basic.estate_ho,
      estate_type: basic.estate_type,
      bld_type: basic.bld_type,
      bld_structure: basic.bld_structure,   // 룸형태 [BLD_STRUCT_PAYLOAD_V1]
      bld_type_etc: basic.bld_type_etc,
      floor: basic.floor,
      floor_type1: basic.floor_type1,
      floor_type2: basic.floor_type2,
      floor_etc: basic.floor_etc,
      lat: basic.lat ?? null,
      lng: basic.lng ?? null,
      roadAddress: basic.roadAddress,
      jibunAddress: basic.jibunAddress,
      detailAddress: basic.detailAddress,
      estate_direction: basic.estate_direction,
    };

    // 3) 상세정보 페이로드 (시차 오류를 방지하기 위해 순수 문자열만 추출)
    const detailPayload = {
      ...detail,
      completion_year: detail.completion_year 
        ? detail.completion_year.slice(0, 10) 
        : null,
    };

    setSaving(true);

    try {
      // ★ 핵심 수정: 모드에 따라 targetEstateNo를 엄격하게 결정합니다.
      let targetEstateNo = (mode === "edit" || mode === "copy" || mode === "contract") 
                           ? estateNo 
                           : null;
      let resultEstate = estate || null;
      // [MODDATE_HOLD_V1] 수정일 격리: 일반 수정(edit) + 체크일 때만 '?keepModDate=1'
      //   복사·신규·거래완료 모드에선 항상 빈 문자열 → 아래 주소들이 기존과 동일
      const __hq = (mode === "edit" && keepModDate) ? "?keepModDate=1" : "";

      // 1️⃣ [복사 모드] 
      if (mode === "copy") {
        // A. 서버에 원본 복제를 명령합니다. (이때 확장된 metaPayload를 보냄)
        const resCopy = await authFetch(`/api/properties/${estate?.estate_no}/copy`, {
          method: "PUT",
          body: JSON.stringify(metaPayload),
        });
        const copyData = await resCopy.json();
        if (!resCopy.ok || !copyData.ok || !copyData.estate_no) {
          throw new Error(copyData.error || "복사본 생성 실패");
        }

        // B. 새로 생성된 매물 번호를 가져옵니다.
        targetEstateNo = copyData.estate_no;
        setEstateNo(targetEstateNo);

        // ★ [가장 중요한 수정] 건물정보교체 등으로 바뀐 '현재 화면의 모든 값'을 
        // 새 번호(targetEstateNo)에 강제로 덮어씌웁니다.
        
        // 1. 상호명, 호수, 층, 좌표(건물정보에서 온 값들) 저장
        await authFetch(`/api/properties/${targetEstateNo}/basic${__hq}`, {
          method: "PUT",
          body: JSON.stringify(basicPayload),
        });

        // 2. 상세 금액, 면적, 준공일 저장
        await authFetch(`/api/properties/${targetEstateNo}/detail${__hq}`, {
          method: "PUT",
          body: JSON.stringify(detailPayload),
        });

        // 3. 연락처(소유자/임차인) 최종 확인 저장
        await authFetch(`/api/properties/${targetEstateNo}/meta${__hq}`, {
          method: "PUT",
          body: JSON.stringify(metaPayload),
        });
        
        // 4. 계약 상태를 '계약가능(y)'으로 강제 설정 (복사본이므로)
        await updateContractYn(targetEstateNo, "y");
      }

      // 2️⃣ [신규 등록 모드]
      else if (!targetEstateNo) {
        // 1. 기본 정보로 매물 생성 및 번호 발급
        const resNew = await authFetch("/api/properties/new", {
          method: "POST",
          body: JSON.stringify({ ...basicPayload, completion_year: detail.completion_year }),
        });
        const newData = await resNew.json();
        if (!resNew.ok || !newData.ok) throw new Error(newData.error || "new_failed");
        
        targetEstateNo = newData.estate_no;
        setEstateNo(targetEstateNo);

        // 2. 생성된 번호에 연락처(metaPayload) 정보 즉시 업데이트 ★핵심★
        await authFetch(`/api/properties/${targetEstateNo}/meta${__hq}`, {
          method: "PUT",
          body: JSON.stringify(metaPayload),
        });
      }

      // 3️⃣ [일반 수정 모드]
      else {
        // 기존 매물 수정 시에만 meta API 호출
        const resMeta = await authFetch(`/api/properties/${targetEstateNo}/meta${__hq}`, {
          method: "PUT",
          body: JSON.stringify(metaPayload),
        });
        if (!resMeta.ok) throw new Error("meta_save_failed");
      }

      // 4️⃣ [공통] 확보된 targetEstateNo(신규 혹은 복사본 번호)에 데이터 주입

      // 계약상태 저장
      if (typeof form.contract_yn === "string") {
        const finalContractStatus = (mode === "copy" || mode === "contract") ? "y" : form.contract_yn;
        await updateContractYn(targetEstateNo, finalContractStatus, { keepModDate: !!__hq }); // [MODDATE_HOLD_V1]
      }

      // 기본정보 저장
      await authFetch(`/api/properties/${targetEstateNo}/basic${__hq}`, {
        method: "PUT",
        body: JSON.stringify(basicPayload),
      });

      // 4. 상세정보 저장
      await authFetch(`/api/properties/${targetEstateNo}/detail${__hq}`, {
        method: "PUT",
        body: JSON.stringify(detailPayload),
      });

      // ★ 5. [핵심 추가] 사진 업로드 실행 (복사 모드 대기열 처리)
      if (photoRef.current && photoRef.current.uploadPendingFiles) {
        await photoRef.current.uploadPendingFiles(targetEstateNo);
      }

      const finalEstateNo = targetEstateNo;
      setEstateNo(finalEstateNo);

      // 📸 [추가] 전체 데이터 스냅샷 생성 (히스토리 아카이빙)
      try {
        const fullSnapshotData = {
          meta: metaPayload,
          basic: basicPayload,
          detail: detailPayload,
          photos: galleryPhotos.map(p => (typeof p === 'string' ? p : (p.url || p.path || p.thumb_url))),
          timestamp: new Date().toISOString(),
          editor_mode: mode
        };
        createFullSnapshot(finalEstateNo, fullSnapshotData)
          .then(res => console.log("전체 스냅샷 아카이빙 완료:", res.fileName))
          .catch(err => console.error("스냅샷 아카이빙 실패:", err));
      } catch (snapshotErr) {
        console.error("스냅샷 데이터 구성 중 오류:", snapshotErr);
      }

      // [BLD_SYNC_FE_V1] 같은 건물 공통정보(건축물대장) 동기화
      //   백엔드: backend/routes/buildingSync.js  POST /api/properties/:id/sync-building
      //   - 같은 지번주소 매물 전부(이 매물 포함)의 단지·동 공통 칸을 대장 값으로 덮어씀
      //     (대지면적·주차·용도지역 / 연면적·층수·세대수·승강기·사용승인일, 건물명은 빈칸일 때만)
      //   - 호실 개별 칸(전용·공용면적, 층, 호, 대지지분)은 서버가 건드리지 않음
      //   - 매물 저장은 이미 끝난 뒤라, 여기서 실패해도 저장에는 영향 없음 → 안내만
      let bldSyncNote = "";
      try {
        const rs = await authFetch(`/api/properties/${finalEstateNo}/sync-building`, { method: "POST" });
        const sj = await rs.json().catch(() => null);
        if (sj && sj.ok) {
          const list = sj.result || [];
          const changed = (r) => r.changes && r.changes.length > 0;
          const isSelf = (r) => String(r.estate_no) === String(finalEstateNo);
          const others = list.filter((r) => !isSelf(r) && changed(r)).length;
          const selfChanged = list.some((r) => isSelf(r) && changed(r));
          if (others || selfChanged) {
            bldSyncNote = "\n\n🏢 건축물대장 공통정보 반영";
            if (selfChanged) bldSyncNote += "\n · 이 매물의 건물 공통 칸을 대장 값으로 맞췄습니다";
            if (others) bldSyncNote += `\n · 같은 건물 다른 매물 ${others}건도 함께 갱신했습니다`;
          }
        } else if (sj && sj.reason === "timeout") {
          bldSyncNote = "\n\n🏢 건축물대장 조회 중이라 같은 건물 갱신은 다음 저장 때 반영됩니다.";
        }
        console.log("[BLD_SYNC]", sj);   // F12 콘솔에서 칸별 변경내역(result) 확인 가능
      } catch (syncErr) {
        console.error("[BLD_SYNC] 동기화 실패(저장은 정상):", syncErr);
      }

      // ★ 개선된 알림 로직
      if (mode === "copy") {
        alert(`복사 등록이 완료되었습니다.\n새 매물번호: ${finalEstateNo}` + bldSyncNote);
      } else if (mode === "contract") {
        alert("거래완료 처리되었습니다." + bldSyncNote);
      } else if (!estateNo || mode === "new") { 
        alert(`신규 매물 등록이 완료되었습니다.\n매물번호: ${finalEstateNo}` + bldSyncNote);
      } else {
        alert("매물 정보가 저장되었습니다." + bldSyncNote);
      }

      if (typeof onSaved === "function") {
        onSaved({
          ok: true,
          mode,
          estate_no: finalEstateNo,
          form: { meta: metaPayload, basic: basicPayload, detail: detailPayload },
          estate: resultEstate,
        });
      }

      if (typeof onClose === "function") {
        onClose();
      }

    } catch (e) {
      console.error("[EstateEditor save error]", e);
      if (e.message !== "unauthorized") {
        alert(`저장 중 오류가 발생했습니다: ${e.message}`);
      }
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  // 신규 등록일 때 estate 기본값 보장
  const safeEstate = estate ?? {};

  // CARD_STYLE_V2 — 섹션을 카드 모양으로
  const labelStyle = {
    fontSize: 13,
    fontWeight: 700,
    marginBottom: 4,
    color: "#2d3748",
  };

  const sectionStyle = {
    marginBottom: 10,
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    padding: "12px 14px",
  };

  const textareaStyle = {
    width: "100%",
    minHeight: 80,
    padding: 8,
    fontSize: 13,
    borderRadius: 6,
    border: "1px solid #ddd",
    resize: "vertical",
    boxSizing: "border-box",
  };


  // 건물정보 오버레이에 표시할 주소 (도로명 > 지번 > 기존 estate 값)
  const overlayAddress =
    basic.roadAddress ||
    basic.jibunAddress ||
    estate?.roadAddress ||
    estate?.jibunAddress ||
    "";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 2000,
        display: "flex",
        alignItems: isMobile ? "flex-end" : "center",   // DRAGGABLE_WINDOW_V2
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: isMobile ? "100%" : "500px",
          maxWidth: isMobile ? "100%" : "90vw",
          height: isMobile ? "88vh" : "auto",
          maxHeight: isMobile ? "88vh" : "90vh",
          boxSizing: "border-box",          // SHEET_FIX_V3: 여백 포함 계산
          background: "#fff",
          borderRadius: isMobile ? "16px 16px 0 0" : 10, // 모바일은 위쪽만 둥글게
          boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
          padding: 12,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",               // 창 밖으로 내용이 삐져나가지 않게
          // PC 에서만 끌어 옮긴 거리를 반영
          transform: isMobile ? "none" : `translate(${pos.x}px, ${pos.y}px)`,
        }}
        onClick={(e) => e.stopPropagation()}
      >

        {/* 헤더 */}
        <div
          onMouseDown={onDragStart}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
            cursor: isMobile ? "default" : "move",  // DRAG_HANDLE_V2
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* ★ 모드 표시 배지 추가 */}
            <span style={{
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "11px",
              fontWeight: "bold",
              color: "#fff",
              backgroundColor: themeColor,
              textTransform: "uppercase"
            }}>
              {isViewMode ? "VIEW ONLY" : "EDITING"}
            </span>
            <div style={{ fontSize: 16, fontWeight: 700, color: themeColor }}>{title}</div>

            {estateNo && (
              <div
                style={{
                  fontSize: 12,
                  color: "#555",
                  marginTop: 2,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                }}
              >
                <span>등록번호: {estateNo}</span>
                {estate?.register_name && (
                  <span>
                    /{estate.register_name}
                    {estate.register_position ? ` ${estate.register_position}` : ""}
                  </span>
                )}

                {estate?.update_name && (
                  <span>
                    /{estate.update_name}
                    {estate.update_position ? ` ${estate.update_position}` : ""}
                  </span>
                )}
                {registerDate && <span>등록일 {formatDateTime(registerDate)}</span>}
                {updateDate && <span>수정일 {formatDateTime(updateDate)}</span>}
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 18,
              cursor: "pointer",
              padding: 4,
            }}
          >
            ×
          </button>
        </div>

        {/* 주소/기본 정보 */}
        <div
          style={{
            padding: 10,
            marginBottom: 12,
            borderRadius: 8,
            background: "#f7fafc",
            border: "1px solid #e2e8f0",
            fontSize: 13,
            lineHeight: 1.5,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 4,
            }}
          >
            <div style={{ fontWeight: 600 }}>소재지</div>
            {/* 🔒 건물정보확인: premium/admin 만 (공공데이터 API 호출 발생) */}
            {canEdit && (
            <button
              type="button"
              style={{ 
                marginLeft: 6, 
                padding: "2px 8px", 
                cursor: "pointer", 
                borderRadius: "4px", 
                border: "1px solid #cbd5e0", 
                backgroundColor: "#fff", 
                fontSize: "12px" 
              }}
              onClick={() => {
                // 1. 상세보기 모드인 경우 모드 전환 의사 확인
                if (isViewMode) {
                  const goToEdit = window.confirm(
                    "수정상태가 아닙니다! 수정상태로 전환할까요?\n\n[확인]: 수정상태로 전환\n[취소]: 정보만 확인"
                  );
                  if (goToEdit && onModeChange) {
                    onModeChange("edit"); // 수정 모드로 전환
                  }
                }
                
                // 2. 건물정보 오버레이 오픈 및 조회 실행
                setBuildingSelectedHo("");
                setBuildingOpen(true);
                handleFetchBuildingInfo();
              }}
            >
              건물정보확인
            </button>
            )}

          {/* 🔴 중복 지번(PNU) 선택 UI */}
          {Array.isArray(pnuCandidates) && pnuCandidates.length > 0 && (
            <div
              style={{
                marginTop: 12,
                border: "1px solid #d32f2f",
                borderRadius: 6,
                padding: 10,
                background: "#fff5f5",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
                지번이 여러 개입니다. 정확한 위치를 선택하세요.
              </div>

              {pnuCandidates.map((c) => (
                <button
                  key={c.pnu}
                  type="button"
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                    padding: "6px 8px",
                    marginBottom: 6,
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    background: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    try {
                      setPnuCandidates([]);
                      setBuildingInfoLoading(true);

                      const res = await fetch(`/api/building-info?pnu=${c.pnu}`);
                      const data = await res.json();

                      if (!data?.ok) {
                        alert(data?.error || "건물정보 조회 실패");
                        return;
                      }

                      // 🔥 기존 buildingInfo 세팅 방식 그대로 사용
                      setBuildingInfo({
                        data: data.data ?? null,
                        building: data.data?.recapTitle
                          ? {
                              ...data.data.recapTitle,
                              dongList: data.data.dongList,
                              vworldShareList: data.data.vworldShareList,
                            }
                          : null,
                        stations: Array.isArray(data.stations) ? data.stations : [],
                        providers: data.providers ?? {},
                        ok: true,
                        raw: data,
                      });
                    } finally {
                      setBuildingInfoLoading(false);
                    }
                  }}
                >
                  {c.title || c.address || c.pnu}
                </button>
              ))}
            </div>
          )}
          </div>

          {/* 도로명주소 입력 */}
          <input
            name="roadAddress"
            value={basic.roadAddress ?? estate?.roadAddress ?? ""}
            onChange={handleBasicChange}
            placeholder="도로명주소"
            style={{
              width: "100%",
              padding: 4,
              fontSize: 13,
              marginBottom: 4,
              borderRadius: 4,
              border: "1px solid #cbd5e0",
            }}
          />
          {/* 지번주소 입력 */}
          <input
            name="jibunAddress"
            value={basic.jibunAddress ?? estate?.jibunAddress ?? ""}
            onChange={handleBasicChange}
            placeholder="지번주소"
            style={{
              width: "100%",
              padding: 4,
              fontSize: 13,
              marginBottom: 4,
              borderRadius: 4,
              border: "1px solid #e2e8f0",
            }}
          />
          {/* 상세주소 입력 */}
          {/* <input
            name="detailAddress"
            value={basic.detailAddress ?? ""}
            onChange={handleBasicChange}
            placeholder="상세주소"
            style={{
              width: "100%",
              padding: 4,
              fontSize: 13,
              borderRadius: 4,
              border: "1px solid #e2e8f0",
            }}
          /> */}
        </div>

        {/* // ◆gemini테스트코드 2026.01.01 ◆ <DataChecker estateNo={estateNo} /> */}

        {/* 탭 버튼 */}
        {/* HIDE_EMPTY_TABS: 라벨이 주석 처리되어 빈 회색 버튼만 보이던 탭 숨김 */}
        <div className="editor-tabs" style={{ display: "none" }}>
          <button
            className={tab === "info" ? "active" : ""}
            onClick={() => setTab("info")}
          >
            {/* 물건정보 */}
          </button>
          <button
            className={tab === "full" ? "active" : ""}
            onClick={() => setTab("full")}
          >
            {/* 전체필드 */}
          </button>
          {/* 사진, 기타 탭 있으면 그대로 */}
        </div>

        {/* 1. 고정 영역: 상단 액션 버튼 그룹 (상세보기 모드 & info 탭일 때만 고정 노출) */}
        {tab === "info" && isViewMode && canEdit && (   /* 🔒 premium/admin 만 */
          <div style={{ 
            padding: "10px", 
            background: "#f1f5f9", 
            borderRadius: 8, 
            display: "flex", 
            gap: 8, 
            marginBottom: 10,
            flexShrink: 0 // 고정 영역이므로 축소 방지
          }}>
            <button 
              onClick={() => onModeChange("edit")} 
              style={{ flex: 1, padding: "8px", borderRadius: 4, cursor: "pointer", border: "1px solid #cbd5e0", fontWeight: "600" }}
            >
              정보 수정하기
            </button>
            <button 
              onClick={() => onModeChange("copy")} 
              style={{ flex: 1, padding: "8px", borderRadius: 4, cursor: "pointer", border: "1px solid #cbd5e0", fontWeight: "600" }}
            >
              이 매물 복사하기
            </button>

            {/* 📍 블로그 생성 버튼을 여기로 이동하여 중복 노출 방지 */}
            <button 
              onClick={handleGenerateBlogPage} 
              className="btn-blog-generate"
              style={{ 
                flex: 1, 
                padding: "8px", 
                borderRadius: 4, 
                cursor: "pointer", 
                backgroundColor: "#00c73c", 
                color: "#fff", 
                border: "none", 
                fontWeight: "bold" 
              }}
            >
            {blogLoading ? (
                <>
                  <span className="spinner">⏳</span> 블로그 콘텐츠 생성중...
                </>
              ) : (
                "네이버 블로그용 생성"
              )}
            </button>
          </div>
        )}

        {/* 스크롤 영역 - 물건정보 탭 */}
        {tab === "info" && (
          <div
            style={{
              flex: 1,
              minHeight: 0,              // SHEET_FIX_V3: flex 자식 축소 허용
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: 4,
            }}
          >

            {/* SMS_MOVED_V1: SMS 전송/이력 (스냅샷 이력 하단으로 이동) */}
            {isViewMode && canEdit && (
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "flex-end",
                gap: 8, marginBottom: 10,
              }}>
                {smsLogs && smsLogs.length > 0 && (
                  <span
                    onClick={() => setShowSmsPopup(true)}
                    style={{ fontSize: 11, color: "#718096", cursor: "pointer", textDecoration: "underline" }}
                  >
                    {formatDateTime(smsLogs[0].sent_at)}
                  </span>
                )}
                <button
                  type="button"
                  onClick={() => setShowSmsPopup(true)}
                  disabled={smsLoading}
                  style={{
                    padding: "2px 10px", fontSize: 12, borderRadius: 4,
                    border: "1px solid #cbd5e0", backgroundColor: "#3182ce",
                    color: "#fff", cursor: "pointer",
                  }}
                >
                  {smsLoading ? "전송중..." : "SMS 전송/이력"}
                </button>
              </div>
            )}

            {/* 2. 조건부 필드 출력 (isFieldVisible 적용) */}
            {FIELD_LAYOUT
              // 🔒 물건관리 등급 섹션 통째로 제거 (canEdit=false 일 때)
              .filter(g => canEdit || !["info-grade", "info-memo"].includes(g.id))
              // GRADE_EDIT_ONLY: 등급 선택 바는 편집모드에서만
              // (보기모드에서는 건물·호실 카드의 테두리색과 이름표로 표시)
              .filter(g => !(isViewMode && g.id === "info-grade"))
              // 🔒 해당 호수 정보에서 동/호수만 제거 (층 정보는 유지)
              .map(g => canEdit ? g : {
                ...g,
                fields: g.fields.filter(f => f !== "estate_dong" && f !== "estate_ho")
              })
              .map((group) => {
              // 현재 섹션 그룹의 필드들 중 실제로 보여야 할 필드만 필터링
              const visibleFields = group.fields.filter(f => isFieldVisible(f));
              
              // ★ 핵심: 보여줄 필드가 0개라면 섹션 타이틀도 출력하지 않음
              if (visibleFields.length === 0) return null;

              // ── GRADE_CARD_V1: 건물·호실 카드에 등급색 입히기 ──
              const gradeVal = String(form.grade_condition || "").trim();
              const gradeColor = GRADE_COLORS[gradeVal];
              const isBldCard = group.id === "info-building-base";
              // 등급이 있고 보기모드이며 건물카드일 때만 색 적용
              const cardStyle = (isBldCard && isViewMode && gradeColor)
                ? { ...sectionStyle,
                    border: `2px solid ${gradeColor}`,
                    background: lighten(gradeColor, 0.9) }
                : (() => {   // [CARD_BG_V1] 카드별 배경 + 왼쪽 색띠 (등급색 카드는 위 분기가 우선)
                  const t = {
                  "info-building-base": { bg: "#eef4ff", ac: "#3b6fd8" },  // 건물·호실 — 하늘/파랑
                  "info-price":         { bg: "#fff4e6", ac: "#d9822b" },  // 거래·금액 — 살구/주황
                  "info-area":          { bg: "#ebf7f0", ac: "#2f9e63" },  // 면적·구성 — 민트/초록
                  "info-traffic":       { bg: "#f3effd", ac: "#7c5cd6" },  // 교통·시설 — 라벤더/보라
                  "info-memo":          { bg: "#fffbe8", ac: "#b8930a" },  // 메모 — 아이보리/겨자
                }[group.id];
                  return t ? { ...sectionStyle, background: t.bg, borderLeft: `5px solid ${t.ac}` } : sectionStyle;
                })();
              // 등급 한글 이름 (GRADE_CONDITION_OPTIONS 에서 조회)
              const gradeLabel = GRADE_CONDITION_OPTIONS
                .find(o => o.value === gradeVal)?.label || "";

              return (
                <div key={group.id} style={cardStyle}>
                  {/* 보여줄 내용이 있을 때만 타이틀 출력 */}
                  {/* ★ 수정: 타이틀과 SMS 버튼을 한 행에 배치 */}
                  <div style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    marginBottom: 4 
                  }}>
                    <div style={{ ...labelStyle, color: ({
                    "info-building-base": { bg: "#eef4ff", ac: "#3b6fd8" },  // 건물·호실 — 하늘/파랑
                    "info-price":         { bg: "#fff4e6", ac: "#d9822b" },  // 거래·금액 — 살구/주황
                    "info-area":          { bg: "#ebf7f0", ac: "#2f9e63" },  // 면적·구성 — 민트/초록
                    "info-traffic":       { bg: "#f3effd", ac: "#7c5cd6" },  // 교통·시설 — 라벤더/보라
                    "info-memo":          { bg: "#fffbe8", ac: "#b8930a" },  // 메모 — 아이보리/겨자
                  }[group.id] || {}).ac || labelStyle.color }}>{group.title}</div>{/* [CARD_BG_V1] 제목색 */}
                    
                    {/* GRADE_BADGE_V1: 등급 이름표 (기존 SMS 버튼 자리) */}
                    {isBldCard && isViewMode && gradeLabel && gradeColor /* [CARD_BG_V2] 빈 등급의 '선택' 안내문구 제외 */ && (
                      <span style={{
                        padding: "2px 10px",
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 700,
                        backgroundColor: gradeColor,
                        // 연회색(비추천)만 밝아서 검정 글자, 나머지는 흰 글자
                        color: gradeVal === "nonrecommend" ? "#333" : "#fff",
                        whiteSpace: "nowrap",
                      }}>{gradeLabel}</span>
                    )}
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(${group.columns}, 1fr)`,
                      gap: 8,
                    }}
                  >
                    {/* map 내부의 화살표 함수 괄호 세심하게 확인 */}
                    {visibleFields.map((fieldName) => {
                      if (!isFieldVisible(fieldName)) return null;

                      const def = FIELD_DEFS[fieldName];
                      const hideLabelFields = ["_status_toggle_group", "contract_yn", "use_yn", "estate_direction", "price_mgr_yn"];
                      // ★ 라벨 출력 대상 목록 (요청 사항 반영: 텍스트/숫자 입력창 전체)
                    const showLabelFields = [
                      "estate_name", "bld_type_etc", "estate_dong", "estate_ho", "floor", 
                      "price_sale", "price_bunyang", "fee_jeonse", "fee_year", "fee_month", "price_deposit", "price_posible",
                      "price_per_scale", "price_per_household", "price_investment", "mortgage", "f_price_total_mgr",
                      "price_premium", "price_sum",
                      "exclusive_scale", "exclusive_scale_square", "used_scale", "used_scale_square", 
                      "common_area_m2", "common_area_square", "site_amount", "site_amount_square", 
                      "site_scale", "site_scale_square", "totArea",
                      "shop_name", 
                      "rent_household_cnt", // ★ 전체 임대 가구 수 (변수명 정확히 일치)
                      "owner_room",         // ★ 주인세대 룸 수 (변수명 정확히 일치)
                      "owner_bath",         // ★ 주인세대 욕실 수 (변수명 정확히 일치)
                      "room_cnt", "bath_cnt", "bld_scale", "bld_scale_under", 
                      "parking_cnt", "parking_fee", 
                      "station", "station_distance", "station_transport",
                      "sale_type_rent_year", "sale_type_rent_month",
                      "use_district", "completion_year", "estate_type", "bld_type", "floor_type1", "floor_type2", "floor_etc" /* [BLDCARD_VIEW_V2] 호수대체 라벨 */
                    ];
                      const shouldShowLabel = showLabelFields.includes(fieldName) && !hideLabelFields.includes(fieldName);
                      // [BLDCARD_VIEW_V1] 건물·호실 카드는 보기모드에서 라벨 줄 자체를 없앰 (수정모드는 그대로)
                      // [PRICECARD_VIEW_V1] 거래·금액 카드(info-price)도 보기모드 라벨 숨김
                      const __bcHide = isViewMode && group && (group.id === "info-building-base" || group.id === "info-price" || group.id === "info-area" /* [AREACARD_VIEW_V1] */ || group.id === "info-traffic" /* [VIEW_LAYOUT_V1] */);

                      // ★ _mgr_items_group인 경우 2단 그리드에서 2칸을 모두 차지(span 2)하도록 수정
                      const isFullWidthGroup = (isViewMode && fieldName === "owner_household") /* [AREACARD_VIEW_V1] */ || fieldName === "_status_toggle_group" || fieldName === "_mgr_items_group" || fieldName === "_facility_group" || fieldName === "_facility_elec_group" || fieldName === "_rent_type_toggle_group";

                      // HIDE_EMPTY_PARENT: 값이 비어 null 이 오면 라벨·상자까지 통째로 제거
                      // (renderFieldInput 의 HIDE_EMPTY_IN_VIEW 와 한 쌍)
                      const rendered = renderFieldInput(fieldName);
                      if (rendered === null || rendered === undefined) return null;

                      return (
                        <div 
                          key={fieldName} 
                          style={{ 
                            marginBottom: "8px",
                            gridColumn: isFullWidthGroup ? "span 2" : "auto" // ★ 핵심: 그룹형 버튼은 한 줄 전체 사용
                          }}
                        >
                          {def && !__bcHide && (
                            <div style={{ 
                              fontSize: 11, 
                              color: shouldShowLabel ? "#555" : "transparent",
                              marginBottom: 2, 
                              fontWeight: "600",
                              height: "14px",
                              userSelect: "none"
                            }}>
                              {def.label}
                            </div>
                          )}
                          {rendered}
                        </div>
                      );
                    })} {/* ← visibleFields.map 닫기 */}
                  </div> {/* ← grid div 닫기 */}
                </div> /* ← section div 닫기 */
              );
            })} {/* ← FIELD_LAYOUT.map 닫기 */}


        {/* 현장녹음 [REC_LINK_V1] */}
        {estate?.recording_url && (
          <div style={sectionStyle}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <span style={{ fontWeight: 700, fontSize: 14 }}>현장 녹음</span>
              {estate.recording_at && (
                <span style={{ fontSize: 12, color: "#888" }}>
                  {String(estate.recording_at).slice(0, 16).replace("T", " ")}
                </span>
              )}
              <a
                href={estate.recording_url}
                target="_blank"
                rel="noreferrer"
                style={{ padding: "6px 16px", background: "#2b6cb0", color: "#fff",
                         borderRadius: 6, fontSize: 13, textDecoration: "none", fontWeight: 600 }}
              >
                듣기
              </a>
              <span style={{ fontSize: 11, color: "#999" }}>구글드라이브에서 재생됩니다</span>
            </div>
          </div>
        )}
        {/* 연락처 */}
        <div style={ /* [VIEW_LAYOUT_V1] 보기모드에서 연락처가 하나도 없으면 빈 상자(여백)를 숨김 */
          (isViewMode && ![...(form.owners || []), ...(form.tenants || [])]
            .some((c) => (String(c?.name ?? "").trim() !== "" || (String(c?.number ?? "").trim() !== "" && String(c?.number ?? "").trim() !== "0")) /* [CARD_BG_V2] 이름 또는 번호 */))
            && __legacyContacts().length === 0 /* [CONTACT_LEGACY_OFF_V1] */ ? { display: "none" } : { ...sectionStyle, background: "#f4f6f9", borderLeft: "5px solid #64748b" } /* [CARD_BG_V1] */ }>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}> {/* 📍 세로 정렬로 변경 */}
            {/* 소유자 섹션 */}
            <ContactArraySection 
              title="소유자 연락처 (+)" 
              list={form.owners || []} 
              isViewMode={isViewMode}
              // 📍 내부 함수를 Props로 전달 (스코프 문제 해결)
              formatPhoneNumber={formatPhoneNumber} 
              onChange={(newList) => updateContactList('owners', newList)} // 📍 수정
            />
            
            {/* 임차인 섹션 (이제 소유자 밑으로 들어갑니다) */}
            <ContactArraySection 
              title="임차인 연락처 (+)" 
              list={form.tenants || []} 
              isViewMode={isViewMode}
              // 📍 내부 함수를 Props로 전달 (스코프 문제 해결)
              formatPhoneNumber={formatPhoneNumber} 
              onChange={(newList) => updateContactList('tenants', newList)} // 📍 수정 
            />
            {/* [CONTACT_LEGACY_OFF_V1] 구방식 칸에만 남은 옛 연락처 — 참고 표시 (직원이 통화로 확인 후 「추가 +」로 등록) */}
            {isViewMode && __legacyContacts().length > 0 && (
              <div style={{ padding: "8px 10px", background: "#fff", border: "1px dashed #cbd5e0", borderRadius: 6, fontSize: 12, color: "#718096" }}>
                <div style={{ fontWeight: 700, marginBottom: 4 }}>옛 연락처 (확인 필요)</div>
                {__legacyContacts().map((c, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, padding: "2px 0" }}>
                    <span style={{ minWidth: 44 }}>{c.role}</span>
                    <span style={{ flex: 1 }}>{c.name || "-"}</span>
                    <a href={`tel:${c.number.replace(/\D/g, "")}`} style={{ color: "#718096" }}>{c.number}</a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

            {/* [VIEW_LAYOUT_V1] 블로그·스냅샷 이력 — 상단에서 사진 관리 바로 위로 이동 */}
                  {/* 📍 블로그 콘텐츠 생성 이력 섹션 추가 (스냅샷 이력 위) */}
                  {/* 🔒 내부 작업 기록이므로 premium/admin 만 */}
                  {canEdit && (
                  <div style={{ marginTop: "20px", padding: "12px", background: "#f0fff4", borderRadius: "8px", border: "1px solid #c6f6d5" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                      <label style={{ fontSize: "13px", fontWeight: "bold", color: "#2f855a" }}>📝 블로그 콘텐츠 생성 이력</label>
                      <span style={{ fontSize: "11px", color: "#718096" }}>AI 분석 기록</span>
                    </div>
                    
                    <div style={{ maxHeight: "100px", overflowY: "auto", background: "#fff", borderRadius: "4px", border: "1px solid #c6f6d5" }}>
                      {blogLogs.length > 0 ? (
                        blogLogs.map((log, i) => (
                          <div 
                            key={i} 
                            style={{ 
                              padding: "8px", borderBottom: "1px solid #f0fff4", fontSize: "11.5px", 
                              display: "flex", justifyContent: "space-between" 
                            }}
                          >
                            <span style={{ color: "#2f855a" }}>✨ {log.keywords || "일반"} 분석 완료</span>
                            <span style={{ color: "#718096" }}>{log.date}</span>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "15px", textAlign: "center", color: "#a0aec0", fontSize: "12px" }}>
                          생성된 블로그 이력이 없습니다.
                        </div>
                      )}
                    </div>
                  </div>
                  )}

                  {/* 🔒 전체 데이터 스냅샷 이력: 내부 관리 기록 */}
                  {canEdit && (
                  <div style={{ marginTop: "20px", padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                      <label style={{ fontSize: "13px", fontWeight: "bold" }}>💾 전체 데이터 스냅샷 이력</label>
                      <span style={{ fontSize: "11px", color: "#718096" }}>저장 시 자동 생성</span>
                    </div>
                    
                    <div style={{ maxHeight: "150px", overflowY: "auto", background: "#fff", borderRadius: "4px", border: "1px solid #cbd5e0" }}>
                      {snapshotLogs.length > 0 ? (
                        snapshotLogs.map((log, i) => (
                          <div 
                            key={i} 
                            onClick={() => handleViewSnapshot(log.fileName)}
                            style={{ 
                              padding: "8px", borderBottom: "1px solid #edf2f7", fontSize: "12px", 
                              display: "flex", justifyContent: "space-between", cursor: "pointer" 
                            }}
                          >
                            <span style={{ color: "#3182ce", textDecoration: "underline" }}>📄 {log.fileName}</span>
                            <span style={{ color: "#718096" }}>{new Date(log.createdAt).toLocaleString()}</span>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "20px", textAlign: "center", color: "#a0aec0", fontSize: "12px" }}>
                          생성된 스냅샷 이력이 없습니다.
                        </div>
                      )}
                    </div>
                  </div>
                  )}

            {/* 3. 사진 갤러리 통합 (최하단) */}
            <div style={{ marginTop: 20, borderTop: "2px solid #eee", paddingTop: 15 }}>
              <div style={{ fontWeight: "bold", marginBottom: 10 }}>매물 사진 관리</div>
              <PhotoGallery 
                ref={photoRef} // ★ Ref 연결
                // 📍 [수정 핵심] 복사 모드일 때는 propertyId를 null로 주어 사진 조회를 원천 차단합니다.
                propertyId={mode === "copy" ? null : (estateNo || estate?.estate_no)}
                canEdit={canEdit}   // 🔒 premium/admin 이 아니면 업로드 input 숨김
                onPhotosLoaded={handlePhotosLoaded} // 고정된 함수를 전달
                mode={mode} // ★ 추가: 현재 모드(edit/copy 등)를 전달
                basicInfo={basic}
                onCoverChanged={(url) => {
                  // 1. App.js의 리스트 상태를 즉시 갱신 (리스트 썸네일이 바로 바뀜)
                  if (onThumbChange) {
                    onThumbChange(estate.estate_no, url);
                  }
                  // 2. 만약 에디터 내부에 출력 중인 썸네일 데이터가 있다면 그것도 갱신 필요 시 처리
                  console.log("대표 이미지 변경 완료:", url);
                }}
              />
            </div>

            {/* 물건상태(use_yn, contract_yn), 메모 등은
                FIELD_DEFS/FIELD_LAYOUT에 추가해서 여기로 옮기거나
                아래에 기존 섹션 그대로 두고 같이 써도 된다 */}
          </div>
        )}



        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
          {/* [COPY_TYPE_PICK_V1] 복사 시 용도 선택창 — copyTypePick 상태로 표시 */}
          {copyTypePick && (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 100000, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div style={{ background: "#fff", borderRadius: 10, padding: "20px 18px", width: "min(360px, 92vw)", boxShadow: "0 8px 24px rgba(0,0,0,0.25)" }}>
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>복사할 매물의 용도를 선택하세요</div>
                <div style={{ fontSize: 12, color: "#666", marginBottom: 14 }}>
                  원본: {(ESTATE_TYPE_OPTIONS.find(o => o.value === basic.estate_type) || {}).label || "미지정"} · 고른 용도에 맞는 입력 항목만 표시됩니다
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  {ESTATE_TYPE_OPTIONS.filter(o => o.value).map(o => (
                    <button key={o.value} type="button"
                      onClick={() => { setFieldValue("estate_type", o.value); setCopyTypePick(false); }}
                      style={{ padding: "12px 8px", borderRadius: 6, cursor: "pointer", fontWeight: 600,
                        border: o.value === basic.estate_type ? "2px solid #2b6cb0" : "1px solid #cbd5e0",
                        background: o.value === basic.estate_type ? "#ebf4ff" : "#fff" }}>
                      {o.label}
                    </button>
                  ))}
                </div>
                <button type="button"
                  onClick={() => { setCopyTypePick(false); if (onModeChange) onModeChange("view"); }}
                  style={{ marginTop: 12, width: "100%", padding: "8px", borderRadius: 6, border: "1px solid #cbd5e0", background: "#f7fafc", cursor: "pointer" }}>
                  복사 취소
                </button>
              </div>
            </div>
          )}
          {/* 상세보기(view) 모드일 때는 '닫기' 버튼만 크게 노출, 수정/복사 모드일 때는 기존 버튼들 노출 */}
          {mode === "view" ? (
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: "8px 24px",
                fontSize: 14,
                borderRadius: 6,
                border: "1px solid #ccc",
                background: "#f7fafc",
                cursor: "pointer",
                fontWeight: 600,
                width: "100%", // 상세보기에서는 닫기 버튼을 강조하거나 넓게 배치 가능
              }}
            >
              닫기
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={() => {   // [CANCEL_TO_VIEW_V1] 상세보기에서 왔으면 상세보기로, 아니면 닫기
                  if (__fromViewRef.current && estate?.estate_no && typeof onModeChange === "function") onModeChange("view");
                  else onClose();
                }}
                disabled={saving}
                style={{
                  padding: "6px 14px",
                  fontSize: 13,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  background: "#f7fafc",
                  cursor: "pointer",
                }}
              >
                취소
              </button>
              <button
                type="button"
                onClick={handleSave}
                disabled={saving}
                style={{
                  padding: "6px 18px",
                  fontSize: 13,
                  borderRadius: 6,
                  border: "1px solid #2b6cb0",
                  background: "#2b6cb0",
                  color: "#fff",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                {saving
                  ? "저장 중..."
                  : mode === "copy"
                  ? "복사 등록"
                  : mode === "contract"
                  ? "거래완료 저장"
                  : "저장"}
              </button>
            </>
          )}
        </div>
      </div>

      {/* ★ 지도확인 오버레이 */}
      {estate && (
        <AddressMapOverlay
          open={mapOpen}
          onClose={() => setMapOpen(false)}
          address={estate.roadAddress || estate.jibunAddress || ""}
          lat={estate.lat}
          lng={estate.lng}
          estateNo={estateNo}  // ★ DB에 바로 저장하는 API(/save-nearest)용
          // 지도에서 계산된 역/소요시간을 detail 상태로 반영
          onSelectStation={handleMapStationSelect}
        />
      )}

      {/* ★ 건물정보 확인 오버레이 */}
      <BuildingInfoOverlay
        open={buildingOpen}
        jibunAddress={basic.jibunAddress}
        roadAddress={basic.roadAddress}
        lat={detail.lat || basic.lat || estate?.lat}
        lng={detail.lng || basic.lng || estate?.lng}
        onClose={() => setBuildingOpen(false)}
        loading={buildingInfoLoading}
        error={buildingInfoError}
        buildingInfo={buildingInfo}
        onApply={applyBuildingInfoToDetail}
        selectedHo={buildingSelectedHo}
        onChangeHo={setBuildingSelectedHo}
        estateHo={basic.estate_ho}
        address={overlayAddress}
        onRefresh={handleRefreshBuildingInfo}
        cachedAt={buildingCachedAt}
      />

      {/* SMS 기록 상세 팝업 */}
      {showSmsPopup && (
<div className="sms-result-overlay" onClick={() => setShowSmsPopup(false)}>
          <div className="sms-result-modal" onClick={(e) => e.stopPropagation()}
            /* [SMS_MODAL_V1] 내용이 길어도 화면을 넘지 않게 하고, 넘치면 안에서 스크롤 */
            style={{ maxHeight: "92vh", overflowY: "auto", position: "relative" }}>
            <h3 style={{ margin: "0 0 10px 0", fontSize: "16px", borderBottom: "2px solid #3182ce", paddingBottom: "5px" }}>SMS 발송 및 이력</h3>
            
{/* ★ 전송 데이터 항목 선택 UI 추가 */}
            <div style={{ marginBottom: "15px", backgroundColor: "#f1f5f9", padding: "10px", borderRadius: "6px" }}>
              <label style={{ fontSize: "12px", fontWeight: "700", display: "block", marginBottom: "8px" }}>전송 항목 선택</label>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "5px" }}>
                {[
                  { key: "estateName", label: "건물명" },
                  { key: "address", label: "소재지" },
                  { key: "ho", label: "호수" },
                  { key: "floor", label: "층수" },
                  { key: "price", label: "금액(관포함)" },
                  { key: "roomBath", label: "룸/욕실" },
                  { key: "parking", label: "주차정보" },
                  { key: "completionDate", label: "준공일" },
                  { key: "facilities", label: "시설상태" },
                  { key: "link", label: "링크" },
                ].map(opt => (
                  <label key={opt.key} style={{ fontSize: "11px", display: "flex", alignItems: "center", gap: "3px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      checked={smsOptions[opt.key]} 
                      onChange={() => handleOptionChange(opt.key)} 
                    />
                    {opt.label}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontSize: "12px", fontWeight: "700", display: "block", marginBottom: "5px" }}>최종 메시지 (편집 가능)</label>
              {/* [SMS_SENDER_PICK_V1] 발신번호 선택 — 이번 발송에만 적용, 기본 = 매물 SMS 번호 */}
              <SenderSelect kind="property" value={smsSender} onChange={setSmsSender} style={{ margin: '4px 0' }} />
              <textarea
                value={smsContent}
                onChange={(e) => setSmsContent(e.target.value)}
                style={{ 
                  width: "100%", height: "90px", padding: "8px", fontSize: "12px", 
                  borderRadius: "4px", border: "1px solid #cbd5e0", resize: "none", boxSizing: "border-box" 
                }}
                placeholder="전송할 내용을 입력하세요..."
              />
            </div>

            {/* ★ 수신자 선택 UI */}
            <div style={{ marginBottom: "15px", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "10px", backgroundColor: "#f8fafc" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                <label style={{ fontSize: "13px", fontWeight: "700" }}>수신자 선택 (카테고리 → 그룹 → 수신자)</label>
                <button type="button" className="btn-manage-receivers" onClick={() => setShowReceiverModal(true)}>+ 수신처 관리</button>
              </div>

              {/* [RCV_PICKER_V1] 카테고리 → 그룹 → 수신자 (공용 ReceiverPicker) — 예전 그룹 목록 대체 */}
              <ReceiverPicker receivers={receivers} selectedIds={selectedIds} onChange={setSelectedIds} maxHeight="200px" />
            </div>

            <div className="sms-log-list" /* [SMS_MODAL_V1] 이력이 쌓여도 이 높이를 넘지 않고 안에서만 스크롤 */
              style={{ borderTop: "1px solid #eee", paddingTop: "10px",
                       maxHeight: "140px", overflowY: "auto" }}>
              {smsLogs.length > 0 ? (
                smsLogs.map((log, i) => (
                  <div key={i} className="sms-log-item">
                    <p><strong>일시:</strong> {formatDateTime(log.sent_at)}</p>
                    <p><strong>발송번호:</strong> {log.sender_phone || "시스템번호"}</p>
                    <p><strong>수신:</strong> {log.receiver_name || "담당자"} ({log.receiver_phone})</p>
                  </div>
                ))
              ) : (
                <div style={{ padding: "20px", textAlign: "center", color: "#a0aec0" }}>
                  전송 기록이 없습니다.
                </div>
              )}
            </div>

            <div /* [SMS_MODAL_V1] 스크롤해도 버튼이 항상 바닥에 보이도록 고정 */
              style={{ display: "flex", gap: "8px", marginTop: "15px",
                       position: "sticky", bottom: 0, background: "#fff",
                       paddingTop: "10px", paddingBottom: "4px",
                       borderTop: "1px solid #eee", zIndex: 5 }}>
              <button 
                type="button" 
                className="btn-preview" 
                onClick={handleOpenPreview} // 📍 발송 전 미리보기를 먼저 띄움
                disabled={selectedIds.length === 0 || smsLoading}
                style={{ flex: 2, background: "#2b6cb0", color: "#fff", fontWeight: "bold" }}
              >
                {smsLoading ? "처리 중..." : `발송 (${selectedIds.length}명)`}
              </button>

              <button type="button" className="sms-btn-delete" style={{ flex: 1 }} onClick={handleSmsDelete}>
                기록삭제
              </button>
              
              <button type="button" className="sms-btn-close" style={{ flex: 1 }} onClick={() => setShowSmsPopup(false)}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ★ 추가: 연락처 등록/관리 모달 실제 렌더링 */}
      <ReceiverManageModal 
        open={showReceiverModal} 
        onClose={() => setShowReceiverModal(false)} 
        onRefresh={fetchReceivers} 
        groups={uniqueGroups}
      />

      {/* 에디터 맨 마지막 </div> 바로 위에 추가 */}
      {showPreviewModal && previewData && (
        <div className="preview-overlay" style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="mobile-mockup" style={{ width: '340px', height: '650px', background: '#fff', borderRadius: '20px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}>
            <div style={{ background: '#333', color: '#fff', textAlign: 'center', padding: '12px', fontWeight: 'bold' }}>전송 화면 미리보기</div>
            
            <div style={{ flex: 1, overflowY: 'auto', padding: '0' }}>
              {/* 📍 지도를 미리보기에서도 보여주기 위한 영역 추가 */}
              {previewData.lat && previewData.lng ? (
                <div id="preview-map" style={{ width: '100%', height: '180px', background: '#eee' }}></div>
              ) : (
              <div style={{ padding: '20px', textAlign: 'center', fontSize: '12px', color: '#999', background: '#f8fafc' }}>
                📍 소재지 미선택으로 지도가 표시되지 않습니다.
              </div>
              )}

              <div style={{ padding: '15px' }}>
                <h2 style={{ fontSize: '18px', margin: '0 0 8px 0' }}>{previewData.estate_name}</h2>
                <div style={{ color: '#3182ce', fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>{previewData.price_info}</div>
                <hr style={{ border: '0', borderTop: '1px solid #eee' }} />
                
                <div style={{ fontSize: '13px', color: '#666', marginTop: '10px', fontWeight: 'bold' }}>📍 {previewData.roadAddress || previewData.jibunAddress}</div>
                
                {/* 메모(상세설명) */}
                <pre style={{ whiteSpace: 'pre-wrap', fontSize: '13px', marginTop: '15px', color: '#444', background: '#f9f9f9', padding: '10px', borderRadius: '5px' }}>
                  {previewData.memo}
                </pre>

                {/* 사진 리스트 (고화질 처리) */}
                <div style={{ marginTop: '15px' }}>
                  {previewData.photos?.map((u, i) => (
                    <img 
                      key={i} 
                      src={u.replace(/sz=w\d+/, 'sz=w600')} 
                      style={{ width: '100%', borderRadius: '8px', marginBottom: '8px', display: 'block' }} 
                      alt="미리보기 사진"
                    />
                  ))}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', borderTop: '1px solid #eee' }}>
                <button 
                  style={{ flex: 1, padding: '15px', border: 'none', background: '#fff', cursor: 'pointer' }} 
                  onClick={() => setShowPreviewModal(false)}
                >
                  취소
                </button>
                
                <button 
                  style={{ 
                    flex: 1, 
                    padding: '15px', 
                    border: 'none', 
                    background: '#3182ce', 
                    color: '#fff', 
                    fontWeight: 'bold', 
                    cursor: 'pointer' 
                  }} 
                  onClick={handleSaveSnapshotAndSend} // 📍 통합된 전송 함수 연결
                  disabled={smsLoading}
                >
                  {smsLoading ? "발송 중..." : "확인 및 발송"}
                </button>
            </div>
          </div>
        </div>
      )}

      {/* 🕒 스냅샷 상세 보기 및 복구 모달 */}
      {selectedSnapshot && (
        <div className="snapshot-preview-overlay" style={{ position: 'fixed', inset: 0, zIndex: 4000, background: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: '450px', maxHeight: '80vh', background: '#fff', borderRadius: '12px', padding: '20px', overflowY: 'auto', boxShadow: '0 20px 40px rgba(0,0,0,0.4)' }}>
            <h3 style={{ borderBottom: '2px solid #2b6cb0', paddingBottom: '10px', marginTop: 0 }}>🕒 스냅샷 데이터 확인</h3>
            <div style={{ fontSize: '11px', background: '#f1f5f9', padding: '10px', borderRadius: '6px', marginTop: '10px', overflowX: 'auto' }}>
              <pre style={{ margin: 0 }}>{JSON.stringify(selectedSnapshot, null, 2)}</pre>
            </div>
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
              <button 
                onClick={() => {
                  if(window.confirm("정말로 이 시점의 데이터로 현재 화면을 복구하시겠습니까?\n(하단의 저장 버튼을 눌러야 실제 DB에 반영됩니다)")) {
                    // 1. 기본/상세 정보 복구
                    if (selectedSnapshot.basic) setBasic({ ...selectedSnapshot.basic });
                    if (selectedSnapshot.detail) setDetail({ ...selectedSnapshot.detail });

                    // 2. 📍 메타 정보 및 연락처 배열 복구
                    if (selectedSnapshot.meta) {
                      const smm = selectedSnapshot.meta;
                      
                      // 어떤 타입이 들어오든 배열로 뱉어주는 헬퍼
                      const safeArray = (data) => {
                        if (Array.isArray(data)) return data;
                        if (typeof data === 'string' && data.startsWith('[')) {
                          try { return JSON.parse(data); } catch(e) { return []; }
                        }
                        return [];
                      };

                      setForm(prev => ({
                        ...prev,
                        ...smm,
                        // 📍 명시적으로 배열 타입을 지정하여 owners/tenants 주입
                        owners: safeArray(smm.owners),
                        tenants: safeArray(smm.tenants)
                      }));
                    }
                    setSelectedSnapshot(null);
                    alert("데이터가 화면에 로드되었습니다. 확인 후 저장해주세요.");
                  }
                }}
                style={{ flex: 1, padding: '12px', background: '#e53e3e', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
              >
                이 데이터로 복구하기
              </button>
              <button 
                onClick={() => setSelectedSnapshot(null)}
                style={{ flex: 1, padding: '12px', background: '#edf2f7', border: '1px solid #cbd5e0', borderRadius: '6px', cursor: 'pointer' }}
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

{showBlogModal && blogPreviewData && (
  <div className="preview-overlay" style={{ position: 'fixed', inset: 0, zIndex: 4000, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <div style={{ 
      width: '80%', 
      maxWidth: '1200px', 
      height: '90vh', 
      background: '#fff', 
      borderRadius: '20px', 
      display: 'flex', 
      flexDirection: 'column', 
      overflow: 'hidden', 
      boxShadow: '0 20px 50px rgba(0,0,0,0.5)' 
    }}>
      
      <div style={{ background: '#00c73c', color: '#fff', padding: '20px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
        네이버 블로그 포스팅용 콘텐츠 (전체 복사 후 붙여넣기 하세요)
      </div>
      
<div id="blog-copy-area" style={{ flex: 1, overflowY: "auto", padding: "30px" }}>
  {/* 카카오 이미지 지도 */}
  <div id="blog-static-map-container" style={{ width: "100%", height: "350px", background: "#eee", marginBottom: "25px" }}></div>

  {/* AI 생성 콘텐츠 영역 */}
    <div style={{ 
      padding: '30px', 
      background: '#f0fff4', 
      borderRadius: '20px', 
      border: '1px solid #c6f6d5',
      marginBottom: '40px',
      fontSize: '18px',
      lineHeight: '1.8',
      color: '#2d3748'
    }}>
      {/* BLOG_PHOTO_V1 — 1번 사진은 제목 위 대표 이미지로 크게 */}
      {(blogPreviewData.photos || []).length > 0 &&
        blogPhoto(blogPreviewData.photos[0], "cover", true)}

      {/* 나머지 사진은 본문 안에 분배된다 */}
      {renderBlogContent(blogPreviewData.aiContent,
                         (blogPreviewData.photos || []).slice(1))}
    </div>

  <div style={{ maxWidth: "800px", margin: "0 auto" }}>
    {/* BLOG_SUMMARY_V1 — 하단 요약 카드
        백엔드가 본문과 같은 계산으로 만든 값이라 본문과 어긋나지 않는다 */}
    {blogPreviewData.summary && (
      <div style={{ border: "1px solid #cbd5e0", borderRadius: "12px",
                    padding: "24px", margin: "30px 0", background: "#fafafa" }}>
        {blogPreviewData.summary.title && (
          <div style={{ fontSize: "20px", fontWeight: "bold",
                        color: "#1a202c", marginBottom: "4px" }}>
            🏠 {blogPreviewData.summary.title}
          </div>
        )}
        {blogPreviewData.summary.address && (
          <div style={{ fontSize: "15px", color: "#718096", marginBottom: "18px" }}>
            {blogPreviewData.summary.address}
          </div>
        )}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {blogPreviewData.summary.rows.map((r, i) => (
              <tr key={i}>
                <td style={{ padding: "7px 12px 7px 0", verticalAlign: "top",
                             color: "#4a5568", fontWeight: "bold",
                             fontSize: "15px", whiteSpace: "nowrap", width: "90px" }}>
                  {r.label}
                </td>
                <td style={{ padding: "7px 0", color: "#2d3748",
                             fontSize: "16px", lineHeight: "1.6" }}>
                  {r.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {blogPreviewData.summary.note && (
          <div style={{ fontSize: "13px", color: "#718096",
                        marginTop: "16px", paddingTop: "14px",
                        borderTop: "1px dashed #cbd5e0" }}>
            ※ {blogPreviewData.summary.note}
          </div>
        )}
      </div>
    )}

    {/* BLOG_PHOTO_V1 — 사진은 본문 안으로 분배되어 여기서는 출력하지 않는다 */}
  </div>
</div>

      <div style={{ display: 'flex', padding: '20px', background: '#f1f5f9', gap: '15px' }}>
        <button onClick={() => setShowBlogModal(false)} style={{ flex: 1, padding: '15px', borderRadius: '10px', border: '1px solid #ccc', background: '#fff', cursor: 'pointer', fontSize: '16px' }}>닫기</button>
        <button 
          onClick={() => {
            const range = document.createRange();
            range.selectNode(document.getElementById("blog-copy-area"));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            document.execCommand('copy');
            alert("블로그용 콘텐츠가 복사되었습니다! 네이버 블로그 스마트에디터에 붙여넣기(Ctrl+V) 하세요.");
          }}
          style={{ flex: 2, padding: '15px', borderRadius: '10px', border: 'none', background: '#00c73c', color: '#fff', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}
        >
          블로그용 전체 복사하기
        </button>
        {/* THUMB_UI_V1 — 네이버 대표이미지(썸네일) 만들기 */}
        <button
          onClick={openThumbModal}
          style={{ flex: 1, padding: '15px', borderRadius: '10px', border: 'none',
                   background: '#4c51bf', color: '#fff', fontWeight: 'bold',
                   cursor: 'pointer', fontSize: '16px' }}
        >
          대표이미지 만들기
        </button>
      </div>
    </div>
  </div>
)}

{/* ===== THUMB_UI_V1 : 대표이미지(썸네일) 만들기 화면 ===== */}
{showThumbModal && (
  <div style={{ position: 'fixed', inset: 0, zIndex: 4500,
                background: 'rgba(0,0,0,0.85)', display: 'flex',
                justifyContent: 'center', alignItems: 'center' }}>
    <div style={{ width: '92%', maxWidth: '1000px', maxHeight: '92vh',
                  background: '#fff', borderRadius: '16px',
                  display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      <div style={{ background: '#4c51bf', color: '#fff', padding: '18px',
                    textAlign: 'center', fontWeight: 'bold', fontSize: '18px' }}>
        네이버 대표이미지 만들기
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '24px',
                    display: 'grid', gridTemplateColumns: '1fr 340px', gap: '24px' }}>

        {/* ── 왼쪽: 입력 ── */}
        <div>
          <label style={{ display: 'block', fontWeight: 'bold',
                          marginBottom: '8px', fontSize: '15px' }}>
            제목 <span style={{ fontWeight: 'normal', color: '#718096', fontSize: '13px' }}>
              (Enter로 줄바꿈, 최대 4줄 · 한 줄 9자 내외가 보기 좋습니다)
            </span>
          </label>
          <textarea
            value={thumbTitle}
            onChange={(e) => setThumbTitle(e.target.value)}
            rows={4}
            style={{ width: '100%', padding: '12px', fontSize: '17px',
                     border: '1px solid #cbd5e0', borderRadius: '8px',
                     lineHeight: '1.6', resize: 'vertical', boxSizing: 'border-box' }}
            placeholder={"예)\n남현동 삼원하이츠\n조용한 주택가 원룸"}
          />

          <label style={{ display: 'block', fontWeight: 'bold',
                          margin: '22px 0 8px', fontSize: '15px' }}>
            배경 사진
          </label>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '8px', marginBottom: '12px' }}>
            {(blogPreviewData?.photos || []).map((u, i) => (
              <img key={i} src={u} referrerPolicy="no-referrer"
                   onClick={() => { setThumbBgUrl(u); setThumbBgB64(""); }}
                   style={{ width: '100%', height: '78px', objectFit: 'cover',
                            borderRadius: '6px', cursor: 'pointer',
                            border: thumbBgUrl === u ? '3px solid #4c51bf' : '3px solid transparent',
                            opacity: thumbBgUrl === u ? 1 : 0.72 }} />
            ))}
          </div>

          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <label style={{ padding: '9px 14px', border: '1px solid #cbd5e0',
                            borderRadius: '8px', cursor: 'pointer', fontSize: '14px',
                            background: thumbBgB64 ? '#ebf4ff' : '#fff' }}>
              직접 업로드
              <input type="file" accept="image/*" onChange={onThumbFilePick}
                     style={{ display: 'none' }} />
            </label>
            <button
              onClick={() => { setThumbBgUrl(""); setThumbBgB64(""); }}
              style={{ padding: '9px 14px', border: '1px solid #cbd5e0',
                       borderRadius: '8px', cursor: 'pointer', fontSize: '14px',
                       background: (!thumbBgUrl && !thumbBgB64) ? '#ebf4ff' : '#fff' }}>
              배경 없음 (단색)
            </button>
          </div>

          <button
            onClick={generateThumb}
            disabled={thumbLoading}
            style={{ marginTop: '22px', width: '100%', padding: '14px',
                     borderRadius: '10px', border: 'none', background: '#4c51bf',
                     color: '#fff', fontWeight: 'bold', fontSize: '16px',
                     cursor: thumbLoading ? 'wait' : 'pointer',
                     opacity: thumbLoading ? 0.6 : 1 }}>
            {thumbLoading ? "만드는 중..." : "이미지 만들기"}
          </button>
        </div>

        {/* ── 오른쪽: 미리보기 ── */}
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '15px' }}>
            미리보기
          </div>
          <div style={{ width: '100%', aspectRatio: '1 / 1', background: '#edf2f7',
                        borderRadius: '10px', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', overflow: 'hidden' }}>
            {thumbResult?.image
              ? <img src={thumbResult.image} style={{ width: '100%', display: 'block' }} />
              : <span style={{ color: '#a0aec0', fontSize: '14px' }}>
                  [이미지 만들기]를 누르세요
                </span>}
          </div>

          {thumbResult && (
            <>
              <div style={{ fontSize: '13px', color: '#718096', margin: '10px 0' }}>
                저장될 이름: {thumbResult.fileName}
              </div>
              <button
                onClick={downloadThumb}
                style={{ width: '100%', padding: '13px', borderRadius: '10px',
                         border: 'none', background: '#2f855a', color: '#fff',
                         fontWeight: 'bold', fontSize: '15px', cursor: 'pointer' }}>
                PNG 다운로드
              </button>
              <div style={{ fontSize: '12px', color: '#718096', marginTop: '10px',
                            lineHeight: '1.6' }}>
                내려받은 이미지를 네이버 블로그 글의 <b>첫 번째 이미지</b>로 올리면
                목록에서 대표이미지로 표시됩니다.
              </div>
            </>
          )}
        </div>
      </div>

      <div style={{ padding: '16px 24px', background: '#f1f5f9' }}>
        <button onClick={() => setShowThumbModal(false)}
                style={{ width: '100%', padding: '13px', borderRadius: '10px',
                         border: '1px solid #cbd5e0', background: '#fff',
                         cursor: 'pointer', fontSize: '15px' }}>
          닫기
        </button>
      </div>
    </div>
  </div>
)}


      {/* ⚠️ 최종 저장 확인 모달 (변경사항 하이라이트) */}
      {showSaveConfirm && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: '500px', maxHeight: '80vh', background: '#fff', borderRadius: '15px', padding: '25px', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}>
            <h3 style={{ marginTop: 0, color: '#2b6cb0', borderBottom: '2px solid #edf2f7', paddingBottom: '15px' }}>
              {mode === "copy" ? "복사 전 변경사항 확인" : "저장 전 변경사항 확인"}
            </h3>
            
            <div style={{ flex: 1, overflowY: 'auto', margin: '15px 0', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead style={{ background: '#f8fafc', position: 'sticky', top: 0 }}>
                  <tr>
                    <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', textAlign: 'left' }}>항목</th>
                    <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', textAlign: 'left' }}>이전</th>
                    <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', textAlign: 'left' }}>이후</th>
                  </tr>
                </thead>
                <tbody>
                  {diffList.length > 0 ? diffList.map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: '10px', borderBottom: '1px dotted #e2e8f0', fontWeight: 'bold', color: '#4a5568' }}>{item.label}</td>
                      <td style={{ padding: '10px', borderBottom: '1px dotted #e2e8f0', color: '#a0aec0', textDecoration: 'line-through' }}>{item.from}</td>
                      <td style={{ padding: '10px', borderBottom: '1px dotted #e2e8f0', color: '#e53e3e', fontWeight: 'bold' }}>{item.to}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="3" style={{ padding: '30px', textAlign: 'center', color: '#999' }}>변경된 내용이 없습니다.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <p style={{ fontSize: '14px', textAlign: 'center', color: '#2d3748', marginBottom: '20px' }}>
               위 <strong>{diffList.length}건</strong>의 변경사항을 반영하여 {mode === "copy" ? "복사본을 생성" : "저장"}할까요?
            </p>
            {/* [MODDATE_HOLD_V1] 수정일 격리 체크박스 — 일반 수정에서만 표시. 체크 시 수정일·수정자 유지 */}
            {mode === "edit" && (
              <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '-8px', marginBottom: '16px', fontSize: '13px', color: keepModDate ? '#c05621' : '#4a5568', cursor: 'pointer' }}>
                <input type="checkbox" checked={keepModDate} onChange={(ev) => setKeepModDate(ev.target.checked)} />
                <span>수정일 갱신 안 함</span>
                <span style={{ color: '#a0aec0' }}>(오타·단순 정리 — 수정일·수정자 유지)</span>
              </label>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" onClick={() => setShowSaveConfirm(false)} style={{ flex: 1, padding: '15px', background: '#fff', border: '1px solid #cbd5e0', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>취소 및 수정</button>
              <button type="button" onClick={executeFinalSave} style={{ flex: 2, padding: '15px', background: '#2b6cb0', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}>확인 및 저장 실행</button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

// ===== DEV ONLY: FIELD_DEFS → BACKEND MAP DUMP =====
if (process.env.NODE_ENV === "development") {
  const backendMap = {
    basic: [],
    detail: [],
    meta: [],
  };

  Object.entries(FIELD_DEFS).forEach(([key, def]) => {
    if (def.state === "basic") backendMap.basic.push(key);
    if (def.state === "detail") backendMap.detail.push(key);
    if (def.state === "form") backendMap.meta.push(key);
  });

  console.log("=== FIELD_DEFS BACKEND MAP ===");
  console.log(JSON.stringify(backendMap, null, 2));
}
